// Page-specific strings, namespaced as 'pages.<pageName>.<key>'.
export default {
  'pages.chat.promptLibrary.purposeRequired': '이 프롬프트의 목적을 입력하세요.',
  'pages.chat.promptLibrary.metadataUnavailable':
    '일부 프롬프트 옵션을 사용할 수 없습니다. 저장하려면 업무 분야를 하나 이상 선택해야 합니다.',
  'pages.chat.promptLibrary.retryOptions': '다시 시도',
  'pages.chat.promptLibrary.tags': '태그',
  'pages.chat.promptLibrary.tagsRequired': '태그를 하나 이상 추가하세요.',
  'pages.chat.promptLibrary.tagsPlaceholder': '태그 선택 또는 만들기',
  'pages.chat.promptLibrary.practiceAreas': '업무 분야',
  'pages.chat.promptLibrary.practiceAreasRequired': '업무 분야를 하나 이상 선택하세요.',
  'pages.chat.promptLibrary.practiceAreasPlaceholder': '업무 분야 선택',
  'pages.chat.promptLibrary.exampleTemplate':
    '작업: [이 프롬프트가 수행할 작업을 설명하세요.]\n\n입력: [제공할 문서나 정보를 지정하세요.]\n\n요구 사항: [구조, 어조, 제약 조건 및 세부 수준을 설명하세요.]\n\n다음을 원하는 출력의 예시로 사용하세요. 예시의 사실을 반복하지 말고 새로운 입력에 맞게 조정하세요:\n\n',
  'pages.chat.promptLibrary.discardTitle': '이 프롬프트 초안을 삭제할까요?',
  'pages.chat.promptLibrary.discardDescription':
    '수정 내용이 아직 라이브러리에 저장되지 않았습니다.',
  'pages.chat.promptLibrary.discard': '삭제',
  'pages.chat.promptLibrary.keepEditing': '계속 편집',
  'pages.chat.promptLibrary.saved': '프롬프트를 개인 라이브러리에 저장했습니다.',
  'pages.chat.promptLibrary.viewLibrary': '라이브러리 보기',
  'pages.chat.promptLibrary.saveFailed':
    '프롬프트를 저장하지 못했습니다. 초안은 유지되어 있습니다. 다시 시도하세요.',
  'pages.chat.promptLibrary.create': '재사용 가능한 프롬프트 만들기',
  'pages.chat.promptLibrary.cancel': '취소',
  'pages.chat.promptLibrary.save': '내 라이브러리에 저장',
  'pages.chat.promptLibrary.reviewTitle': '새 대화에서도 유용하게 사용할 수 있도록 작성하세요',
  'pages.chat.promptLibrary.reviewDescription':
    '재사용 가능한 지침을 유지하거나 유용한 답변을 예시로 사용하세요. 이름과 사건별 사실은 [계약서] 같은 자리 표시자로 바꾸세요. “위 내용” 같은 참조를 명확하게 작성하세요. 채팅 기록과 첨부 파일은 포함되지 않습니다.',
  'pages.chat.promptLibrary.original': '원본 채팅 텍스트',
  'pages.chat.promptLibrary.keepWording': '선택한 문구 유지',
  'pages.chat.promptLibrary.useExample': '출력 예시로 사용',
  'pages.chat.promptLibrary.exampleHelp':
    '비슷한 결과를 얻는 방법을 설명하도록 아래에 작업, 입력 및 요구 사항을 작성하세요.',
  'pages.chat.promptLibrary.name': '이름',
  'pages.chat.promptLibrary.nameRequired': '이 프롬프트의 이름을 입력하세요.',
  'pages.chat.promptLibrary.purpose': '목적',
  'pages.chat.promptLibrary.content': '프롬프트',
  'pages.chat.promptLibrary.contentRequired': '저장할 지침을 입력하세요.',
  'pages.adminManagement.groupName': '그룹 이름',
  'pages.adminManagement.personalTag': '개인',
  'pages.adminManagement.owner': '소유자',
  'pages.adminManagement.deletedUserTag': '삭제된 사용자',
  'pages.adminManagement.members': '구성원',
  'pages.adminManagement.options': '옵션',
  'pages.adminManagement.manageGroupTooltip': '그룹 관리',
  'pages.adminManagement.manageFilesTooltip': '파일 관리',
  'pages.adminManagement.removeGroupTooltip': '그룹 삭제',
  'pages.adminManagement.stats.totalUsers': '전체 사용자',
  'pages.adminManagement.stats.totalGroups': '전체 그룹',
  'pages.adminManagement.stats.personalGroups': '개인 그룹',
  'pages.adminManagement.stats.sharedGroups': '공유 그룹',
  'pages.adminManagement.stats.totalFiles': '전체 파일',
  'pages.adminManagement.stats.totalFolders': '전체 폴더',
  'pages.adminManagement.sharedTag': '공유됨',
  'pages.adminManagement.moveAll': '전체 이동',
  'pages.adminManagement.fileDescription': '{username} · {action} {date}',
  'pages.adminManagement.fileAction.uploaded': '업로드됨',
  'pages.adminManagement.fileAction.created': '생성됨',
  'pages.adminManagement.createGroupButton': '그룹 만들기',
  'pages.adminManagement.modifyUserGroupTitle': '사용자 그룹 수정',
  'pages.adminManagement.createUserGroupTitle': '사용자 그룹 만들기',
  'pages.adminManagement.updateSubmitText': '업데이트',
  'pages.adminManagement.userGroupUpdatedSuccess': '사용자 그룹이 성공적으로 업데이트되었습니다',
  'pages.adminManagement.userGroupCreatedSuccess': '사용자 그룹이 성공적으로 생성되었습니다',
  'pages.adminManagement.groupNameRequiredMessage': '그룹 이름을 입력해 주세요',
  'pages.adminManagement.ownerRequiredMessage': '그룹 소유자를 선택해 주세요',
  'pages.adminManagement.membersRequiredMessage': '그룹 구성원을 선택해 주세요',
  'pages.adminManagement.moveFolderTitle': '폴더 이동',
  'pages.adminManagement.moveFileTitle': '파일 이동',
  'pages.adminManagement.allMovedSuccess': '모두 성공적으로 이동되었습니다',
  'pages.adminManagement.folderMovedSuccess': '폴더가 성공적으로 이동되었습니다',
  'pages.adminManagement.fileMovedSuccess': '파일이 성공적으로 이동되었습니다',
  'pages.adminManagement.destinationGroupLabel': '대상 그룹',
  'pages.adminManagement.destinationGroupRequiredMessage': '대상 그룹을 선택해 주세요',
  'pages.adminManagement.destinationFolderPlaceholder': '대상 폴더 선택',
  'pages.adminManagement.renameOptionalLabel': '이름 변경(선택 사항)',
  'pages.adminManagement.loadFolderDataError': '폴더 데이터를 불러오지 못했습니다',
  'pages.adminManagement.ownerCannotBeRemovedWarning':
    '그룹 소유자는 구성원에서 제외할 수 없습니다',
  'pages.aISetting.promptCopied': '프롬프트가 복사되었습니다!',
  'pages.aISetting.failedToCopyPrompt': '프롬프트 복사에 실패했습니다',
  'pages.aISetting.updatedByMeta': '{user}님이 {date}에 업데이트함',
  'pages.aISetting.updateButton': '업데이트',
  'pages.aISetting.systemPromptLabel': '시스템 프롬프트',
  'pages.aISetting.additionalPromptLabel': '추가 프롬프트',
  'pages.aISetting.temperatureLabel': '온도',
  'pages.aISetting.updatedBadge': '업데이트됨!!',
  'pages.aISetting.requiredParamsMissing': '필수 매개변수가 누락되었습니다: {params}',
  'pages.angelInsider.micrositeFrameTitle': 'A&GEL Insider',
  'pages.angelInsider.nav.basics': '기본',
  'pages.angelInsider.nav.learnMore': '더 알아보기',
  'pages.angelInsider.nav.whatsNew': '새로운 소식',
  'pages.angelInsider.nav.futureStuff': '다가올 기능',
  'pages.angelInsider.nav.logoAlt': 'A&GEL Insider',
  'pages.angelInsider.landing.tiles.basics.title': '기본',
  'pages.angelInsider.landing.tiles.basics.subtitle':
    '여기서부터 시작하세요. 첫날부터 필요한 모든 것.',
  'pages.angelInsider.landing.tiles.learnMore.title': '더 알아보기',
  'pages.angelInsider.landing.tiles.learnMore.subtitle':
    '한 단계 더 나아가고 싶은 분들을 위한 고급 기능.',
  'pages.angelInsider.landing.tiles.whatsNew.title': '새로운 소식',
  'pages.angelInsider.landing.tiles.whatsNew.subtitle': '최근에 출시된 기능과 업데이트.',
  'pages.angelInsider.landing.tiles.comingUp.title': '다가올 기능',
  'pages.angelInsider.landing.tiles.comingUp.subtitle': '팀이 다음으로 준비 중인 것.',
  'pages.angelInsider.landing.pills.all': '전체',
  'pages.angelInsider.landing.pills.chatAndContext': '채팅 & 컨텍스트',
  'pages.angelInsider.landing.pills.filesAndVault': '파일 & 보관함',
  'pages.angelInsider.landing.pills.promptLibrary': '프롬프트 라이브러리',
  'pages.angelInsider.landing.pills.quickInfo': '빠른 정보',
  'pages.angelInsider.landing.pills.scribe': '스크라이브',
  'pages.angelInsider.landing.pills.disputeResolution': '분쟁 해결',
  'pages.angelInsider.landing.pills.sideBySide': '나란히 보기',
  'pages.angelInsider.landing.pills.multiStepPrompt': '다단계 프롬프트',
  'pages.angelInsider.landing.pills.timeline': '타임라인',
  'pages.angelInsider.landing.pills.workstudio': 'Workstudio',
  'pages.angelInsider.landing.pills.deepResearch': '딥 리서치',
  'pages.angelInsider.landing.pills.scopeSummary': '범위 요약',
  'pages.angelInsider.landing.pills.review': '검토',
  'pages.angelInsider.landing.pills.whatsNew': '새로운 소식',
  'pages.angelInsider.landing.pills.futureStuff': '다가올 기능',
  'pages.angelInsider.landing.preferOneFeature': '한 번에 하나씩 기능을 배우고 싶으신가요?',
  'pages.angelInsider.landing.scrollFeatureList': '기능 목록 스크롤',
  'pages.angelInsider.basics.habits.habit1.num': '습관 01',
  'pages.angelInsider.basics.habits.habit1.title': 'A&GEL에 활용할 재료를 제공하세요',
  'pages.angelInsider.basics.habits.habit1.intro':
    '신규 사용자가 가장 흔히 저지르는 실수는, AI 도구가 출발점으로 삼을 충분한 정보를 제공하는 것이 얼마나 중요한지 과소평가하는 것입니다.',
  'pages.angelInsider.basics.habits.habit2.num': '습관 02',
  'pages.angelInsider.basics.habits.habit2.title':
    'LLM을 "텍스트 프로세서"로 활용하고, "지식 엔진"으로 여기지 마세요',
  'pages.angelInsider.basics.habits.habit2.intro':
    '대규모 언어 모델(LLM)이 실제로 무엇인지 이해하는 것이 중요합니다. LLM은 진실을 담은 데이터베이스도, 인간의 판단을 대신하는 것도 아닙니다. 대신 LLM을 언어와 기본적인 인지 작업을 위한 고속 CPU 또는 프로세서라고 생각하세요.',
  'pages.angelInsider.basics.habits.habit3.num': '습관 03',
  'pages.angelInsider.basics.habits.habit3.title': '채팅만 하지 말고 다른 기능도 살펴보세요',
  'pages.angelInsider.basics.heading': '기본',
  'pages.angelInsider.basics.welcome.intro':
    '함께하게 되어 매우 기쁩니다. A&GEL을 둘러보기 시작하시는 지금, 좋은 출발을 위해 몇 가지 말씀을 드리고자 합니다.',
  'pages.angelInsider.basics.welcome.timeHeading':
    '새로운 도구를 익히는 데는 시간이 걸립니다 – 괜찮습니다',
  'pages.angelInsider.basics.welcome.supportParagraph':
    '새로운 기술에 익숙해지는 것이 처음에는 어렵게 느껴질 수 있다는 점을 잘 알고 있습니다. 저희는 모든 과정에서 여러분을 지원하기 위해 이 자리에 있다는 것을 기억해 주세요. 궁금한 점이 있거나 막히는 부분이 있을 때, 혹은 단순히 도움을 받고 싶으실 때에도 언제든지 편하게 문의해 주시기 바랍니다.',
  'pages.angelInsider.basics.welcome.differentParagraph':
    'A&GEL과 같은 AI 도구는 이전의 도구들과 <strong>다릅니다</strong> — <strong>사용자 여러분을 직접</strong> 지원합니다. 손끝에서 활용할 수 있는 수많은 조력자를 두고 있다고 생각해 보세요. 인간의 판단을 대신할 수는 없지만, 여러 면에서 혼자서는 불가능했던 수준까지 여러분의 역량을 크게 확장해 줍니다.',
  'pages.angelInsider.basics.welcome.bestWayParagraph':
    '<strong>A&GEL을 배우는 가장 좋은 방법은 직접 사용해 보는 것입니다 —</strong> 자유롭게 탐색해 보시기를 권해 드립니다. 이것저것 시도해 보고, (안전한 범위 안에서) 실수도 해 보면서 자신에게 가장 잘 맞는 방법을 찾아보세요.',
  'pages.angelInsider.basics.welcome.pacingHeading': '본인의 속도에 맞춰 나아가세요',
  'pages.angelInsider.basics.welcome.staircaseParagraph':
    '역량을 키우는 것은 계단을 오르는 것과 같다고 생각해 보세요. 기본부터 시작해서 자신감이 붙을수록 다음 단계로 넘어가는 것이 훨씬 자연스럽게 느껴질 것입니다. 서두를 필요는 없습니다 — 이것은 경주가 아닙니다. 탄탄한 기초를 다지는 데 필요한 시간을 충분히 가지세요.',
  'pages.angelInsider.basics.welcome.togetherHeading': '함께라면 더 멀리 갈 수 있습니다',
  'pages.angelInsider.basics.welcome.togetherParagraph':
    '팀과 회사가 A&GEL을 함께 받아들일 때, 그 혜택은 모두에게 배가됩니다. 사용자 커뮤니티 전반에서 지식을 공유하고 협력하면 모두를 끌어올리는 파급 효과가 생겨납니다.',
  'pages.angelInsider.basics.welcome.welcomeAboardParagraph':
    '함께하게 된 것을 환영합니다 — A&GEL과 함께 무엇을 이룰 수 있을지 기대됩니다.',
  'pages.angelInsider.basics.welcome.signatureName': 'Kok Leong',
  'pages.angelInsider.basics.welcome.signatureTeam': 'A&GEL 개발팀',
  'pages.angelInsider.basics.welcome.ctaLetsBegin': '시작해 볼까요 →',
  'pages.angelInsider.basics.habitsSection.title': '여정을 안내할 단 3가지 습관',
  'pages.angelInsider.basics.habitsSection.intro':
    'A&GEL을 시작하는 것은 채팅창에 질문을 입력하고 엔터를 누르는 것 그 이상의 의미가 있습니다. A&GEL과 같은 AI 도구의 힘을 제대로 활용하려면 AI와 상호작용하는 방식에 대한 사고방식을 바꿔야 합니다.',
  'pages.angelInsider.basics.habitsSection.lockHint':
    '패널을 클릭하면 더 넓은 화면으로 고정됩니다. 다시 클릭하면 잠금이 해제됩니다.',
  'pages.angelInsider.reader.back': '← 뒤로',
  'pages.angelInsider.reader.label': 'A&GEL INSIDER',
  'pages.angelInsider.reader.contents': '목차',
  'pages.angelInsider.reader.issueNumber': '제{number}호',
  'pages.angelInsider.reader.featureGuide': '기능 가이드',
  'pages.angelInsider.reader.minRead': '{minutes}분 읽기',
  'pages.angelInsider.reader.atAGlance': '한눈에 보기',
  'pages.angelInsider.blockRenderer.supportedAlt': '지원됨',
  'pages.angelInsider.typewriterExample.badLabel': '이것도 괜찮습니다:',
  'pages.angelInsider.typewriterExample.goodLabel': '하지만 이게 더 좋습니다:',
  'pages.angelInsider.basics.habits.labels.takeaways': '핵심 정리',
  'pages.angelInsider.basics.habits.labels.examples': '예시',
  'pages.angelInsider.basics.habits.labels.benefits': '이점',
  'pages.angelInsider.basics.habits.habit1.tile.patternMatchers':
    'A&GEL 같은 AI 도구는 마음을 읽지 못합니다. 이들은 <strong>패턴을 맞추는 존재</strong>입니다. 두루뭉술하게 물으면 두루뭉술한 답이 돌아오고, 풍부하고 구체적인 컨텍스트를 주면 정확하고 곧바로 쓸 수 있는 결과를 얻을 가능성이 훨씬 커집니다.',
  'pages.angelInsider.basics.habits.habit1.tile.callItContext':
    '이 출발점을 <strong>“컨텍스트”</strong>라고 부르기로 합시다.',
  'pages.angelInsider.basics.habits.habit1.tile.rawMaterial':
    '컨텍스트란 A&GEL이 다룰 원재료라고 생각하세요. 법률 메모를 쓸 때 그저 “이 사건을 요약해 줘”라고만 하지 마세요. 판결문을 업로드하고, 신경 쓰이는 핵심 사실관계나 법적 쟁점을 짚어 주고, 누구를 위한 글인지 알려 주세요(요약용으로 저희가 만들어 둔 프롬프트를 프롬프트 라이브러리에서 가져다 써도 됩니다). 원칙적으로 컨텍스트를 많이 줄수록 A&GEL은 더 잘합니다.',
  'pages.angelInsider.basics.habits.habit1.tile.promptLibraryLink':
    '프롬프트 라이브러리 더 알아보기',
  'pages.angelInsider.basics.habits.habit1.tile.empowerYou':
    'A&GEL 같은 AI 도구는 <em>여러분</em>에게 직접 힘을 실어 줍니다. 역량을 키워 주지만, 방향은 여러분이 잡아 주어야 합니다. 컨텍스트가 없으면 AI는 사건 브리핑을 받지 못한 명석한 변호사, 혹은 일을 해내는 데 필요한 배경 정보가 없는 유능한 동료와 같습니다.',
  'pages.angelInsider.basics.habits.habit1.tile.vault.title':
    '보관함은 A&GEL 위에 올려둔 여러분의 두뇌입니다',
  'pages.angelInsider.basics.habits.habit1.tile.vault.body':
    '보관함은 A&GEL의 주된 컨텍스트 원천으로, 결과물을 여러분이 신뢰하고 선별해 둔 지식 기반에 단단히 묶어 둡니다. A&GEL은 인터넷을 검색하지 않습니다 – 오직 여러분이 올린 것 안에서만 작동하죠. 지치지 않는 동료라고 생각해 보세요. 관련 없는 서류가 잔뜩 쌓인 어수선한 책상을 건네면 결과물이 나빠지고, 딱 맞는 선례 하나를 건네면 결과물이 날카로워집니다. 파일을 논리적인 하위 폴더로 정리하고, 무엇을 올릴지 선별하며, 참조 파일 가중치와 세션 파일 가중치로 A&GEL이 무엇을 우선할지 미세 조정하세요. 보관함을 쓰레기 매립장이 아니라 잘 큐레이션된 서재처럼 다루세요.',
  'pages.angelInsider.basics.habits.habit1.tile.vault.link': '보관함 더 알아보기',
  'pages.angelInsider.basics.habits.habit1.tile.documents.title':
    '프롬프트를 넣기 전에 A&GEL에 특정 문서를 건네기',
  'pages.angelInsider.basics.habits.habit1.tile.documents.body':
    '파일을 채팅에 끌어다 놓거나 파일을 골라 대화하면, 그 문서의 내용만 A&GEL의 단기 기억에 올려 두는 셈입니다. 저희 워크숍에 오셨던 분이라면 그 파일을 두고 ‘어젯밤에 막 정주행한 드라마 한 편’(<em>오늘은 그 얘기만 하고 싶은</em>)이라고 비유하는 걸 들으셨을 겁니다. 이렇게 하면 A&GEL이 시야를 좁히게 되는데, 이를 잘 활용하면 정확한 결과를 끌어낼 수 있습니다.',
  'pages.angelInsider.basics.habits.habit1.tile.documents.link': '컨텍스트 더 알아보기',
  'pages.angelInsider.basics.habits.habit1.tile.colleague.title':
    'A&GEL과 일하는 것은 동료와 일하는 것과 크게 다르지 않습니다',
  'pages.angelInsider.basics.habits.habit1.tile.colleague.body':
    '팀원이 일을 진행할 수 있도록 정보를 건네듯이, A&GEL에게도 마찬가지입니다.',
  'pages.angelInsider.basics.habits.habit1.tile.query.title':
    '그럼 프롬프트 안의 질문이나 지시 자체는요? 그것도 ‘A&GEL에 무언가를 준 것’에 해당하나요?',
  'pages.angelInsider.basics.habits.habit1.tile.query.body':
    '그렇습니다. A&GEL 같은 AI 도구에게 프롬프트는 그저 일련의 단어로 받아들여지고 처리됩니다. 즉 프롬프트 전체가 그 AI 도구, 곧 A&GEL에게는 ‘컨텍스트’인 셈이죠. 프롬프트로 질문을 던지고 있다면, 더 나은 질문을 하세요. 그러면 더 나은 답을 얻습니다.',
  'pages.angelInsider.basics.habits.habit1.tile.query.link': '프롬프트 작성 더 알아보기',
  'pages.angelInsider.basics.habits.habit1.tile.benefitsIntro':
    'A&GEL에 풍부한 컨텍스트를 주면 이런 것을 얻습니다:',
  'pages.angelInsider.basics.habits.habit1.tile.benefit1':
    '<strong>더 나은 결과물:</strong> 구체적인 컨텍스트는 구체적인 결과를 낳습니다 — 충분히 브리핑받은 A&GEL은 사건의 사실관계를 이미 아는 동료처럼 움직이지, 맨땅에서 시작하는 사람처럼 굴지 않습니다.',
  'pages.angelInsider.basics.habits.habit1.tile.benefit2':
    '<strong>더 적은 반복:</strong> 출발점이 정확할수록 다시 프롬프트를 넣거나 고치는 데 드는 시간이 줄어듭니다. 사슬의 앞쪽에서 제대로 잡으세요.',
  'pages.angelInsider.basics.habits.habit1.tile.benefit3':
    '<strong>(좋은 의미의) 좁은 시야:</strong> 프롬프트를 넣기 전에 특정 문서를 올려 두면 A&GEL의 초점이 그 안에 고정됩니다 — 그 컨텍스트 안에서만 작동하므로 정확도가 높아지고 결과의 잡음이 줄어듭니다.',
  'pages.angelInsider.basics.habits.habit1.examples.oneOff.bad':
    'A&GEL과의 대화를 매번 일회성으로 여겨, 늘 맨바닥에서 시작하기',
  'pages.angelInsider.basics.habits.habit1.examples.oneOff.good':
    '팀에 새로 합류한 동료를 대하듯 A&GEL을 끌어들이세요 — 사건과 당사자, 그리고 무엇을 이루려 하는지 짧게 브리핑한 뒤 일을 맡기는 겁니다.',
  'pages.angelInsider.basics.habits.habit1.examples.clause.bad':
    'A&GEL에게 “이 조항을 검토해 줘”라고 하기',
  'pages.angelInsider.basics.habits.habit1.examples.clause.good':
    '“[고객]을 위해, […] 목적으로 이 조항을 검토해 줘”라고 하면서 검토 시 무엇을 살펴야 하는지(예: “수수료나 재무 사항과 관련된 문제”) 명시하세요.',
  'pages.angelInsider.basics.habits.habit2.tile.intro':
    'LLM은 정보를 구조화하고, 패턴을 찾아내고, 글을 초안하고, 복잡한 데이터를 정리하는 데 뛰어납니다. 이것은 <em>처리</em>를 위한 도구이지 <em>판단</em>을 위한 도구가 아닙니다. 판단하는 사람도, 전략을 세우는 사람도, 최종 권한을 가진 사람도 여전히 여러분입니다. AI는 표현을 바꾸고 요약하고 조항을 뽑아내는 언어 노동을 맡고, 여러분은 전문성을 발휘해 그 결과를 검증합니다. 이 구분이 결정적입니다: 처리는 AI에 맡기되, 판단만은 결코 넘기지 마세요. 가이드가 일깨우듯, AI 도구는 “인간의 판단을 대신하지는 못하더라도, 여러 면에서 여러분의 역량을 확장해 줍니다”.',
  'pages.angelInsider.basics.habits.habit2.tile.breakItDown.title':
    '쪼개세요 (특히 긴 프롬프트라면)',
  'pages.angelInsider.basics.habits.habit2.tile.breakItDown.body':
    '많은 사용자가 A&GEL을 단순한 챗봇처럼 다루며, 긴 프롬프트 하나를 던져 놓고 잘되기를 바랍니다. A&GEL 같은 AI 도구를 쓰는 가장 좋은 방법은 아닙니다. 능숙한 사용자는 복잡한 과제를 다루기 쉬운 작은 조각으로 나눕니다 — 큰 프롬프트 하나 대신 여러 개의 하위 프롬프트를 쓰는 것이죠. <em>분해</em>라고 불리는 이 기법은 대체로 더 질 높은 결과로 이어집니다.',
  'pages.angelInsider.basics.habits.habit2.tile.breakItDown.imageAlt': '하나의 긴 프롬프트',
  'pages.angelInsider.basics.habits.habit2.tile.oneGoExample':
    '크고 복잡한 여러 갈래의 프롬프트를 한 번에 실행하기. 예: “문서 1과 문서 2에 담긴 내 우려 사항을 모두 담은 보고서를 작성하고, 그 보고서를 요약해 요약문을 만든 다음, 보고서 전문과 요약문을 하나의 문서로 합쳐 줘.”',
  'pages.angelInsider.basics.habits.habit2.tile.breakTaskIntro':
    '과제를 더 작고 순차적인 단계로 나눠, 앱의 다단계 프롬프트로 하나씩 실행하세요.',
  'pages.angelInsider.basics.habits.habit2.tile.step1.title': '1단계: 추출',
  'pages.angelInsider.basics.habits.habit2.tile.step1.context':
    '입력 컨텍스트: [<em>문서 1과 문서 2의 본문을 넣으세요</em>]',
  'pages.angelInsider.basics.habits.habit2.tile.step1.prompt':
    '프롬프트 1: “두 문서에 언급된 모든 우려 사항, 쟁점, 위험을 빠짐없이 개조식 목록으로 만들어라.”',
  'pages.angelInsider.basics.habits.habit2.tile.step2.title': '2단계: 본 보고서 작성',
  'pages.angelInsider.basics.habits.habit2.tile.step2.context':
    '입력 컨텍스트: [<em>1단계의 결과를 넣으세요</em>]',
  'pages.angelInsider.basics.habits.habit2.tile.step2.prompt':
    '프롬프트 2: “그 개조식 목록을 사용해 상세하고 격식 있는 보고서를 작성하라. 비슷한 우려 사항은 알맞은 제목 아래로 묶어라. 머리말이나 요약문은 넣지 마라.”',
  'pages.angelInsider.basics.habits.habit2.tile.step3.title': '3단계: 요약문 & 최종 취합',
  'pages.angelInsider.basics.habits.habit2.tile.step3.context':
    '입력 컨텍스트: [<em>2단계의 결과를 넣으세요</em>]',
  'pages.angelInsider.basics.habits.habit2.tile.step3.prompt':
    '프롬프트 3: “먼저 그 격식 있는 보고서에 대해 한 문단짜리 간결한 요약문을 작성하라. 그런 다음 요약문을 출력하고 시각적 구분선을 넣은 뒤, 그 아래에 보고서 전문을 그대로 출력해 하나로 합쳐진 문서를 만들어라.”',
  'pages.angelInsider.basics.habits.habit2.tile.multiStepLink':
    '다단계 프롬프트의 전체 실전 예시 보기',
  'pages.angelInsider.basics.habits.habit2.tile.reshape.title':
    '기존 텍스트를 다시 짜고, 서식을 바꾸고, 그로부터 추론하는 데 A&GEL을 쓰세요',
  'pages.angelInsider.basics.habits.habit2.tile.reshape.body':
    '참고 자료도 없이 A&GEL에게 복잡한 법률 문서를 맨바닥에서 작성하라고 하기보다는, 참고 자료를 제공한 뒤 (i) A&GEL의 언어 능력을 빌려 여러분의 초안을 어조·구성·서식 면에서 바꾸거나 여러 초안을 하나로 버무리게 하고, (ii) 의도·방향·함의 같은 이차적 특성을 뽑아내게 하세요(예: 여러 문단이나 문서에 걸친 검토 결과 체크리스트 작성).',
  'pages.angelInsider.basics.habits.habit2.tile.benefitsIntro':
    'A&GEL을 텍스트 프로세서로 다루고 과제를 쪼개면 이런 것을 얻습니다:',
  'pages.angelInsider.basics.habits.habit2.tile.benefit1':
    '<strong>더 질 높은 결과물:</strong> 복잡한 과제를 하위 프롬프트로 분해하면 A&GEL이 한 번에 한 가지에만 집중합니다 — 각 단계가 앞 단계 위에 깔끔히 쌓이고, 과부하된 프롬프트 하나의 무게에 무너지지 않습니다.',
  'pages.angelInsider.basics.habits.habit2.tile.benefit2':
    '<strong>더 예측 가능한 결과:</strong> 각 단계를 통제하면 결과도 통제하게 됩니다. 큰 프롬프트 하나가 제대로 맞아떨어지기를 바라는 대신, 앞으로 나아가기 전에 검증할 수 있습니다.',
  'pages.angelInsider.basics.habits.habit2.tile.benefit3':
    '<strong>전문성의 더 나은 활용:</strong> 표현을 바꾸고 구조를 잡고 내용을 뽑아내는 언어 노동은 A&GEL이 맡습니다. 여러분은 검토자이자 전략가의 자리를 지키게 되고, 바로 그곳에서 여러분의 판단이 가장 큰 값을 합니다.',
  'pages.angelInsider.basics.habits.habit2.examples.nda.bad':
    'A&GEL에게 “소프트웨어 프로젝트용 NDA를 작성해 줘”라고 하기',
  'pages.angelInsider.basics.habits.habit2.examples.nda.good':
    '“이것이 우리 표준 NDA 양식이다[붙여넣기]. 비밀유지 기간을 5년으로 바꾸고, 규제 목적의 공개에 대한 예외를 추가하며, 싱가포르법에 대한 모든 언급을 홍콩법으로 바꿔라.”',
  'pages.angelInsider.basics.habits.habit3.tile.intro':
    '단순한 채팅을 넘어선 기능들을 살펴보면 — 문서를 업로드하거나, 특정 앱이나 전문 기능을 쓰거나, 여러 기능을 단계로 엮는 등 — 결과물을 훨씬 세밀하게 통제할 수 있습니다.',
  'pages.angelInsider.basics.habits.habit3.tile.experiment.title': '직접 해 보는 것이 핵심입니다',
  'pages.angelInsider.basics.habits.habit3.tile.experiment.body':
    '다른 기능들도 마음껏 시험하고 살펴보세요. 전문 모드에 있는 기능 상당수는 더 높은 정확성과 꼼꼼함에 맞춰 조율되어 있습니다. 어떤 기능이 여러분의 업무 흐름에 가장 잘 맞는지 찾아보고, 실수를 두려워하지 마세요. 역량을 쌓는 일은 계단을 오르는 것과 같습니다. 기본부터 시작하면, 자신감이 붙을수록 자연스럽게 더 고급 기법으로 넘어가게 됩니다.',
  'pages.angelInsider.basics.habits.habit3.tile.experiment.closing':
    '컨텍스트를 다스리고, AI가 텍스트 프로세서라는 사실과 전문가로서 여러분 자신의 역할을 존중하며, 복잡한 과제를 쪼갤 줄 알게 되면, A&GEL은 신기한 물건에서 일상 업무의 없어서는 안 될 일부로 바뀔 것입니다.',
  'pages.angelInsider.basics.habits.habit3.tile.swissArmy.title':
    'A&GEL은 챗봇이라기보다 스위스 아미 나이프에 가깝습니다',
  'pages.angelInsider.basics.habits.habit3.tile.swissArmy.body':
    '모든 기능을 채팅 창 하나에 밀어 넣는 대신, 복잡함을 정밀하게 갈라내도록 설계된 다재다능한 지식 도구 모음을 앞세운 것은 저희가 처음부터 내린 설계 선택입니다. 채팅은 아이디어를 굴리고 짧게 묻기에는 훌륭하지만, 아주 큰 문서(예: 2만 단어가 넘는 문서)나 복잡한 다단계·다부분 과제 앞에서는 힘에 부칩니다. 저희는 이 강력한 도구들을 채팅 안에 숨기는 대신, 왼쪽 사이드바 맨 앞에 내놓았습니다. 여러분의 구체적인 업무 목표와 알맞은 기능 — 또는 기능의 조합 — 을 잇는 것이 저희의 목표입니다.',
  'pages.angelInsider.basics.habits.habit3.tile.explore.title':
    '채팅 너머의 다른 기능도 살펴보세요',
  'pages.angelInsider.basics.habits.habit3.tile.explore.review':
    '검토: 여러 문서를 분석하고, 실사를 진행하고, 구조화된 질문 목록으로 복잡한 파일을 헤쳐 나가기에 안성맞춤입니다.',
  'pages.angelInsider.basics.habits.habit3.tile.explore.reviewLink': '검토 더 알아보기',
  'pages.angelInsider.basics.habits.habit3.tile.explore.workStudio':
    'Workstudio: 표준 입장을 자동으로 적용해 계약서 작성을 표준화합니다.',
  'pages.angelInsider.basics.habits.habit3.tile.explore.workStudioLink': 'Workstudio 더 알아보기',
  'pages.angelInsider.basics.habits.habit3.tile.explore.scribe':
    '스크라이브: 오디오 파일을 정확한 텍스트로 옮기며, 실시간 전사와 국경을 넘는 통화의 동시 번역까지 지원합니다.',
  'pages.angelInsider.basics.habits.habit3.tile.explore.scribeLink': '스크라이브 더 알아보기',
  'pages.angelInsider.basics.habits.habit3.tile.explore.quickInfo':
    '빠른 정보 / 가이드 요약: 어떤 문서든 빠르고 출처가 붙은 읽기를 제공합니다. 개요가 필요하면 빠른 정보, 초점을 잡고 싶으면 가이드 요약입니다.',
  'pages.angelInsider.basics.habits.habit3.tile.explore.quickInfoLink':
    '빠른 정보 & 가이드 요약 더 알아보기',
  'pages.angelInsider.basics.habits.habit3.tile.explore.translation':
    '번역: 법률·비즈니스 콘텐츠를 위한 전용 번역을 문단 단위로 정확하게 제공합니다.',
  'pages.angelInsider.basics.habits.habit3.tile.explore.apps':
    '앱: 특정 과제에서 더 높은 정확성과 꼼꼼함을 내도록 조율되어 있습니다. 예를 들어 다단계 프롬프트는 문서를 특정 논점 중심으로 해부하는 여러 분석 도구를 제공해, 채팅의 한계를 넘어서는 더 길고 복잡한 작업에 필요한 정밀함을 제공합니다.',
  'pages.angelInsider.basics.habits.habit3.tile.benefitsIntro':
    '과제를 알맞은 기능에 대응시키면 이런 것을 얻습니다:',
  'pages.angelInsider.basics.habits.habit3.tile.benefit1':
    '<strong>더 큰 통제력:</strong> 채팅 하나에만 기대지 않고 일에 맞는 도구를 골라 쓰면 정확도가 올라갑니다.',
  'pages.angelInsider.basics.habits.habit3.tile.benefit2':
    '<strong>역량 쌓기:</strong> 직접 해 보는 것이 핵심입니다. 여러 기능과 조합을 시도하다 보면 A&GEL이 무엇을 할 수 있는지에 대한 감각이 자리 잡습니다. 이것은 계단을 오르는 것과 같습니다. 채팅에서 기본적인 질문으로 시작해, 실력이 붙으면 앱이나 검토에서 복잡한 다단계 분석으로 올라가는 것이죠.',
  'pages.angelInsider.basics.habits.habit3.tile.benefit3':
    '<strong>효율:</strong> 어떤 도구를 쓸지 알면 시간이 절약됩니다. 전사에는 스크라이브, 정밀한 언어 변환에는 번역처럼 전용 기능이 더 잘 처리할 일을 두고 채팅에서 프롬프트와 씨름하지 않게 됩니다.',
  'pages.angelInsider.basics.habits.habit3.examples.chatOnly.bad':
    '90쪽짜리 계약서든 다단계 분석이든, 늘 채팅만 쓰기',
  'pages.angelInsider.basics.habits.habit3.examples.chatOnly.good':
    '긴 계약서에는 검토를, 여러 단계로 나뉜 과제에는 다단계 프롬프트를 써 보고 — 그 일에는 어느 기능이 더 빠르고 정확하게 느껴졌는지 메모해 두세요.',
  'pages.angelInsider.basics.habits.habit3.examples.paste.bad':
    '90쪽짜리 계약서를 채팅에 붙여 넣고 “위험이 뭐야?”라고 묻기',
  'pages.angelInsider.basics.habits.habit3.examples.paste.good':
    '구조화된 질문 목록과 함께 ‘검토’로 돌리거나, 앱의 ‘다단계’로 처리해 문서를 절 단위로 훑으며 정확히 무엇을 찾는지 짚어 내세요.',
  'pages.angelInsider.seeMore': '자세히 보기',
  'pages.angelInsider.learnMore.heading': '더 알아보기',
  'pages.angelInsider.learnMore.intro':
    '채팅 외에도 A&GEL의 앱 모드는 딥 리서치, 가이드 요약, 빠른 정보, 타임라인, 기한 추출과 같은 집중형 작업을 다룹니다. 이러한 기능은 정확하게 준비할수록 더 좋은 결과를 돌려줍니다.',
  'pages.angelInsider.learnMore.featuredBadge': '추천',
  'pages.angelInsider.learnMore.cards.usingFiles.title': 'A&GEL에서 내 파일 활용하기',
  'pages.angelInsider.learnMore.cards.usingFiles.body':
    '스캔한 종이 문서는 A&GEL이 읽을 수 있도록 먼저 텍스트 레이어가 있어야 합니다. Kofax로 PDF를 검색 가능한 형태로 만든 뒤 업로드하세요.',
  'pages.angelInsider.learnMore.cards.workStudio.title': 'Workstudio',
  'pages.angelInsider.learnMore.cards.workStudio.body':
    '팀의 표준 입장을 한 번만 정의해 두면 — A&GEL이 변경 내용 추적이 적용된 Word 문서를 돌려줍니다.',
  'pages.angelInsider.learnMore.cards.workStudio.imageAlt': 'Workstudio',
  'pages.angelInsider.learnMore.cards.review.title': '검토',
  'pages.angelInsider.learnMore.cards.review.body':
    '여러 문서에 걸쳐 여러 질문을 한 번에 제기하세요 — 결과는 인라인 인용과 함께 표로 표시됩니다. 미니 채팅을 사용하면 페이지를 벗어나지 않고 후속 질문을 이어갈 수 있습니다.',
  'pages.angelInsider.learnMore.cards.review.imageAlt': '검토 모드',
  'pages.angelInsider.learnMore.cards.dispute.title': '분쟁 해결',
  'pages.angelInsider.learnMore.cards.dispute.body':
    '전체 문서 세트를 대상으로 사건 요약, 소장 분석, 답변서 작성, 소송 서면 추적을 수행합니다.',
  'pages.angelInsider.learnMore.cards.dispute.imageAlt': '소송 서면 추적기',
  'pages.angelInsider.learnMore.cards.sideBySide.title': '나란히 보기 & 비교',
  'pages.angelInsider.learnMore.cards.sideBySide.body':
    '조항별 검토와 함께 원문 단락까지 완전하게 확인할 수 있습니다. 비교 기능은 변경 내용 추적과 수정본도 처리합니다.',
  'pages.angelInsider.learnMore.cards.sideBySide.imageAlt': '나란히 보기 분석',
  'pages.angelInsider.learnMore.cards.multiStep.title': '다단계 프롬프트',
  'pages.angelInsider.learnMore.cards.multiStep.body':
    '복잡한 법률 업무를 순차적인 단계로 나누고, 각 단계가 앞 단계 위에 쌓이도록 합니다.',
  'pages.angelInsider.learnMore.cards.multiStep.imageAlt': '앱 모드',
  'pages.angelInsider.learnMore.cards.timeline.title': '타임라인',
  'pages.angelInsider.learnMore.cards.timeline.body':
    '최대 100건의 문서에 흩어진 시간 순서를 원문이 확인된 하나의 타임라인으로 통합합니다.',
  'pages.angelInsider.learnMore.cards.timeline.imageAlt': '타임라인',
  'pages.angelInsider.learnMore.cards.deepResearch.title': '딥 리서치',
  'pages.angelInsider.learnMore.cards.deepResearch.body':
    '구조화된 리서치 프롬프트를 바탕으로 문서 전반에 걸친 심층 분석을 수행합니다. 모든 결과는 클릭 가능한 인라인 인용을 통해 출처 단락으로 연결됩니다.',
  'pages.angelInsider.learnMore.cards.deepResearch.imageAlt': '딥 리서치',
  'pages.angelInsider.learnMore.cards.scopeSummary.title': '범위 요약',
  'pages.angelInsider.learnMore.cards.scopeSummary.body':
    '직접 정의한 중점 영역에 맞춰 구조화된 요약을 생성합니다. 추출된 모든 항목에는 원문과 대조해 확인할 수 있는 클릭 가능한 인라인 인용이 붙습니다.',
  'pages.angelInsider.learnMore.faq.heading': '자주 묻는 질문',
  'pages.angelInsider.learnMore.faq.group1.kicker': '일반 원칙',
  'pages.angelInsider.learnMore.faq.experts.question':
    '“전문가가 언제나 전문가로 남게 하라”는 말은 무슨 뜻인가요?',
  'pages.angelInsider.learnMore.faq.experts.answer':
    '전문가로서의 판단, 통찰, 그리고 진정성은 언제나 업무의 중심에 있어야 합니다. A&GEL은 여러분의 전문성을 대체하지 않습니다 — 더 많은 것을 가지고 더 많은 일을 해내도록 돕기 위해 설계되었습니다.',
  'pages.angelInsider.learnMore.faq.unfamiliar.question':
    'A&GEL에 물어보려는 주제에 대해 제가 전혀 모른다면 어떻게 해야 하나요?',
  'pages.angelInsider.learnMore.faq.unfamiliar.answer':
    '그래도 A&GEL을 사용할 수 있습니다 — 다만 더 신중하게 접근하고 결과를 더 꼼꼼히 확인하세요. A&GEL을 팀이 이미 보유한 노하우로 가는 관문으로 삼아, 필요할 때 바로 인사이트를 얻고 자신의 학습과 성장에 활용해 보세요.',
  'pages.angelInsider.learnMore.faq.group2.kicker': '파일 관리',
  'pages.angelInsider.learnMore.faq.referenceMaterial.question':
    'A&GEL에 어떤 참고 자료를 업로드해야 하나요?',
  'pages.angelInsider.learnMore.faq.referenceMaterial.answer':
    '신뢰할 수 있고 정확한 자료만 업로드하세요 — 1차 법률 자료(법령, 판례)와 검증된 내부 자료(사내 노하우, 검증된 문서)가 이에 해당합니다. 명확한 명명 규칙을 유지하세요.',
  'pages.angelInsider.learnMore.faq.thirdParty.question': '제3자 문서도 업로드할 수 있나요?',
  'pages.angelInsider.learnMore.faq.thirdParty.answer':
    '네 — 상대방 대리인의 문서도 포함됩니다. 신뢰할 수 있는 선례와 구분되도록 명확히 표시된 폴더에 업로드하세요. AI 사용 및 제3자 콘텐츠에 관한 사내 정책도 함께 준수해 주세요.',
  'pages.angelInsider.learnMore.faq.processingTime.question':
    'A&GEL이 업로드한 파일을 처리하는 데 왜 시간이 오래 걸리나요?',
  'pages.angelInsider.learnMore.faq.processingTime.answer':
    '문서는 A&GEL이 다룰 수 있는 “임베딩”으로 변환되어야 하며 — 이 작업은 업로드 시 한 번만 수행됩니다. 채팅에서는 컨텍스트 버튼으로 선택해 이미 업로드한 문서를 새 세션에서 다시 사용할 수 있습니다.',
  'pages.angelInsider.learnMore.faq.bulkUpload.question':
    '문서를 한꺼번에 업로드하려면 어떻게 해야 하나요?',
  'pages.angelInsider.learnMore.faq.bulkUpload.answer':
    '파일 모드에서 오른쪽 상단의 업로드 버튼을 클릭하고 파일을 선택한 뒤 “열기”를 누르세요. 업로드가 진행되는 동안에도 A&GEL을 계속 사용할 수 있습니다.',
  'pages.angelInsider.learnMore.faq.sorting.question':
    '참고 자료를 어떻게 분류하고 관리해야 하나요?',
  'pages.angelInsider.learnMore.faq.sorting.answer':
    '모든 자료를 한 폴더에 몰아넣지 마세요. (i) 주제와 (ii) 업무 흐름에 따라 문서를 묶으세요 — 예: <code>Home / IP Licensing / Licensor</code>. 이렇게 하면 A&GEL이 알맞은 컨텍스트를 가져오기 쉬워지고, 결과를 확인하기도 수월해집니다.',
  'pages.angelInsider.learnMore.faq.group3.kicker': '프롬프트 작성',
  'pages.angelInsider.learnMore.faq.promptTypes.question':
    '어떤 유형의 프롬프트를 사용할 수 있나요?',
  'pages.angelInsider.learnMore.faq.promptTypes.answer':
    '정보 탐색형(질문형, 설명형, 리서치형), 과제 지향형(지시형, 다단계형, 템플릿형), 분석형(데이터 분석, 문제 해결, 비교), 분류형(분류, 정렬, 태그 지정), 변환형(번역, 형식 변환, 문체 조정) 프롬프트 등이 있습니다.',
  'pages.angelInsider.learnMore.faq.effectivePrompts.question':
    '효과적인 프롬프트는 어떻게 작성하나요?',
  'pages.angelInsider.learnMore.faq.effectivePrompts.answer':
    '가장 효과적인 프롬프트는 네 부분으로 구성됩니다: <strong>(a) 페르소나</strong> — A&GEL이 어떤 역할을 맡아야 하는지; <strong>(b) 과제</strong> — 구체적인 지시; <strong>(c) 컨텍스트</strong> — 배경 정보와 참고 자료; <strong>(d) 형식</strong> — 결과물을 어떤 구조로 받고 싶은지.',
  'pages.angelInsider.learnMore.faq.rag.question': 'RAG란 무엇이며 A&GEL은 언제 사용하나요?',
  'pages.angelInsider.learnMore.faq.rag.answer':
    'RAG(검색 증강 생성)는 A&GEL 채팅의 기본 모드입니다. 보관함의 참고 자료를 가져와 프롬프트와 함께 모델에 전달함으로써 결과의 정확성과 신뢰성을 높입니다.',
  'pages.angelInsider.learnMore.faq.allMaterials.question':
    '왜 모든 프롬프트마다 업로드한 자료 전부를 A&GEL이 참고하게 하면 안 되나요?',
  'pages.angelInsider.learnMore.faq.allMaterials.answer':
    '관련 없는 컨텍스트를 제공하면 속도, 정확성, 신뢰성이 모두 떨어집니다. A&GEL은 확률적으로 작동하므로 현재 작업에 맞지 않는 자료를 끌어올 수 있습니다. 컨텍스트는 프롬프트와 관련된 문서로만 제한하세요.',
  'pages.angelInsider.learnMore.faq.selectMaterials.question':
    '프롬프트마다 관련 참고 자료는 어떻게 선택하나요?',
  'pages.angelInsider.learnMore.faq.selectMaterials.answer':
    '채팅 모드에서 “컨텍스트”로 이동해 선택 아이콘을 클릭한 뒤, 관련 있는 문서나 폴더만 선택하세요.',
  'pages.angelInsider.learnMore.faq.group4.kicker': '결과물 활용',
  'pages.angelInsider.learnMore.faq.outputAsIs.question':
    'A&GEL의 결과물을 그대로 사용해도 되나요?',
  'pages.angelInsider.learnMore.faq.outputAsIs.answer':
    '아니요 — 사용하기 전에 반드시 A&GEL의 결과물을 확인하세요. 결과물은 출발점으로 삼고, 업로드한 참고 자료를 포함해 신뢰할 수 있는 지식 원천과 교차 확인하세요.',
  'pages.angelInsider.learnMore.faq.accuracy.question':
    '결과물의 정확성과 신뢰성은 어떻게 확인해야 하나요?',
  'pages.angelInsider.learnMore.faq.accuracy.answer':
    '채팅 모드에서는 A&GEL이 참고한 원본 문서로 연결되는 참조 링크가 결과에 함께 표시됩니다. 각 참조를 클릭해 원본 자료와 대조하세요. A&GEL은 여러분의 노하우로 가는 관문이어야 하며, 노하우 자체의 출처가 되어서는 안 됩니다. 참조가 없는 결과물은 환각이 발생하기 쉬우므로, 충분한 컨텍스트가 제공된 순수한 작문·서식·문장 편집 프롬프트가 아니라면 사용해서는 안 됩니다.',
  'pages.angelInsider.learnMore.faq.group5.kicker': '용어집',
  'pages.angelInsider.learnMore.glossary.favouriteFileWeight.term': '즐겨찾기 파일 가중치',
  'pages.angelInsider.learnMore.glossary.favouriteFileWeight.definition':
    '응답을 생성할 때 보관함에서 “즐겨찾기”로 표시된 문서를 A&GEL이 얼마나 우선할지 조정합니다.',
  'pages.angelInsider.learnMore.glossary.reRanking.term': '재순위화',
  'pages.angelInsider.learnMore.glossary.reRanking.definition':
    '1차 검색 결과를 다시 살펴, 응답을 생성하기 전에 가장 관련성 높은 조항과 문단을 앞세우는 2차 정렬 과정입니다.',
  'pages.angelInsider.learnMore.glossary.searchRatio.term': '검색 비율',
  'pages.angelInsider.learnMore.glossary.searchRatio.definition':
    'A&GEL이 보관함을 얼마나 넓게 검색할지 조절합니다. 비율이 높을수록 컨텍스트가 넓어지고, 낮을수록 정확한 일치에 집중합니다.',
  'pages.angelInsider.learnMore.glossary.systemPrompt.term': '시스템 프롬프트',
  'pages.angelInsider.learnMore.glossary.systemPrompt.definition':
    '모든 세션에서 A&GEL의 역할, 어조, 한계를 정하는 기본 지시문입니다.',
  'pages.angelInsider.learnMore.glossary.thinking.term': '‘사고’ / ‘추론’',
  'pages.angelInsider.learnMore.glossary.thinking.definition':
    '복잡한 분석에서 오류를 줄이기 위해, 최종 응답을 생성하기 전 A&GEL이 내부적으로 단계별로 검토하는 과정입니다.',
  'pages.angelInsider.learnMore.issues.heading': '각 호를 읽어보고 싶다면',
  'pages.angelInsider.learnMore.issues.issue1.title': '컨텍스트가 (거의) 전부입니다',
  'pages.angelInsider.learnMore.issues.issue1.description':
    '기본 • 프롬프트 핵심 • 2026년 2월 17일',
  'pages.angelInsider.learnMore.issues.issue2.title': '분쟁 해결 활용 사례',
  'pages.angelInsider.learnMore.issues.issue2.description':
    '사건 요약 • 소송 서면 추적기 • 프롬프트 작성 팁 • 2026년 3월 19일',
  'pages.angelInsider.learnMore.issues.issue3.title': '새로운 타임라인 및 다단계 프롬프트 앱',
  'pages.angelInsider.learnMore.issues.issue3.description':
    '이메일 업로드 • 스크라이브 업데이트 • 타임라인 개편 • 2026년 3월 19일',
  'pages.angelInsider.learnMore.issues.issue4.title': '스크라이브 실시간 번역과 Workstudio',
  'pages.angelInsider.learnMore.issues.issue4.description':
    '실시간 번역 • 새로운 Workstudio 기능 • 2026년 4월 1일',
  'pages.angelInsider.learnMore.issues.issue5.title': '인라인 참조, 미니 채팅 등',
  'pages.angelInsider.learnMore.issues.issue5.description':
    '핀사이트 인용 • 이동 가능한 미니 채팅 • 스크라이브 타임스탬프 • 2026년 4월 10일',
  'pages.angelInsider.learnMore.issues.pill': '제{number}호',
  'pages.angelInsider.whatsNew.heading': '새로운 소식',
  'pages.angelInsider.whatsNew.cards.msgUpload.title': '.msg 이메일 업로드',
  'pages.angelInsider.whatsNew.cards.msgUpload.body':
    '.msg 이메일 파일을 그대로 업로드할 수 있으며, 첨부 파일까지 모두 읽어 들입니다.',
  'pages.angelInsider.whatsNew.cards.inlineReferencing.title': '인라인 참조',
  'pages.angelInsider.whatsNew.cards.inlineReferencing.body':
    '이제 딥 리서치, 타임라인, 범위 요약, 검토에 클릭 가능한 핀사이트 인용이 제공됩니다 — 페이지를 벗어나지 않고 어떤 결과든 원문과 대조해 확인하세요.',
  'pages.angelInsider.comingUp.heading': '다가올 기능',
  'pages.angelInsider.comingUp.intro':
    '다음 호 A&GEL Insider에서는 Workstudio를 더 깊이 다룹니다. 다단계 프롬프트를 처음부터 구성하는 방법과, 이를 활용해 팀의 표준 입장이 반영된 변경 내용 추적 초안을 생성하는 방법을 배우게 됩니다. 기대해 주세요.',
  'pages.angelInsider.comingUp.cards.workstudioV2.title': 'Workstudio V2',
  'pages.angelInsider.comingUp.cards.workstudioV2.body':
    '더 깊이 있는 Workstudio 작성 도구와 한층 확장된 변경 내용 추적 결과물. 자세한 내용은 5호에서 확인하세요.',
  'pages.angelInsider.comingUp.cards.workstudioV2.badge': '출시 예정',
  'pages.angelInsider.comingUp.cards.moreToCome.title': '더 많은 소식이 이어집니다',
  'pages.angelInsider.comingUp.cards.moreToCome.body':
    'A&GEL 팀은 끊임없이 새로운 기능을 선보이고 있습니다. 다음 Insider 호를 기대해 주세요.',
  'pages.angelInsider.comingUp.cards.moreToCome.badge': '준비 중',
  'pages.angelInsider.issues.basics-intro.title': 'A&GEL에 오신 것을 환영합니다',
  'pages.angelInsider.issues.basics-intro.subtitle':
    '좋은 출발을 위해 드리는 몇 가지 이야기입니다.',
  'pages.angelInsider.issues.basics-intro.glance.0':
    '새로운 도구를 익히는 데는 시간이 걸립니다 — 모든 과정에서 저희가 함께하겠습니다.',
  'pages.angelInsider.issues.basics-intro.glance.1':
    'A&GEL 같은 도구는 혼자서는 불가능했던 수준까지 <strong>여러분의 역량을 확장</strong>합니다.',
  'pages.angelInsider.issues.basics-intro.glance.2':
    '가장 좋은 학습법은 <strong>A&GEL을 직접 써 보는 것</strong>입니다 — 자유롭게 탐색하고, 실수도 해 보세요.',
  'pages.angelInsider.issues.basics-intro.glance.3':
    '팀이 함께 A&GEL을 받아들일 때, 그 혜택은 모두에게 배가됩니다.',
  'pages.angelInsider.issues.basics-intro.sections.0.kicker': '01 — 시작하기',
  'pages.angelInsider.issues.basics-intro.sections.0.heading':
    '새로운 도구를 익히는 데는 시간이 걸립니다 – 괜찮습니다',
  'pages.angelInsider.issues.basics-intro.sections.0.blocks.0.p':
    '함께하게 되어 매우 기쁩니다. A&GEL을 둘러보기 시작하시는 지금, 좋은 출발을 위해 몇 가지 말씀을 드리고자 합니다.',
  'pages.angelInsider.issues.basics-intro.sections.0.blocks.1.p':
    '새로운 기술에 익숙해지는 것이 처음에는 어렵게 느껴질 수 있다는 점을 잘 알고 있습니다. 저희는 모든 과정에서 여러분을 지원하기 위해 이 자리에 있다는 것을 기억해 주세요. 궁금한 점이 있거나 막히는 부분이 있을 때, 혹은 단순히 도움을 받고 싶으실 때에도 언제든지 편하게 문의해 주시기 바랍니다.',
  'pages.angelInsider.issues.basics-intro.sections.0.blocks.3.p':
    'A&GEL과 같은 AI 도구는 이전의 도구들과 <strong>다릅니다</strong> — <strong>사용자 여러분을 직접</strong> 지원합니다. 손끝에서 활용할 수 있는 수많은 조력자를 두고 있다고 생각해 보세요. 인간의 판단을 대신할 수는 없지만, 여러 면에서 혼자서는 불가능했던 수준까지 여러분의 역량을 크게 확장해 줍니다.',
  'pages.angelInsider.issues.basics-intro.sections.0.blocks.4.p':
    '<strong>배우기 시작하는 가장 좋은 방법은 A&GEL을 직접 써 보는 것입니다 —</strong> 자유롭게 탐색해 보시기를 권해 드립니다. 이것저것 시도해 보고, (안전한 범위 안에서) 실수도 해 보면서 자신에게 가장 잘 맞는 방법을 찾아보세요.',
  'pages.angelInsider.issues.basics-intro.sections.1.kicker': '02 — 역량 쌓기',
  'pages.angelInsider.issues.basics-intro.sections.1.heading': '본인의 속도에 맞춰 나아가세요',
  'pages.angelInsider.issues.basics-intro.sections.1.blocks.0.p':
    '역량을 키우는 것은 계단을 오르는 것과 같다고 생각해 보세요. 기본부터 시작해서 자신감이 붙을수록 다음 단계로 넘어가는 것이 훨씬 자연스럽게 느껴질 것입니다. 서두를 필요는 없습니다 — 이것은 경주가 아닙니다. 탄탄한 기초를 다지는 데 필요한 시간을 충분히 가지세요.',
  'pages.angelInsider.issues.basics-intro.sections.2.kicker': '03 — 커뮤니티',
  'pages.angelInsider.issues.basics-intro.sections.2.heading': '함께라면 더 멀리 갈 수 있습니다',
  'pages.angelInsider.issues.basics-intro.sections.2.blocks.0.p':
    '팀과 회사가 A&GEL을 함께 받아들일 때, 그 혜택은 모두에게 배가됩니다. 사용자 커뮤니티 전반에서 지식을 공유하고 협력하면 모두를 끌어올리는 파급 효과가 생겨납니다.',
  'pages.angelInsider.issues.basics-intro.signoff.line':
    '함께하게 된 것을 환영합니다 — A&GEL과 함께 무엇을 이룰 수 있을지 기대됩니다.',
  'pages.angelInsider.issues.basics-intro.signoff.name': 'Kok Leong<br>A&GEL 개발팀',
  'pages.angelInsider.issues.issue-1.title': '컨텍스트가 (거의) 전부입니다',
  'pages.angelInsider.issues.issue-1.subtitle':
    '프롬프트의 핵심 — 컨텍스트 선택이 A&GEL의 모든 결과를 좌우하는 방식.',
  'pages.angelInsider.issues.issue-1.date': '2026년 1월 15일',
  'pages.angelInsider.issues.issue-1.glance.0':
    '이제 채팅에 전용 <strong>컨텍스트</strong> 버튼과 <strong>“컨텍스트 %”</strong> 표시가 생겼습니다.',
  'pages.angelInsider.issues.issue-1.glance.1':
    '기본 검색 설정이 <strong>컨텍스트 없음</strong>으로 바뀌었습니다 — 더 빠르고, 교정이나 가벼운 편집에 적합합니다.',
  'pages.angelInsider.issues.issue-1.glance.2':
    '일상 업무를 위해 보관함에서 <strong>기본 컨텍스트 프리셋</strong>을 만들어 두세요.',
  'pages.angelInsider.issues.issue-1.glance.3':
    '컨텍스트 없는 프롬프트는 추측에 불과합니다 — 나만 아는 배경 정보를 반드시 제공하세요.',
  'pages.angelInsider.issues.issue-1.sections.0.kicker': '01 — 채팅',
  'pages.angelInsider.issues.issue-1.sections.0.heading':
    '채팅의 컨텍스트: 전용 버튼과 “컨텍스트 %” 표시',
  'pages.angelInsider.issues.issue-1.sections.0.blocks.0.p':
    'A&GEL의 채팅 기능은 맞춤형 <strong>검색 증강 생성(RAG)</strong> 파이프라인을 사용합니다. 보관함에 있는 노하우와 참고 자료를 가져와 모델에 전달해 결과를 생성합니다. RAG 품질을 좌우하는 가장 중요한 요소는 <em>컨텍스트 선택</em> — 즉 답변이 보관함의 어느 범위에서 나오는지입니다.',
  'pages.angelInsider.issues.issue-1.sections.0.blocks.1.p':
    '이를 눈으로 확인할 수 있도록 <strong>“컨텍스트 %”</strong> 표시를 추가했습니다 — 대략적이지만, 현재 채팅 세션이 보관함을 얼마나 포괄하는지 한눈에 알려 주는 유용한 지표입니다. 컨텍스트 버튼을 클릭하면 대화에 사용할 폴더나 파일을 정확히 고를 수 있습니다.',
  'pages.angelInsider.issues.issue-1.sections.0.blocks.2.callout.title':
    '새로운 기본값: 컨텍스트 없음',
  'pages.angelInsider.issues.issue-1.sections.0.blocks.2.callout.body':
    '기본 검색 설정이 이제 컨텍스트 없음(채팅 창 오른쪽 위)입니다. 이 방식은 사전 학습된 공개 지식만으로 생성하므로 채팅이 더 빠릅니다 — 교정이나 문구 수정 같은 단순한 요청에 적합합니다. 컨텍스트 없음 설정에서는 A&GEL이 몇 초 안에 응답합니다.',
  'pages.angelInsider.issues.issue-1.sections.0.blocks.3.h':
    '일상 업무를 위한 기본 컨텍스트 설정하기',
  'pages.angelInsider.issues.issue-1.sections.0.blocks.4.p':
    'A&GEL은 <em>여러분의</em> 노하우를 바탕으로 답하므로, 기본 컨텍스트 프리셋을 만들어 둘 수 있습니다. 컨텍스트 버튼을 클릭하고 폴더를 선택한 뒤 더하기(+) 버튼을 누르세요. 프리셋 이름을 정하고, 필요하면 <strong>“기본값으로 설정”</strong>을 체크한 다음 확인을 클릭합니다.',
  'pages.angelInsider.issues.issue-1.sections.0.blocks.5.p':
    '<strong>모든</strong> 폴더를 선택하면(컨텍스트 100%) 모든 문서를 검색하므로 A&GEL이 느려집니다 — 범위가 넓다고 늘 좋은 것은 아닙니다. 컨텍스트는 해당 질문에 맞게 조정하세요. 접근 가능한 파일 수와 질문의 복잡도에 따라 응답에 최대 1분이 걸릴 수 있습니다.',
  'pages.angelInsider.issues.issue-1.sections.1.kicker': '02 — 프롬프트',
  'pages.angelInsider.issues.issue-1.sections.1.heading':
    '프롬프트를 작성할 때는 항상 컨텍스트를 더하세요',
  'pages.angelInsider.issues.issue-1.sections.1.blocks.0.quote':
    '컨텍스트 없는 프롬프트는 추측일 뿐입니다 — 이른바 “프롬프트 룰렛”.',
  'pages.angelInsider.issues.issue-1.sections.1.blocks.1.p':
    '프롬프트가 효과를 내려면 올바른 정보가 주어져야 합니다 — 전문성이 깊은 분야일수록 더욱 그렇습니다. A&GEL을 유능한 조력자로 생각하되, 전체 그림이 필요하다는 점을 기억하세요. 나만 아는 배경, 즉 핵심 목표와 성공 기준, 나아가 “좋은” 답변과 “나쁜” 답변의 예시까지 제공하세요.',
  'pages.angelInsider.issues.issue-1.sections.1.blocks.2.h':
    '더 풍부한 프롬프트를 위한 간단한 프레임워크',
  'pages.angelInsider.issues.issue-1.sections.1.blocks.3.p':
    '충분한 컨텍스트를 제공했는지 스스로 계속 물어보세요. 바로 이 지점에서 여러분의 전문성이 발휘되며, 기본적인 프롬프트와 비교해 결과의 질이 확연히 달라집니다.',
  'pages.angelInsider.issues.issue-1.sections.1.blocks.4.callout.title': '소송 사례',
  'pages.angelInsider.issues.issue-1.sections.1.blocks.4.callout.body':
    '소송 담당자는 프롬프트를 복제한 뒤 대괄호로 표시된 부분만 자기 사건에 맞게 고쳐도 훨씬 정교한 결과를 얻습니다. 법률적 컨텍스트(적용 법리의 짧은 요약)와 상업적 컨텍스트(주변 사실관계)를 많이 제공할수록, 그 프롬프트는 분석 도구로서 더 좋은 성능을 냅니다.',
  'pages.angelInsider.issues.issue-1.sections.1.blocks.5.p':
    '여러분의 컨텍스트는 여러분이 가장 잘 압니다 — 그러니 프롬프트와 질문 목록, 맞춤 지시문의 효과를 살려 줄 바로 그 유형의 컨텍스트를 항상 더해 주세요.',
  'pages.angelInsider.issues.issue-1.sections.2.kicker': '03 — 시작하기',
  'pages.angelInsider.issues.issue-1.sections.2.heading': '도움이 필요하신가요?',
  'pages.angelInsider.issues.issue-1.sections.2.blocks.0.callout.title':
    '문제가 생겼나요? 세 가지만 알려 주세요',
  'pages.angelInsider.issues.issue-1.sections.2.blocks.0.callout.body':
    'A&GEL 개발자에게 메시지나 이메일을 보내 주세요. 다음 내용만 담으면 충분합니다:',
  'pages.angelInsider.issues.issue-1.sections.2.blocks.0.callout.list.0':
    '<strong>시각</strong> — 예: “오늘 오후 4시 31분에 시작한 채팅”',
  'pages.angelInsider.issues.issue-1.sections.2.blocks.0.callout.list.1':
    '<strong>문제가 발생한 기능</strong> — 예: “분석 → 딥 리서치에서 파일을 업로드하려 했는데 로드되지 않음”',
  'pages.angelInsider.issues.issue-1.sections.2.blocks.0.callout.list.2':
    '<strong>간단한 설명</strong> 또는 스크린샷',
  'pages.angelInsider.issues.issue-1.signoff.line':
    '감사합니다. 그리고 기억하세요 — 컨텍스트가 먼저입니다.',
  'pages.angelInsider.issues.issue-1.signoff.name': 'A&GEL 개발팀',
  'pages.angelInsider.issues.issue-2.title': '분쟁 해결 활용 사례',
  'pages.angelInsider.issues.issue-2.subtitle':
    '요약과 초안 생성, 소송 서면 분석과 추적 — 프롬프트 작성 팁까지.',
  'pages.angelInsider.issues.issue-2.date': '2026년 2월 12일',
  'pages.angelInsider.issues.issue-2.glance.0':
    '두 가지 <strong>사건 요약</strong> 프롬프트(간결형 & 상세형) — 복잡한 판결에서는 상세형이 특히 빛을 발합니다.',
  'pages.angelInsider.issues.issue-2.glance.1':
    '<strong>답변서</strong>와 고객용 <strong>법률 소식</strong>을 작성하는 프롬프트.',
  'pages.angelInsider.issues.issue-2.glance.2':
    '<strong>소송 서면을 분석</strong>하는 프롬프트 모음 — 소장, 답변서, 그리고 주장의 충분성.',
  'pages.angelInsider.issues.issue-2.glance.3':
    '여러 문서에 걸친 소송 서면 추적기로 <strong>검토 모드</strong>를 활용하세요.',
  'pages.angelInsider.issues.issue-2.sections.0.kicker': '01 — 요약',
  'pages.angelInsider.issues.issue-2.sections.0.heading': '사건 요약 생성하기',
  'pages.angelInsider.issues.issue-2.sections.0.blocks.0.p':
    '사건을 요약하는 프롬프트 두 가지를 개발했습니다 — 하나는 간결한 개요용, 다른 하나는 보다 상세한 분석용입니다. 싱가포르 법률아카데미(SAL)가 공개한 프롬프트를 바탕으로 생성형 AI를 활용해 다듬었습니다(A&GEL에게 자신의 결과물을 비평하게 하는 방식도 포함).',
  'pages.angelInsider.issues.issue-2.sections.0.blocks.1.p':
    '저희 경험상 <strong>상세형</strong> 사건 요약이 대체로 더 우수하며, 특히 복잡한 판결에서 그렇습니다. A&GEL은 원 판결문에만 <em>전적으로</em> 의존하도록 지시받습니다 — 다만 <em>판결이유(ratio decidendi)</em>와 <em>방론(obiter dicta)</em>을 구분하는 데는 어려움을 겪을 수 있다는 점에 유의하세요.',
  'pages.angelInsider.issues.issue-2.sections.0.blocks.2.callout.title': '만능 해법은 아닙니다',
  'pages.angelInsider.issues.issue-2.sections.0.blocks.2.callout.body':
    '결과물은 여전히 평소와 같은 방식으로 검토하고 확인해야 합니다 — 정확성과 완전성을 꼼꼼히 점검하세요. 이 프롬프트들은 효율적인 출발점을 제공할 뿐, 완성된 결과물이 아닙니다.',
  'pages.angelInsider.issues.issue-2.sections.0.blocks.3.p':
    '이를 (앱 메뉴의) <strong>가이드 요약</strong> 기능과 함께 사용해 보세요. 이 기능은 프롬프트의 안내에 따라 단일 문서를 요약합니다. 싱가포르 법원 판결문을 업로드하고 사건 요약(상세형) 프롬프트를 선택한 뒤, 특별히 신경 쓰이는 쟁점을 덧붙이세요.',
  'pages.angelInsider.issues.issue-2.sections.0.blocks.4.figure.caption':
    '프롬프트 라이브러리의 사건 요약(간결형) v1.1과 사건 요약(상세형) v1.1.',
  'pages.angelInsider.issues.issue-2.sections.1.kicker': '02 — 문서 작성',
  'pages.angelInsider.issues.issue-2.sections.1.heading': '초안 생성하기',
  'pages.angelInsider.issues.issue-2.sections.1.blocks.0.p':
    'SAL이 공개한 프롬프트를 바탕으로 한 프롬프트가 소장에 대응하는 <strong>답변서</strong> 초안을 생성합니다. 복제해 사건에 맞게 고치되, 충분한 컨텍스트를 반드시 포함하세요.',
  'pages.angelInsider.issues.issue-2.sections.1.blocks.1.p':
    '두 번째 프롬프트는 사건 요약을 바탕으로 고객용 <strong>법률 소식</strong>을 만들어 냅니다. 짧은 지식관리 샘플 기사가 문체와 구성, 어조를 잡아 줍니다.',
  'pages.angelInsider.issues.issue-2.sections.1.blocks.2.gallery.0.caption':
    '소장에 대한 답변서 초안 작성.',
  'pages.angelInsider.issues.issue-2.sections.1.blocks.2.gallery.1.caption':
    '참고 기사의 문체와 어조에 맞춰 작성 v1.2.',
  'pages.angelInsider.issues.issue-2.sections.2.kicker': '03 — 소송 서면',
  'pages.angelInsider.issues.issue-2.sections.2.heading': '소송 서면 분석하기',
  'pages.angelInsider.issues.issue-2.sections.2.blocks.0.p':
    '소송 서면 분석용 프롬프트를 여러 개 준비했습니다. 아직 가볍게만 검증된 것들이니 — 직접 써 보고, 복제해 개선한 뒤 다른 사용자와 공유해 주세요.',
  'pages.angelInsider.issues.issue-2.sections.2.blocks.1.list.0':
    '<strong>소장 분석</strong> — 요약 정리, 시간순 정리, 2021년 법원규칙 기준 충분성 검토, 핵심 쟁점과 본안 전 항변, 즉시 조치 사항과 다음 단계.',
  'pages.angelInsider.issues.issue-2.sections.2.blocks.1.list.1':
    '<strong>답변서 분석</strong> — 방어 전략을 추출하고, 소장의 주장에 구체적으로 대응하지 않은 공백을 찾아냅니다.',
  'pages.angelInsider.issues.issue-2.sections.2.blocks.1.list.2':
    '<strong>주장의 충분성</strong> — 원래 답변서 평가용으로 만들었으니, 검토 중인 서면에 맞게 복제해 조정하세요.',
  'pages.angelInsider.issues.issue-2.sections.2.blocks.2.gallery.0.caption':
    '소장 분석 & 시간순 정리 v1.5.',
  'pages.angelInsider.issues.issue-2.sections.2.blocks.2.gallery.1.caption':
    '소장에 대한 답변서 분석 v1.0.',
  'pages.angelInsider.issues.issue-2.sections.2.blocks.2.gallery.2.caption':
    '답변서 주장의 충분성 v1.0.',
  'pages.angelInsider.issues.issue-2.sections.3.kicker': '04 — 검토 모드',
  'pages.angelInsider.issues.issue-2.sections.3.heading': '검토를 소송 서면 추적기로 활용하기',
  'pages.angelInsider.issues.issue-2.sections.3.blocks.0.p':
    '분쟁이 진행되는 동안 각 당사자의 입장을 한눈에 확인하세요. <strong>검토 모드</strong>에서는 소장의 모든 청구원인을 길잡이 질문으로 삼아, 서면과 진술서에 제시된 입장을 체계적으로 살피고 따져 볼 수 있습니다.',
  'pages.angelInsider.issues.issue-2.sections.3.blocks.1.h': '1단계 — 채팅에서 질문 목록 생성하기',
  'pages.angelInsider.issues.issue-2.sections.3.blocks.2.p':
    '소장을 파일에 업로드하거나 채팅에 바로 넣은 뒤, 청구원인을 뽑아내는 프롬프트를 실행하세요:',
  'pages.angelInsider.issues.issue-2.sections.3.blocks.3.prompt.label': '질문 목록 생성기',
  'pages.angelInsider.issues.issue-2.sections.3.blocks.3.prompt.text':
    '당신은 20년 경력의 소송 전문 변호사입니다. 깊게 숨을 고르고 집중하세요.\n\n업로드된 문서는 소장입니다. 당신의 과제는 개조식 요약을 작성하는 것입니다. 각 항목은 (a) 하나의 청구원인, (b) 그 상대방인 피고, (c) 근거로 삼은 사실 주장, (d) 구하는 구제수단을 모두 담아야 합니다. 모든 세부 내용은 같은 항목 안에 담고 — 하위 항목은 쓰지 마세요. 문서의 모든 내용을 빠짐없이 추출하세요. 피고가 여럿이면 제1피고에 대한 모든 청구원인을 먼저 다룬 뒤 제2피고로 넘어가는 식으로 진행하세요.\n\n빠짐없되 간결하게: 각 청구원인과 직접 관련된 모든 내용을 요약하고 인용하세요. 정확하게: 모호한 표현을 피하고 문서에 쓰인 표현을 그대로 사용하세요.',
  'pages.angelInsider.issues.issue-2.sections.3.blocks.4.h':
    '2단계 — 검토에서 그 목록을 서면에 대조 실행하기',
  'pages.angelInsider.issues.issue-2.sections.3.blocks.5.p':
    '생성된 목록을 복사해 <strong>검토</strong>로 이동한 뒤 <strong>빠른 질문</strong>을 클릭하세요. <em>질문 추가</em>에 목록을 붙여넣고 <em>추가 +</em>를 클릭한 다음, 소장을 첨부하고 제출을 누릅니다.',
  'pages.angelInsider.issues.issue-2.sections.3.blocks.6.gallery.0.caption':
    '검토 모드 — 질문 목록을 빠른 질문 매트릭스로 추가.',
  'pages.angelInsider.issues.issue-2.sections.3.blocks.7.callout.title': '소송 서면을 넘어',
  'pages.angelInsider.issues.issue-2.sections.3.blocks.7.callout.body':
    '많은 문서에 많은 질문을 던질 수 있는 검토의 특성은 문서량이 많은 다른 업무에도 잘 맞습니다 — 증거개시, 문서 검토, 방대한 진술서 검토 등입니다.',
  'pages.angelInsider.issues.issue-2.sections.4.kicker': '05 — 숙련',
  'pages.angelInsider.issues.issue-2.sections.4.heading': '프롬프트 작성 팁: 시험하고 개선하기',
  'pages.angelInsider.issues.issue-2.sections.4.blocks.0.p':
    '<strong>프롬프트를 시험해 보세요.</strong> 미리 준비해 둔 모범 답안과 A&GEL의 결과물을 비교해 프롬프트를 가늠하세요. 서로 잘 맞아떨어진다면 프롬프트가 잘 다듬어진 것이고, 그렇지 않다면 어디가 비었는지 찾아 컨텍스트를 보태세요.',
  'pages.angelInsider.issues.issue-2.sections.4.blocks.1.p':
    '<strong>프롬프트를 개선하세요.</strong> 프롬프트 라이브러리의 <em>Improve My Prompt v1.0</em> 도구로 한층 더 다듬을 수 있습니다.',
  'pages.angelInsider.issues.issue-2.signoff.line': '복제하고, 다듬고, 잘 통한 것을 공유하세요.',
  'pages.angelInsider.issues.issue-2.signoff.name': 'A&GEL 개발팀',
  'pages.angelInsider.issues.feature-scribe.title': '스크라이브',
  'pages.angelInsider.issues.feature-scribe.subtitle':
    '회의를 녹음, 전사, 실시간 번역하고 편집까지 — 한곳에서 모두.',
  'pages.angelInsider.issues.feature-scribe.glance.0':
    '<strong>실시간 편집</strong> — 스크라이브가 녹음하는 동안 전사본을 편집하세요. 편집된 부분에는 밑줄이 표시됩니다.',
  'pages.angelInsider.issues.feature-scribe.glance.1':
    '<strong>오디오 재생</strong> — 전사본의 아무 구간이나 클릭하면 그 지점부터 녹음이 재생됩니다.',
  'pages.angelInsider.issues.feature-scribe.glance.2':
    '<strong>실시간 번역</strong> — 원하는 언어로 실시간 번역합니다.',
  'pages.angelInsider.issues.feature-scribe.glance.3':
    '<strong>타임스탬프가 있는 다운로드</strong> — 내보낸 Word 전사본에 타임스탬프가 들어 있어 이동이 쉽습니다.',
  'pages.angelInsider.issues.feature-scribe.sections.0.kicker': '스크라이브',
  'pages.angelInsider.issues.feature-scribe.sections.0.heading': '실시간 편집과 오디오 재생',
  'pages.angelInsider.issues.feature-scribe.sections.0.blocks.0.p':
    '<strong>실시간 편집</strong> — 개선된 스크라이브에서는 전사본을 편집할 수 있으며, 편집된 부분은 확인하기 쉽도록 밑줄로 표시됩니다. <strong>오디오 재생</strong> — 전사본이 저장된 뒤 원본 전사본을 열고 아무 구간이나 클릭하면 그 지점부터 녹음이 재생됩니다.',
  'pages.angelInsider.issues.feature-scribe.sections.0.blocks.1.gallery.0.caption':
    '실시간 전사와 함께 진행 중인 스크라이브 녹음.',
  'pages.angelInsider.issues.feature-scribe.sections.0.blocks.1.gallery.1.caption':
    '원본 전사본 — 구간을 클릭하면 해당 오디오가 재생됩니다.',
  'pages.angelInsider.issues.feature-scribe.sections.1.kicker': '스크라이브',
  'pages.angelInsider.issues.feature-scribe.sections.1.heading':
    '이제 스크라이브에서도 실시간 번역',
  'pages.angelInsider.issues.feature-scribe.sections.1.blocks.0.p':
    '통화와 회의를 원하는 언어로 이해하세요. <strong>실시간 번역</strong> 상자를 체크하고 언어를 고르면 — A&GEL이 원본 전사 아래에 번역을 실시간으로 표시합니다.',
  'pages.angelInsider.issues.feature-scribe.sections.1.blocks.1.figure.caption':
    '실시간 번역을 켜고 드롭다운에서 언어를 선택하세요.',
  'pages.angelInsider.issues.feature-scribe.sections.1.blocks.2.p':
    'A&GEL이 전사와 번역을 진행하는 동안에도 메모를 입력하거나 전사본을 직접 수정할 수 있습니다 — 편집한 내용은 A&GEL의 텍스트와 구분되도록 <strong>노란색</strong>으로 표시됩니다. 저장된 전사본에는 번역과 편집 내용이 모두 유지됩니다.',
  'pages.angelInsider.issues.feature-scribe.sections.1.blocks.3.gallery.0.caption':
    '원문 아래의 실시간 번역과 노란색으로 표시된 편집 가능한 메모.',
  'pages.angelInsider.issues.feature-scribe.sections.1.blocks.3.gallery.1.caption':
    '원본 전사본 왼쪽을 따라 표시되는 타임스탬프.',
  'pages.angelInsider.issues.feature-scribe.sections.2.kicker': '스크라이브',
  'pages.angelInsider.issues.feature-scribe.sections.2.heading':
    '이제 타임스탬프가 포함된 다운로드 전사본',
  'pages.angelInsider.issues.feature-scribe.sections.2.blocks.0.p':
    '스크라이브 전사본에는 이제 다운로드한 Word 문서 안에 <strong>타임스탬프</strong>가 포함됩니다 — 녹음된 대화나 회의의 특정 순간으로 손쉽게 이동할 수 있는 표식입니다.',
  'pages.angelInsider.issues.feature-scribe.sections.2.blocks.1.figure.caption':
    '타임스탬프와 번역이 그대로 유지된 스크라이브 전사본 다운로드본.',
  'pages.angelInsider.issues.feature-scribe.signoff.line': '기록하고, 되짚고, 다시 들으세요.',
  'pages.angelInsider.issues.feature-scribe.signoff.name': 'A&GEL 개발팀',
  'pages.angelInsider.issues.feature-prompt-library.title': '프롬프트 라이브러리',
  'pages.angelInsider.issues.feature-prompt-library.subtitle':
    '커뮤니티가 만든 프롬프트를 찾아 복제하고 다듬으세요 — 내장 도구로 더 날카롭게.',
  'pages.angelInsider.issues.feature-prompt-library.glance.0':
    '프롬프트 라이브러리에서 커뮤니티가 만든 프롬프트를 둘러보고, 복제해 사건에 맞게 고쳐 쓰세요.',
  'pages.angelInsider.issues.feature-prompt-library.glance.1':
    '<strong>프롬프트를 시험해 보세요</strong> — 미리 준비해 둔 모범 답안과 A&GEL의 결과물을 비교하세요.',
  'pages.angelInsider.issues.feature-prompt-library.glance.2':
    '기대만큼 작동하지 않는 프롬프트는 프롬프트 라이브러리의 <strong>Improve My Prompt v1.0</strong>으로 더 다듬으세요.',
  'pages.angelInsider.issues.feature-prompt-library.sections.0.kicker': '숙련',
  'pages.angelInsider.issues.feature-prompt-library.sections.0.heading':
    '프롬프트 작성 팁: 시험하고 개선하기',
  'pages.angelInsider.issues.feature-prompt-library.sections.0.blocks.0.p':
    '<strong>프롬프트를 시험해 보세요.</strong> 프롬프트의 효과를 가늠하는 좋은 방법은, 미리 준비해 둔 “모범 답안”이나 기준 결과물과 A&GEL의 출력을 비교해 보는 것입니다.',
  'pages.angelInsider.issues.feature-prompt-library.sections.0.blocks.1.p':
    '예를 들어 사건을 요약하는 프롬프트를 만들고 있다면, 예전에 직접 작성해 잘 알고 있는 사건 요약본을 기준으로 삼으세요. 요약 프롬프트를 실행한 뒤 A&GEL의 결과물을 이전 작업물과 견주어 보세요. 결과가 기준과 잘 맞아떨어진다면 프롬프트가 잘 다듬어진 것이고, 그렇지 않다면 어느 부분이 비었는지 짚어 내어 그에 맞게 프롬프트를 보완하세요 — 예컨대 컨텍스트를 더 추가하는 식으로요.',
  'pages.angelInsider.issues.feature-prompt-library.sections.0.blocks.2.p':
    '<strong>프롬프트를 개선하세요.</strong> 프롬프트 라이브러리에 있는 <em>Improve My Prompt v1.0</em> 도구로 프롬프트를 한층 더 다듬어 보세요.',
  'pages.angelInsider.issues.feature-prompt-library.sections.0.blocks.3.figure.caption':
    'Improve My Prompt v1.0 — 라이브러리에 있는 기존 프롬프트를 다듬습니다.',
  'pages.angelInsider.issues.feature-prompt-library.signoff.line':
    '복제하고, 다듬고, 잘 통한 것을 공유하세요.',
  'pages.angelInsider.issues.feature-prompt-library.signoff.name': 'A&GEL 개발팀',
  'pages.angelInsider.issues.feature-prompting.title': '프롬프트 작성',
  'pages.angelInsider.issues.feature-prompting.subtitle':
    '컨텍스트 없는 프롬프트는 추측입니다. 그것을 바꾸는 프레임워크가 여기 있습니다.',
  'pages.angelInsider.issues.feature-prompting.glance.0':
    '효과적인 프롬프트에는 늘 네 부분이 있습니다: <strong>페르소나, 과제, 컨텍스트, 형식</strong>.',
  'pages.angelInsider.issues.feature-prompting.glance.1':
    '컨텍스트는 오직 <em>여러분</em>만 제공할 수 있는 부분입니다 — 전문성이 차이를 만드는 지점이죠.',
  'pages.angelInsider.issues.feature-prompting.glance.2':
    '컨텍스트 없는 프롬프트는 “프롬프트 룰렛”입니다 — 형식은 갖췄지만 쓸 만한 결과가 나오기 어렵습니다.',
  'pages.angelInsider.issues.feature-prompting.glance.3':
    '라이브러리에서 프롬프트를 복제한 뒤, 사건의 구체적 사실관계와 법적 틀에 맞게 고쳐 쓰세요.',
  'pages.angelInsider.issues.feature-prompting.sections.0.kicker': '01 — 프레임워크',
  'pages.angelInsider.issues.feature-prompting.sections.0.heading':
    '페르소나, 과제, 컨텍스트, 형식',
  'pages.angelInsider.issues.feature-prompting.sections.0.blocks.0.p':
    '효과적인 프롬프트에는 늘 네 부분이 있습니다. 체크리스트로 생각해 보세요:',
  'pages.angelInsider.issues.feature-prompting.sections.0.blocks.1.p':
    '<strong>페르소나</strong> — A&GEL이 어떤 역할을 맡을지 알려 주세요. <em>“당신은 20년 경력의 소송 전문 변호사입니다.”</em> 이것이 결과물의 어조와 깊이, 구체성을 좌우합니다.',
  'pages.angelInsider.issues.feature-prompting.sections.0.blocks.2.p':
    '<strong>과제</strong> — 무엇을 해 주기를 바라는지 명확하고 구체적으로 설명하세요.',
  'pages.angelInsider.issues.feature-prompting.sections.0.blocks.3.p':
    '<strong>컨텍스트</strong> — 오직 여러분만 제공할 수 있는 부분입니다. 구체적인 법적 틀, 상업적 사실관계, 사건을 둘러싼 정황이 여기에 해당합니다. 컨텍스트 없는 프롬프트는 추측일 뿐이며, 팀에서는 이를 “프롬프트 룰렛”이라 부릅니다. A&GEL 결과물의 품질은 여러분이 제공한 컨텍스트의 품질에 정비례합니다.',
  'pages.angelInsider.issues.feature-prompting.sections.0.blocks.4.p':
    '<strong>형식</strong> — 결과물을 어떤 구조로 받고 싶은지 지정하세요. 번호 매긴 목록? 표? 조항 초안? 짧은 문단? 지정하지 않으면 A&GEL은 여러분의 업무 흐름에 맞지 않을 수도 있는 일반적인 형식을 기본으로 사용합니다.',
  'pages.angelInsider.issues.feature-prompting.sections.1.kicker': '02 — 실전 컨텍스트',
  'pages.angelInsider.issues.feature-prompting.sections.1.heading': '컨텍스트가 만드는 차이',
  'pages.angelInsider.issues.feature-prompting.sections.1.blocks.0.p':
    'A&GEL을 유능한 조력자로 생각하되, 최선의 결과를 내려면 전체 그림이 필요하다는 점을 기억하세요. 단순한 질문을 던지는 대신, 오직 여러분만 아는 구체적인 배경을 제공하세요 — 핵심 목표, 사건의 사실관계, 그리고 “좋은” 답변과 “나쁜” 답변이 어떤 모습인지까지요.',
  'pages.angelInsider.issues.feature-prompting.sections.1.blocks.1.p':
    '법률적 내용(예: 적용 법 영역의 짧은 요약)과 상업적 컨텍스트(예: 거래나 분쟁을 둘러싼 사실관계)를 많이 제공할수록 결과물이 더 쓸모 있어집니다. 그런 컨텍스트가 주어지면, 기본적인 프롬프트와 비교해 결과의 질이 확연히 달라집니다.',
  'pages.angelInsider.issues.feature-prompting.sections.1.blocks.2.callout.title': '사건 요약 사례',
  'pages.angelInsider.issues.feature-prompting.sections.1.blocks.2.callout.body':
    '사건 요약 프롬프트를 쓸 때는 관심 있는 법적 쟁점을 간단히 덧붙이세요 — 예를 들어 판결이유(ratio decidendi)와 방론(obiter dicta)의 구분 같은 것 말입니다. 라이브러리에서 프롬프트를 복제해 관심사에 맞게 고치면, 프롬프트를 그대로 쓸 때보다 결과가 훨씬 더 겨냥된 것이 됩니다.',
  'pages.angelInsider.issues.feature-prompting.sections.2.kicker': '03 — 시험 & 개선',
  'pages.angelInsider.issues.feature-prompting.sections.2.heading': '기준을 세우고 다듬기',
  'pages.angelInsider.issues.feature-prompting.sections.2.blocks.0.p':
    '이미 갖고 있는 “모범 답안”에 견주어 프롬프트를 시험해 보세요 — 직접 작성한 사건 요약이나 예전에 기초한 조항 같은 것 말입니다. 프롬프트를 실행해 결과물을 그 기준과 비교하세요. 서로 맞아떨어지면 프롬프트가 잘 다듬어진 것이고, 그렇지 않다면 비어 있는 부분을 짚어 그에 맞게 컨텍스트를 더하세요.',
  'pages.angelInsider.issues.feature-prompting.sections.2.blocks.1.p':
    '기대만큼 작동하지 않는 프롬프트는 프롬프트 라이브러리의 <strong>Improve My Prompt v1.0</strong> 도구로 더 다듬으세요.',
  'pages.angelInsider.issues.feature-prompting.signoff.line':
    '여러분의 컨텍스트는 여러분이 가장 잘 압니다 — 그것을 프롬프트에 담으세요.',
  'pages.angelInsider.issues.feature-prompting.signoff.name': 'A&GEL 개발팀',
  'pages.angelInsider.issues.feature-prompting.altCta.label':
    '프롬프트 라이브러리 더 알아보기 &rarr;',
  'pages.angelInsider.issues.feature-guided-summary.title': '빠른 정보 & 가이드 요약',
  'pages.angelInsider.issues.feature-guided-summary.subtitle':
    '어떤 문서든 빠르고 출처가 붙은 읽기 — 개요로든, 방향을 정해서든.',
  'pages.angelInsider.issues.feature-guided-summary.glance.0':
    '어떤 문서든 즉시 개요를 보려면 <strong>빠른 정보</strong>를 사용하세요.',
  'pages.angelInsider.issues.feature-guided-summary.glance.1':
    '<strong>가이드 요약</strong>(앱 메뉴)은 초점을 직접 잡을 수 있게 해 줍니다 — 라이브러리의 프롬프트와 함께 쓰세요.',
  'pages.angelInsider.issues.feature-guided-summary.glance.2':
    '문서를 업로드하고 프롬프트를 고른 뒤, 다뤄 주었으면 하는 구체적 쟁점을 덧붙이세요.',
  'pages.angelInsider.issues.feature-guided-summary.glance.3':
    '이제 더 빨라졌습니다 — 생성 중 <strong>중간 업데이트와 인라인 참조</strong>가 제공됩니다.',
  'pages.angelInsider.issues.feature-guided-summary.sections.0.kicker': '01 — 가이드 요약',
  'pages.angelInsider.issues.feature-guided-summary.sections.0.heading':
    '프롬프트로 방향을 잡은, 출처가 붙은 문서 요약',
  'pages.angelInsider.issues.feature-guided-summary.sections.0.blocks.0.p':
    '프롬프트 라이브러리에는 문서를 요약하는 프롬프트가 두 가지 있습니다 — 하나는 간결한 개요용, 다른 하나는 보다 상세한 분석용입니다. 싱가포르 법률아카데미(SAL)가 공개한 프롬프트를 바탕으로 생성형 AI를 활용해 다듬었습니다.',
  'pages.angelInsider.issues.feature-guided-summary.sections.0.blocks.1.p':
    '저희 경험상 <strong>상세형</strong> 요약이 대체로 더 우수하며, 특히 복잡한 문서에서 그렇습니다. A&GEL은 원문에만 <em>전적으로</em> 의존하도록 지시받습니다 — 다만 판례에서는 <em>판결이유(ratio decidendi)</em>와 <em>방론(obiter dicta)</em>을 구분하는 데 어려움을 겪을 수 있습니다.',
  'pages.angelInsider.issues.feature-guided-summary.sections.0.blocks.2.callout.title':
    '만능 해법은 아닙니다',
  'pages.angelInsider.issues.feature-guided-summary.sections.0.blocks.2.callout.body':
    '결과물은 여전히 평소와 같은 방식으로 검토하고 확인해야 합니다 — 정확성과 완전성을 꼼꼼히 점검하세요. 이 프롬프트들은 효율적인 출발점을 제공할 뿐, 완성된 결과물이 아닙니다.',
  'pages.angelInsider.issues.feature-guided-summary.sections.0.blocks.3.p':
    '(앱 메뉴의) <strong>가이드 요약</strong> 기능을 사용하면 단일 문서에 어떤 프롬프트든 적용할 수 있습니다. 파일을 업로드하고 라이브러리에서 프롬프트를 고른 뒤, 특별히 신경 쓰이는 쟁점을 덧붙이세요.',
  'pages.angelInsider.issues.feature-guided-summary.sections.0.blocks.4.figure.caption':
    '프롬프트 라이브러리의 사건 요약(간결형) v1.1과 사건 요약(상세형) v1.1.',
  'pages.angelInsider.issues.feature-guided-summary.sections.1.kicker': '02 — 속도 & 업데이트',
  'pages.angelInsider.issues.feature-guided-summary.sections.1.heading':
    '중간 업데이트와 함께 더 빨라진 생성',
  'pages.angelInsider.issues.feature-guided-summary.sections.1.blocks.0.p':
    '가이드 요약은 이제 생성 도중 <strong>인라인 참조가 포함된 중간 업데이트</strong>를 제공합니다 — 각 섹션이 차례로 도착하는 것을 보면서, 전체 결과가 완성되기 전에 인용을 대조하기 시작할 수 있습니다.',
  'pages.angelInsider.issues.feature-guided-summary.sections.1.blocks.1.p':
    '전반적인 출력 속도도 빨라졌습니다. 참고: 비교적 단순한 문서라면 요약이 충분히 빨리 로드되어 중간 업데이트가 아예 생략될 수 있습니다.',
  'pages.angelInsider.issues.feature-guided-summary.signoff.line':
    '개요가 필요하면 빠른 정보, 초점을 잡고 싶으면 가이드 요약.',
  'pages.angelInsider.issues.feature-guided-summary.signoff.name': 'A&GEL 개발팀',
  'pages.angelInsider.issues.feature-vault.title': '나의 보관함',
  'pages.angelInsider.issues.feature-vault.subtitle':
    '보관함은 A&GEL 위에 올려둔 여러분의 두뇌입니다 — 잘 가꿔 두면 AI의 결과물도 그만큼 날카로워집니다.',
  'pages.angelInsider.issues.feature-vault.glance.0':
    'A&GEL은 인터넷을 검색하지 <strong>않습니다</strong> — 오직 여러분의 보관함 안에서만 작동합니다.',
  'pages.angelInsider.issues.feature-vault.glance.1':
    '<strong>컨텍스트가 전부입니다</strong>: 정확하고 선별적인 업로드가 정확하고 신뢰할 만한 결과를 만듭니다.',
  'pages.angelInsider.issues.feature-vault.glance.2':
    '폴더 구조는 그 자체가 메타데이터입니다 — AI를 올바른 관점으로 이끌어 줍니다.',
  'pages.angelInsider.issues.feature-vault.glance.3':
    '<strong>참조 파일 가중치</strong>와 <strong>세션 파일 가중치</strong>로 A&GEL이 무엇을 우선할지 미세 조정하세요.',
  'pages.angelInsider.issues.feature-vault.sections.0.kicker': '01 — 두뇌',
  'pages.angelInsider.issues.feature-vault.sections.0.heading':
    '보관함은 A&GEL 위에 올려둔 여러분의 두뇌입니다',
  'pages.angelInsider.issues.feature-vault.sections.0.blocks.0.p':
    '보관함은 A&GEL의 주된 컨텍스트 원천으로 설계되었습니다. 확률에 기반한 AI의 결과물을 여러분이 신뢰하고 선별해 둔 지식 기반에 단단히 묶어 두는 역할을 합니다.',
  'pages.angelInsider.issues.feature-vault.sections.0.blocks.1.p':
    '<strong>A&GEL이 답을 찾으려고 인터넷을 검색하나요?</strong> 아니요. A&GEL은 엄격히 보관함의 범위 안에서만 작동하며, 여러분이 업로드하고 정리한 문서에만 전적으로 의존합니다. 이는 세 가지 목적을 위한 의도적인 설계 선택입니다: 결과물의 정확성 확보, 보안 유지, 그리고 고유 지식 기반의 무결성 보존입니다.',
  'pages.angelInsider.issues.feature-vault.sections.0.blocks.2.p':
    'A&GEL은 웹에서 검증되지 않은 정보를 끌어오는 대신, 오직 보관함만을 유일한 사실의 원천으로 삼습니다. 보관함이 잘 정리되어 있다면 A&GEL의 기능들은 여러분이 인정하는 선례, 여러분이 검증한 사실, 여러분이 지지하는 전략 위에 놓이게 됩니다. A&GEL이 질문에 답할 때 그것은 일반 상식에서 추측하는 것이 아니라, 여러분의 구체적이고 권위 있는 자료에서 통찰을 종합해 내는 것입니다.',
  'pages.angelInsider.issues.feature-vault.sections.1.kicker': '02 — 업로드',
  'pages.angelInsider.issues.feature-vault.sections.1.heading': '무엇을, 어떻게 업로드할까',
  'pages.angelInsider.issues.feature-vault.sections.1.blocks.0.p':
    '<strong>무엇을 업로드할 수 있나요?</strong> Word 문서, PDF, 이메일이면 무엇이든 가능합니다. 다른 파일 형식은 준비 중입니다.',
  'pages.angelInsider.issues.feature-vault.sections.1.blocks.1.p':
    '<strong>어떻게 하나요?</strong> 개별 파일이나 폴더 전체를 파일 화면에 끌어다 놓거나, 업로드 버튼을 클릭하세요.',
  'pages.angelInsider.issues.feature-vault.sections.1.blocks.2.figure.caption':
    '파일이나 폴더를 파일 화면에 바로 끌어다 놓으세요.',
  'pages.angelInsider.issues.feature-vault.sections.1.blocks.3.callout.title':
    '쓰레기를 넣으면 쓰레기가 나옵니다',
  'pages.angelInsider.issues.feature-vault.sections.1.blocks.3.callout.body':
    'A&GEL을 마법의 신탁이 아니라, 여러분이 올린 모든 것을 읽어 둔 지치지 않는 동료로 생각하세요. 그 동료에게 관련 없는 서류가 잔뜩 쌓인 어수선한 책상을 내밀면 결과물은 뒤죽박죽이 되기 쉽습니다. 반면 딱 맞는 선례 하나를 건네면 결과물은 훨씬 날카로워집니다. 이것이 A&GEL 활용의 핵심 진실입니다: <strong>컨텍스트가 전부입니다.</strong>',
  'pages.angelInsider.issues.feature-vault.sections.2.kicker': '03 — 구조',
  'pages.angelInsider.issues.feature-vault.sections.2.heading': '폴더 구조를 갖추세요',
  'pages.angelInsider.issues.feature-vault.sections.2.blocks.0.p':
    '폴더 구조는 단정함만을 위한 것이 아닙니다 — AI를 이끄는 메타데이터입니다. “매도인” 선례와 “고객” 선례를 나누듯 파일을 논리적인 하위 폴더로 정리해 두면, A&GEL이 올바른 관점을 찾아오는 데 도움이 됩니다.',
  'pages.angelInsider.issues.feature-vault.sections.2.blocks.1.figure.caption':
    '하위 폴더로 들어가기 — “실시권자”와 “허락권자” 선례를 나눠 두면 컨텍스트가 깔끔하게 유지됩니다.',
  'pages.angelInsider.issues.feature-vault.sections.2.blocks.2.p':
    '<strong>“전부 업로드” 함정을 피하세요.</strong> 자료 전체를 폴더 하나에 쏟아붓고 AI에게 알아서 하라고 맡기고 싶은 유혹이 들 수 있습니다. 그러지 마세요. A&GEL은 검색 증강 생성(RAG)을 사용하므로, 여러분이 올린 파일에서 답을 끌어옵니다. 생성형 AI는 사실을 “이해”하지 않고 확률을 예측합니다. 관련 없는 잡음을 넣으면 신호가 희석됩니다. 결과는 덜 정확하고, 덜 정밀하며, 덜 신뢰할 만한 출력입니다. 프롬프트와 관련된 문서나 폴더를 항상 직접 골라 주세요.',
  'pages.angelInsider.issues.feature-vault.sections.3.kicker': '04 — 미세 조정',
  'pages.angelInsider.issues.feature-vault.sections.3.heading': '신호를 미세 조정하기',
  'pages.angelInsider.issues.feature-vault.sections.3.blocks.0.p':
    'A&GEL은 이 과정을 조절할 수 있는 다이얼을 제공합니다. <strong>참조 파일 가중치</strong>로 여러분이 인용한 특정 문서를 우선하도록 만들고, <strong>세션 파일 가중치</strong>로 그 대화만을 위해 올린 파일의 비중을 높이세요.',
  'pages.angelInsider.issues.feature-vault.sections.3.blocks.1.p':
    '끝으로 기억하세요: A&GEL은 출발점입니다 — 초기 생각을 다듬는 브레인스토밍 파트너이자 협업 공간이지, 결승선이 아닙니다. 결과물은 항상 응답에 링크된 원본 문서와 대조해 확인하세요.',
  'pages.angelInsider.issues.feature-vault.sections.3.blocks.2.callout.title': '결론',
  'pages.angelInsider.issues.feature-vault.sections.3.blocks.2.callout.body':
    '보관함을 쓰레기 매립장이 아니라 잘 큐레이션된 서재처럼 다루세요. 문서를 어디에 두었는지 파악하고 컨텍스트를 선별하면, A&GEL은 시끄러운 챗봇에서 정밀한 조력자로 바뀝니다.',
  'pages.angelInsider.issues.feature-vault.signoff.line': '보관함을 가꾸고, 컨텍스트를 다스리세요.',
  'pages.angelInsider.issues.feature-vault.signoff.name': 'A&GEL 개발팀',
  'pages.angelInsider.issues.feature-vault.cta.label': '기본으로 돌아가기 →',
  'pages.angelInsider.issues.issue-3.title': '새로운 타임라인 및 다단계 프롬프트 앱',
  'pages.angelInsider.issues.issue-3.subtitle':
    '.msg 업로드, 더 똑똑해진 스크라이브, 구조화된 다단계 프롬프트, 그리고 대폭 개편된 타임라인.',
  'pages.angelInsider.issues.issue-3.date': '2026년 3월 18일',
  'pages.angelInsider.issues.issue-3.glance.0':
    '이제 <strong>이메일 파일(.msg)</strong>을 업로드해 첨부 파일까지 전부 읽어 들일 수 있습니다.',
  'pages.angelInsider.issues.issue-3.glance.1':
    '<strong>스크라이브</strong>가 실시간 편집, 오디오 재생, 1분 단위 자동 저장을 지원합니다.',
  'pages.angelInsider.issues.issue-3.glance.2':
    '새로운 <strong>다단계 프롬프트</strong> 모드가 복잡한 법률 업무 흐름을 목표가 분명한 단계로 나눠 줍니다.',
  'pages.angelInsider.issues.issue-3.glance.3':
    '<strong>타임라인</strong>이 개편되어 여러 문서의 시간순 정리를 하나로 합칩니다.',
  'pages.angelInsider.issues.issue-3.sections.0.kicker': '01 — 파일',
  'pages.angelInsider.issues.issue-3.sections.0.heading': '이메일 파일(.msg) 업로드하기',
  'pages.angelInsider.issues.issue-3.sections.0.blocks.0.p':
    '이제 A&GEL 사용자는 <strong>.msg</strong> 이메일 파일 전체를 파일에 업로드해 채팅이나 전문 모드에서 활용할 수 있습니다. A&GEL은 첨부 파일을 포함한 모든 내용을 읽습니다 — 다만 <em>내부 전용</em> 민감도 레이블이 붙었거나 암호로 보호된 첨부 파일은 제외됩니다.',
  'pages.angelInsider.issues.issue-3.sections.0.blocks.1.p':
    '업로드한 뒤에는 A&GEL에게 이메일을 요약하게 하거나, 첨부 문서를 요약하게 하거나, 라이브러리의 어떤 프롬프트든 그 파일에 적용해 실행할 수 있습니다.',
  'pages.angelInsider.issues.issue-3.sections.1.kicker': '02 — 스크라이브',
  'pages.angelInsider.issues.issue-3.sections.1.heading': '스크라이브: 실시간 편집과 오디오 재생',
  'pages.angelInsider.issues.issue-3.sections.1.blocks.0.p':
    '<strong>실시간 편집</strong> — 개선된 스크라이브에서는 전사본을 편집할 수 있으며, 편집된 부분은 확인하기 쉽도록 밑줄로 표시됩니다. <strong>오디오 재생</strong> — 전사본이 저장된 뒤 원본 전사본을 열고 아무 구간이나 클릭하면 그 지점부터 녹음이 재생됩니다.',
  'pages.angelInsider.issues.issue-3.sections.1.blocks.1.gallery.0.caption':
    '실시간 전사와 함께 진행 중인 스크라이브 녹음.',
  'pages.angelInsider.issues.issue-3.sections.1.blocks.1.gallery.1.caption':
    '원본 전사본 — 구간을 클릭하면 해당 오디오가 재생됩니다.',
  'pages.angelInsider.issues.issue-3.sections.2.kicker': '03 — 새 모드',
  'pages.angelInsider.issues.issue-3.sections.2.heading': '다단계 프롬프트',
  'pages.angelInsider.issues.issue-3.sections.2.blocks.0.p':
    '<strong>전문 앱</strong>에서 찾을 수 있습니다. 단발성 프롬프트는 간단한 질문에 효율적이지만, 복잡한 법률 업무는 구조화된 반복적 접근에서 더 큰 효과를 봅니다. 다단계 프롬프트는 문제를 목표가 분명한 상호작용의 연속으로 분해하게 해 줍니다 — 중간에서 높은 난도의 문서 작업에 저희가 가장 즐겨 쓰는 모드입니다.',
  'pages.angelInsider.issues.issue-3.sections.2.blocks.1.h': '업무 흐름을 논리적 단계로 나누기',
  'pages.angelInsider.issues.issue-3.sections.2.blocks.2.steps.0.n': '기업법무 · 1단계',
  'pages.angelInsider.issues.issue-3.sections.2.blocks.2.steps.0.text':
    '각 당사자가 무엇을 이행할 의무가 있는지 요약하라.',
  'pages.angelInsider.issues.issue-3.sections.2.blocks.2.steps.1.n': '2단계',
  'pages.angelInsider.issues.issue-3.sections.2.blocks.2.steps.1.text':
    '그 요약을 바탕으로, 일방에게만 유리하거나 이례적인 조항을 표시하라.',
  'pages.angelInsider.issues.issue-3.sections.2.blocks.2.steps.2.n': '3단계',
  'pages.angelInsider.issues.issue-3.sections.2.blocks.2.steps.2.text':
    '표시된 조항에 대해, 내가 [당사자]를 대리한다면 관철해야 할 상위 다섯 가지 수정 사항을 수정 표시로 제시하라.',
  'pages.angelInsider.issues.issue-3.sections.2.blocks.3.steps.0.n': '소송 · 1단계',
  'pages.angelInsider.issues.issue-3.sections.2.blocks.3.steps.0.text':
    '[첨부된] 소장을 바탕으로 첫 번째 질문서를 작성하라.',
  'pages.angelInsider.issues.issue-3.sections.2.blocks.3.steps.1.n': '2단계',
  'pages.angelInsider.issues.issue-3.sections.2.blocks.3.steps.1.text':
    '1단계를 마친 뒤, 그에 대응하는 문서제출요구서를 작성하라.',
  'pages.angelInsider.issues.issue-3.sections.2.blocks.3.steps.2.n': '3단계',
  'pages.angelInsider.issues.issue-3.sections.2.blocks.3.steps.2.text':
    '마지막 단계로, 관련 문서를 보유하고 있을 가능성이 높은 상위 다섯 명의 보관자를 찾아내고 그 이유를 설명하라.',
  'pages.angelInsider.issues.issue-3.sections.2.blocks.4.callout.title':
    '프롬프트가 하나뿐이어도 쓰세요',
  'pages.angelInsider.issues.issue-3.sections.2.blocks.4.callout.body':
    '단계가 하나뿐이더라도, 이 앱은 문서에 대해 수행해야 하는 복잡한 단일 프롬프트에 아주 훌륭합니다 — 채팅 모드보다 나은 경우가 많습니다.',
  'pages.angelInsider.issues.issue-3.sections.2.blocks.5.figure.caption':
    '다단계 프롬프트 결과 — 참조를 클릭하면 강조 표시가 된 인라인 문서 뷰어가 열립니다.',
  'pages.angelInsider.issues.issue-3.sections.3.kicker': '04 — 타임라인',
  'pages.angelInsider.issues.issue-3.sections.3.heading': '대폭 개편된 타임라인',
  'pages.angelInsider.issues.issue-3.sections.3.blocks.0.p':
    '<strong>여러 문서의 타임라인을 하나로.</strong> 개편된 타임라인은 선택한 각 문서에서 시간순 정리를 뽑아내 하나로 합칩니다 — 각자 별도의 시간 흐름을 지닌 방대한 진술서·서면·의견서가 여러 건일 때 특히 유용합니다.',
  'pages.angelInsider.issues.issue-3.sections.3.blocks.1.gallery.0.caption':
    '파일 다섯 개를 아우른 소장 & 답변서 통합 타임라인.',
  'pages.angelInsider.issues.issue-3.sections.3.blocks.1.gallery.1.caption':
    '출처 참조와 함께 단일 문서의 타임라인을 자세히 들여다보기.',
  'pages.angelInsider.issues.issue-3.sections.3.blocks.2.p':
    '<strong>출처를 확인하세요.</strong> 각 사건 끝의 참조를 클릭하면 원본 문서가 열리고 해당 문장이 강조 표시됩니다.',
  'pages.angelInsider.issues.issue-3.sections.3.blocks.3.h': '사건에 맞게 조율되는 스마트 타임라인',
  'pages.angelInsider.issues.issue-3.sections.3.blocks.4.p':
    '문서를 고른 뒤 <strong>프롬프트 확장</strong>을 클릭하면 관심 주제 중심으로 추출 범위를 좁힐 수 있습니다. <em>Basic Litigation(공유)</em> 구성은 사건 설명, 출처 문서, 관련 주체/인물, 근거 문단을 추출합니다 — 직접 항목을 추가할 수도 있습니다.',
  'pages.angelInsider.issues.issue-3.sections.3.blocks.5.callout.title': '메시지에도 통합니다',
  'pages.angelInsider.issues.issue-3.sections.3.blocks.5.callout.body':
    '채팅 기록이나 메시지 스크린샷(WhatsApp, WeChat)에 타임라인을 적용해 시간 흐름을 만들어 보세요.',
  'pages.angelInsider.issues.issue-3.signoff.line': '단계는 잘게, 시간 흐름은 또렷하게.',
  'pages.angelInsider.issues.issue-3.signoff.name': 'A&GEL 개발팀',
  'pages.angelInsider.issues.feature-dispute.title': '분쟁 해결',
  'pages.angelInsider.issues.feature-dispute.subtitle':
    '사건 요약, 소장 분석, 답변서 작성, 소송 서면 추적 — 모두 A&GEL 안에서.',
  'pages.angelInsider.issues.feature-dispute.glance.0':
    '<strong>사건 요약</strong> — 복잡한 판결에서는 대체로 상세형이 간결형보다 낫습니다.',
  'pages.angelInsider.issues.feature-dispute.glance.1':
    '<strong>소장 분석</strong> — 소장을 업로드하고 분석 프롬프트를 바로 실행하세요.',
  'pages.angelInsider.issues.feature-dispute.glance.2':
    '<strong>답변서 작성</strong> — 소장을 바탕으로 답변서 초안을 생성합니다.',
  'pages.angelInsider.issues.feature-dispute.glance.3':
    '<strong>소송 서면 추적기</strong> — 검토 모드가 전체 문서 세트에 걸쳐 각 청구원인과 각 당사자의 입장을 대응시켜 줍니다.',
  'pages.angelInsider.issues.feature-dispute.sections.0.kicker': '01 — 사건 요약',
  'pages.angelInsider.issues.feature-dispute.sections.0.heading': '판결문과 소송 서면 요약하기',
  'pages.angelInsider.issues.feature-dispute.sections.0.blocks.0.p':
    '프롬프트 라이브러리에는 사건 요약 프롬프트가 두 가지 있습니다 — 간결형과 상세형입니다. 저희 경험상 <strong>상세형</strong>이 대체로 더 우수하며, 특히 복잡한 판결에서 그렇습니다. A&GEL은 원본 문서에만 전적으로 의존하도록 지시받습니다.',
  'pages.angelInsider.issues.feature-dispute.sections.0.blocks.1.figure.caption':
    '프롬프트 라이브러리의 사건 요약(간결형) v1.1과 사건 요약(상세형) v1.1.',
  'pages.angelInsider.issues.feature-dispute.sections.1.kicker': '02 — 소장 & 답변서',
  'pages.angelInsider.issues.feature-dispute.sections.1.heading': '소장 분석과 답변서 작성',
  'pages.angelInsider.issues.feature-dispute.sections.1.blocks.0.p':
    '초기 사건 평가에는 <strong>소장 분석 및 시간순 정리</strong> 프롬프트를 사용하세요. 소장을 업로드하고 프롬프트를 실행하면 — A&GEL이 핵심 사실관계와 청구원인, 그리고 시간순 정리를 뽑아냅니다.',
  'pages.angelInsider.issues.feature-dispute.sections.1.blocks.1.p':
    '첫 답변서를 작성하려면 라이브러리의 <strong>소장에 대한 답변서 초안 작성</strong> 프롬프트를 사용하세요. 복제한 뒤 컨텍스트를 사건에 맞게 고치면 됩니다.',
  'pages.angelInsider.issues.feature-dispute.sections.1.blocks.2.callout.title':
    '간결형보다 상세형',
  'pages.angelInsider.issues.feature-dispute.sections.1.blocks.2.callout.body':
    '복잡한 판결이나 분량이 많은 소장에서는 상세형 요약이 한결같이 더 정확하고 완전한 결과를 냅니다.',
  'pages.angelInsider.issues.feature-dispute.sections.2.kicker': '03 — 소송 서면 추적기',
  'pages.angelInsider.issues.feature-dispute.sections.2.heading': '검토 모드를 소송 서면 추적기로',
  'pages.angelInsider.issues.feature-dispute.sections.2.blocks.0.p':
    '검토 모드는 질문 목록을 여러 문서에 동시에 적용합니다. 분쟁 해결 업무라면 소장과 답변서, 준비서면을 불러오고 청구원인마다 질문을 하나씩 정의하세요. A&GEL이 각 당사자의 입장을 하나의 표에 정리해 줍니다.',
  'pages.angelInsider.issues.feature-dispute.sections.2.blocks.1.figure.caption':
    'Lim Group 사건: 파일 5건에 걸쳐 사기 및 위법행위 주장을 추적하는 검토 모드.',
  'pages.angelInsider.issues.feature-dispute.signoff.line': '더 빠른 사건 평가, 더 나은 준비.',
  'pages.angelInsider.issues.feature-dispute.signoff.name': 'A&GEL 개발팀',
  'pages.angelInsider.issues.feature-sidebyside.title': '나란히 보기 & 비교',
  'pages.angelInsider.issues.feature-sidebyside.subtitle':
    '가장 세밀한 검토 모드 — 조항 단위로, 원문 단락까지 완전하게 확인하며.',
  'pages.angelInsider.issues.feature-sidebyside.glance.0':
    '<strong>나란히 보기</strong>는 조항 단위로 진행되며, 모든 지적 사항마다 원문 단락을 완전하게 확인할 수 있습니다.',
  'pages.angelInsider.issues.feature-sidebyside.glance.1':
    '<strong>비교</strong>는 변경 내용 추적이나 문서 수정본에 대한 1차 법률 검토를 생성합니다.',
  'pages.angelInsider.issues.feature-sidebyside.glance.2':
    '모든 지적 사항이 정확한 원문 조항으로 연결됩니다 — 문서를 뒤질 필요가 없습니다.',
  'pages.angelInsider.issues.feature-sidebyside.glance.3':
    '<strong>미니 채팅 창</strong>을 이제 옮기고 크기도 조절할 수 있습니다 — 작업 화면을 가리지 않게 끌어다 두세요.',
  'pages.angelInsider.issues.feature-sidebyside.sections.0.kicker': '01 — 나란히 보기',
  'pages.angelInsider.issues.feature-sidebyside.sections.0.heading':
    '원문 확인이 곁들여진 조항별 분석',
  'pages.angelInsider.issues.feature-sidebyside.sections.0.blocks.0.p':
    '나란히 보기는 A&GEL에서 가장 세밀한 검토 모드입니다. 문서를 조항 단위로 훑어 가며, 지적 사항마다 정확한 원문 단락을 함께 보여 줍니다 — 그래서 결과물을 원본과 곧바로 대조해 확인할 수 있습니다.',
  'pages.angelInsider.issues.feature-sidebyside.sections.0.blocks.1.figure.caption':
    '주식매매계약(SPA)의 나란히 보기 분석 — 각 지적 사항이 원문 조항으로 연결됩니다.',
  'pages.angelInsider.issues.feature-sidebyside.sections.0.blocks.2.figure.caption':
    '설명 패널 — A&GEL의 논거가 원문 옆에 나란히 표시됩니다.',
  'pages.angelInsider.issues.feature-sidebyside.sections.1.kicker': '02 — 비교',
  'pages.angelInsider.issues.feature-sidebyside.sections.1.heading':
    '변경 내용 추적에 대한 1차 검토',
  'pages.angelInsider.issues.feature-sidebyside.sections.1.blocks.0.p':
    '<strong>비교</strong>는 변경 내용 추적이나 문서 수정본에 대한 1차 법률 검토를 생성합니다. 수정된 문서를 업로드하면 A&GEL이 무엇이 바뀌었고 어떤 의미가 있는지 구조화된 분석을 내놓습니다.',
  'pages.angelInsider.issues.feature-sidebyside.sections.1.blocks.1.callout.title':
    '완성품이 아니라 출발점입니다',
  'pages.angelInsider.issues.feature-sidebyside.sections.1.blocks.1.callout.body':
    '나란히 보기와 비교의 결과물은 효율적인 출발점입니다 — 최종 확정 전에 반드시 원문과 대조해 확인하세요.',
  'pages.angelInsider.issues.feature-sidebyside.sections.2.kicker': '03 — 미니 채팅',
  'pages.angelInsider.issues.feature-sidebyside.sections.2.heading':
    '옮길 수 있는 미니 채팅 인터페이스',
  'pages.angelInsider.issues.feature-sidebyside.sections.2.blocks.0.p':
    '검토, 비교, 나란히 보기 모두 <strong>미니 채팅 창</strong>을 갖추고 있어, 문서와 A&GEL의 결과물에 대해 동시에 질문할 수 있습니다. 이 창은 이제 <strong>옮기고 크기도 조절할 수 있어</strong> — 검토 중인 결과물을 가리지 않도록 화면 어디로든 끌어다 놓을 수 있습니다.',
  'pages.angelInsider.issues.feature-sidebyside.signoff.line': '조항 하나하나, 원문으로 확인.',
  'pages.angelInsider.issues.feature-sidebyside.signoff.name': 'A&GEL 개발팀',
  'pages.angelInsider.issues.feature-multistep.title': '다단계 프롬프트',
  'pages.angelInsider.issues.feature-multistep.subtitle':
    '복잡한 법률 업무를 순차적인 단계로 나누세요 — 각 단계가 앞 단계 위에 쌓입니다.',
  'pages.angelInsider.issues.feature-multistep.glance.0':
    '<strong>전문 앱</strong>에서 찾을 수 있습니다.',
  'pages.angelInsider.issues.feature-multistep.glance.1':
    '각 단계는 앞 단계의 결과물 위에 쌓입니다 — 복잡한 업무 흐름에 안성맞춤입니다.',
  'pages.angelInsider.issues.feature-multistep.glance.2':
    '다단계 업무 흐름은 물론, 문서에 대한 복잡한 단일 프롬프트에도 <em>모두</em> 잘 맞습니다.',
  'pages.angelInsider.issues.feature-multistep.glance.3':
    '결과물에 인라인 출처 참조가 포함됩니다 — 클릭하면 강조 표시된 원문이 열립니다.',
  'pages.angelInsider.issues.feature-multistep.sections.0.kicker': '01 — 시작하기',
  'pages.angelInsider.issues.feature-multistep.sections.0.heading':
    '복잡한 법률 업무를 위한 구조화된 모드',
  'pages.angelInsider.issues.feature-multistep.sections.0.blocks.0.p':
    '<strong>전문 앱</strong>에서 찾을 수 있습니다. 다단계 프롬프트는 법률 문제를 목표가 분명한 단계들의 연속으로 분해하게 해 주며, 각 단계는 앞 단계 위에 쌓입니다. 다단계 업무 흐름은 물론, 문서 수준의 정밀함이 필요한 복잡한 단일 프롬프트에도 잘 맞습니다.',
  'pages.angelInsider.issues.feature-multistep.sections.0.blocks.1.figure.caption':
    '전문 앱 목록에 있는 다단계 프롬프트.',
  'pages.angelInsider.issues.feature-multistep.sections.1.kicker': '02 — 예시',
  'pages.angelInsider.issues.feature-multistep.sections.1.heading':
    '업무 흐름을 논리적 단계로 나누기',
  'pages.angelInsider.issues.feature-multistep.sections.1.blocks.0.steps.0.n': '기업법무 · 1단계',
  'pages.angelInsider.issues.feature-multistep.sections.1.blocks.0.steps.0.text':
    '각 당사자가 무엇을 이행할 의무가 있는지 요약하라.',
  'pages.angelInsider.issues.feature-multistep.sections.1.blocks.0.steps.1.n': '2단계',
  'pages.angelInsider.issues.feature-multistep.sections.1.blocks.0.steps.1.text':
    '그 요약을 바탕으로, 일방에게만 유리하거나 이례적인 조항을 표시하라.',
  'pages.angelInsider.issues.feature-multistep.sections.1.blocks.0.steps.2.n': '3단계',
  'pages.angelInsider.issues.feature-multistep.sections.1.blocks.0.steps.2.text':
    '표시된 조항에 대해, 내가 [당사자]를 대리한다면 관철해야 할 상위 다섯 가지 수정 사항을 수정 표시로 제시하라.',
  'pages.angelInsider.issues.feature-multistep.sections.1.blocks.1.steps.0.n': '소송 · 1단계',
  'pages.angelInsider.issues.feature-multistep.sections.1.blocks.1.steps.0.text':
    '[첨부된] 소장을 바탕으로 첫 번째 질문서를 작성하라.',
  'pages.angelInsider.issues.feature-multistep.sections.1.blocks.1.steps.1.n': '2단계',
  'pages.angelInsider.issues.feature-multistep.sections.1.blocks.1.steps.1.text':
    '1단계를 마친 뒤, 그에 대응하는 문서제출요구서를 작성하라.',
  'pages.angelInsider.issues.feature-multistep.sections.1.blocks.1.steps.2.n': '3단계',
  'pages.angelInsider.issues.feature-multistep.sections.1.blocks.1.steps.2.text':
    '관련 문서를 보유하고 있을 가능성이 높은 상위 다섯 명의 보관자를 찾아내고 그 이유를 설명하라.',
  'pages.angelInsider.issues.feature-multistep.sections.1.blocks.2.callout.title':
    '프롬프트가 하나뿐이어도 쓰세요',
  'pages.angelInsider.issues.feature-multistep.sections.1.blocks.2.callout.body':
    '단계가 하나뿐이더라도, 이 앱은 문서에 대한 복잡한 프롬프트에 아주 훌륭합니다 — 채팅 모드보다 나은 경우가 많습니다.',
  'pages.angelInsider.issues.feature-multistep.sections.1.blocks.3.figure.caption':
    '다단계 프롬프트 결과 — 참조를 클릭하면 강조 표시가 된 인라인 문서 뷰어가 열립니다.',
  'pages.angelInsider.issues.feature-multistep.sections.2.kicker': '03 — 실전 예시',
  'pages.angelInsider.issues.feature-multistep.sections.2.heading':
    '문서 두 건을 아우르는 보고서 작성',
  'pages.angelInsider.issues.feature-multistep.sections.2.blocks.0.p':
    '문서 두 건에서 우려 사항을 뽑아내 요약문이 딸린 하나의 보고서로 합치는 3단계 업무 흐름입니다 — 채팅 프롬프트 하나로는 안정적으로 해내기 어려운 작업이죠.',
  'pages.angelInsider.issues.feature-multistep.sections.2.blocks.1.callout.title': '1단계 — 추출',
  'pages.angelInsider.issues.feature-multistep.sections.2.blocks.1.callout.body':
    '<strong>입력 컨텍스트:</strong> [문서 1과 문서 2의 본문을 넣으세요]<br><strong>프롬프트:</strong> “제공된 텍스트를 읽어라. 두 문서에 언급된 모든 우려 사항, 쟁점, 위험을 빠짐없이 개조식 목록으로 추출하라.”<br><em>결과: 정돈되고 통합된 우려 사항 목록.</em>',
  'pages.angelInsider.issues.feature-multistep.sections.2.blocks.2.callout.title':
    '2단계 — 본 보고서 작성',
  'pages.angelInsider.issues.feature-multistep.sections.2.blocks.2.callout.body':
    '<strong>입력 컨텍스트:</strong> [1단계의 결과]<br><strong>프롬프트:</strong> “제공된 우려 사항 목록을 사용해 상세한 격식 있는 보고서를 작성하라. 비슷한 우려 사항은 알맞은 제목 아래로 묶어라. 이 단계에서는 머리말이나 요약문을 넣지 마라.”<br><em>결과: 구조를 갖춘 본 보고서 전체.</em>',
  'pages.angelInsider.issues.feature-multistep.sections.2.blocks.3.callout.title':
    '3단계 — 요약문 & 최종 취합',
  'pages.angelInsider.issues.feature-multistep.sections.2.blocks.3.callout.body':
    '<strong>입력 컨텍스트:</strong> [2단계의 결과]<br><strong>프롬프트:</strong> “제공된 보고서를 읽어라. 먼저 한 문단짜리 간결한 요약문을 작성하라. 그런 다음 요약문을 출력하고 시각적 구분선을 넣은 뒤, 그 아래에 보고서 전문을 그대로 출력해 하나로 합쳐진 문서를 만들어라.”<br><em>결과: 최종 통합 문서.</em>',
  'pages.angelInsider.issues.feature-multistep.signoff.line': '단계는 잘게, 결과는 날카롭게.',
  'pages.angelInsider.issues.feature-multistep.signoff.name': 'A&GEL 개발팀',
  'pages.angelInsider.issues.feature-timeline.title': '타임라인',
  'pages.angelInsider.issues.feature-timeline.subtitle':
    '최대 100건의 문서에 흩어진 시간 순서를 원문이 확인된 하나의 타임라인으로 통합합니다.',
  'pages.angelInsider.issues.feature-timeline.glance.0':
    '<strong>최대 100건의 문서</strong>에서 뽑은 시간 순서를 하나의 타임라인으로 합칩니다.',
  'pages.angelInsider.issues.feature-timeline.glance.1':
    '<strong>클릭 가능한 인라인 인용</strong> — 참조를 클릭하면 해당 대목이 강조된 원문이 열립니다.',
  'pages.angelInsider.issues.feature-timeline.glance.2':
    '<strong>스마트 타임라인</strong>으로 관련 주체, 근거 문단 등 원하는 항목을 직접 추출할 수 있습니다.',
  'pages.angelInsider.issues.feature-timeline.glance.3':
    '채팅 기록과 메시지 스크린샷(WhatsApp, WeChat)에도 통합니다.',
  'pages.angelInsider.issues.feature-timeline.sections.0.kicker': '01 — 통합 타임라인',
  'pages.angelInsider.issues.feature-timeline.sections.0.heading':
    '여러 문서를 아우르는 시간순 정리',
  'pages.angelInsider.issues.feature-timeline.sections.0.blocks.0.p':
    '개편된 타임라인은 선택한 각 문서에서 시간순 정리를 뽑아내 하나로 합칩니다 — 각자 별도의 시간 흐름을 지닌 방대한 진술서·서면·의견서가 여러 건일 때 특히 유용합니다.',
  'pages.angelInsider.issues.feature-timeline.sections.0.blocks.1.gallery.0.caption':
    '파일 다섯 개를 아우른 소장 & 답변서 통합 타임라인.',
  'pages.angelInsider.issues.feature-timeline.sections.0.blocks.1.gallery.1.caption':
    '개별 사건 들여다보기 — 출처 문서, 관련 주체, 근거 문단이 함께 표시됩니다.',
  'pages.angelInsider.issues.feature-timeline.sections.0.blocks.2.p':
    '<strong>출처를 확인하세요.</strong> 각 사건 끝의 인라인 인용을 클릭하면 원본 문서가 열리고 해당 문장이 강조 표시됩니다.',
  'pages.angelInsider.issues.feature-timeline.sections.1.kicker': '02 — 스마트 타임라인',
  'pages.angelInsider.issues.feature-timeline.sections.1.heading':
    '사건에 맞는 항목을 직접 추출하기',
  'pages.angelInsider.issues.feature-timeline.sections.1.blocks.0.p':
    '<strong>프롬프트 확장</strong>을 클릭하면 관심 주제 중심으로 추출 범위를 좁힐 수 있습니다. <em>Basic Litigation(공유)</em> 구성은 사건 설명, 출처 문서, 관련 주체/인물, 근거 문단을 추출합니다 — 직접 항목을 추가할 수도 있습니다.',
  'pages.angelInsider.issues.feature-timeline.sections.1.blocks.1.figure.caption':
    '스마트 타임라인: 프롬프트 확장에서 원하는 추출 항목을 추가하세요.',
  'pages.angelInsider.issues.feature-timeline.sections.1.blocks.2.callout.title':
    '메시지에도 통합니다',
  'pages.angelInsider.issues.feature-timeline.sections.1.blocks.2.callout.body':
    '채팅 기록이나 메시지 스크린샷(WhatsApp, WeChat)에 타임라인을 적용해 시간 흐름을 만들어 보세요.',
  'pages.angelInsider.issues.feature-timeline.signoff.line': '하나의 타임라인, 모든 문서.',
  'pages.angelInsider.issues.feature-timeline.signoff.name': 'A&GEL 개발팀',
  'pages.angelInsider.issues.feature-using-files.title': 'A&GEL에서 내 파일 활용하기',
  'pages.angelInsider.issues.feature-using-files.subtitle':
    'A&GEL은 Word 문서, PDF, 이메일을 기본으로 다룹니다(앞으로 더 많은 형식이 추가됩니다). 다만 텍스트 레이어가 없거나, 민감도 레이블 또는 파일 형식이 맞지 않아 업로드에 실패하는 파일이 있을 수 있으며, 각 문제마다 간단한 해결책이 있습니다.',
  'pages.angelInsider.issues.feature-using-files.intro':
    '일부 파일이 A&GEL에 제대로 업로드되지 않는 일이 생길 수 있습니다. 이 가이드는 가장 흔한 원인 — 텍스트 레이어가 없는 스캔 문서부터 문서 민감도 레이블까지 — 과 그 해결 방법을 다룹니다.',
  'pages.angelInsider.issues.feature-using-files.glance.0':
    'A&GEL은 PDF의 <strong>텍스트 레이어</strong>를 읽습니다 — 종이를 스캔한 문서에는 대개 텍스트 레이어가 없습니다.',
  'pages.angelInsider.issues.feature-using-files.glance.1':
    '오래된 파일이나 OCR 없이 스캔한 종이 문서에서 흔히 나타납니다.',
  'pages.angelInsider.issues.feature-using-files.glance.2':
    '해결법: PDF를 검색 가능하게 만든 뒤 A&GEL에 다시 업로드하세요.',
  'pages.angelInsider.issues.feature-using-files.glance.3':
    'PDF를 한꺼번에 대량으로 변환해야 하나요? A&GEL 개발팀이 도와드릴 수 있습니다.',
  'pages.angelInsider.issues.feature-using-files.glance.4':
    '내부 문서는 업로드 전에 <strong>External</strong>로 다시 표시해야 하며, 그러지 않으면 A&GEL이 거부합니다.',
  'pages.angelInsider.issues.feature-using-files.glance.5':
    '구버전 Word 문서(1997~2004년, OOXML 이전 .doc)는 이미 지원됩니다 — 변환이 필요 없습니다.',
  'pages.angelInsider.issues.feature-using-files.sections.0.kicker': '01 — 텍스트 레이어 없음',
  'pages.angelInsider.issues.feature-using-files.sections.0.heading': '스캔 문서에서 생기는 문제',
  'pages.angelInsider.issues.feature-using-files.sections.0.blocks.0.p':
    'A&GEL은 PDF에 내장된 텍스트 레이어를 추출하는 방식으로 문서를 읽습니다. 종이를 스캔한 문서처럼 텍스트 레이어가 없으면 A&GEL에는 페이지의 이미지만 보이므로 처리할 수 없습니다.',
  'pages.angelInsider.issues.feature-using-files.sections.0.blocks.1.p':
    '스캔 문서 대부분은, 특히 복합기로 디지털화한 것은 이미지 전용 PDF로 저장됩니다. 오래된 파일이나 OCR을 적용하지 않고 이미지로 스캔한 문서에서 흔히 나타납니다.',
  'pages.angelInsider.issues.feature-using-files.sections.0.blocks.2.p':
    '업로드하기 전에 Kofax처럼 OCR(광학 문자 인식)을 지원하는 PDF 뷰어에서 파일을 열어, 정상적으로 처리되도록 준비하세요.',
  'pages.angelInsider.issues.feature-using-files.sections.0.blocks.3.steps.0.n': '1단계',
  'pages.angelInsider.issues.feature-using-files.sections.0.blocks.3.steps.0.text':
    'Kofax처럼 OCR 기능이 있는 PDF 뷰어에서 스캔한 PDF를 여세요.',
  'pages.angelInsider.issues.feature-using-files.sections.0.blocks.3.steps.1.n': '2단계',
  'pages.angelInsider.issues.feature-using-files.sections.0.blocks.3.steps.1.text':
    'OCR을 실행해 파일을 검색 가능하게 만드세요 — Kofax에서는 <strong>“Make Searchable”</strong> 또는 <strong>“Searchable PDF”</strong> 기능입니다. 변환할 파일이 여러 개라면 하나씩 처리하지 말고 일괄 또는 다중 파일 OCR 옵션(Kofax에서는 Advanced Processing 아래)을 찾아 쓰세요.',
  'pages.angelInsider.issues.feature-using-files.sections.0.blocks.3.steps.2.n': '3단계',
  'pages.angelInsider.issues.feature-using-files.sections.0.blocks.3.steps.2.text':
    '변환된 파일을 저장한 뒤 A&GEL에 업로드하세요.',
  'pages.angelInsider.issues.feature-using-files.sections.0.blocks.4.p':
    '변환을 마치면 파일에 검색 가능한 텍스트 레이어가 담기고, A&GEL이 평소처럼 처리할 수 있게 됩니다. 또는 나중에 변환하는 대신 스캔하는 시점에 검색 가능한 PDF를 만들 수도 있습니다 — 많은 프린터와 스캐너가 스캔 중에 곧바로 검색 가능한 PDF를 만들어 줍니다. 메뉴 이름과 절차는 기기마다 다르니, 사용 중인 장비에서 “Searchable PDF”나 OCR에 해당하는 옵션을 찾아보세요.',
  'pages.angelInsider.issues.feature-using-files.sections.0.blocks.5.figure.caption':
    '예시: 이 스캐너의 “스캔 후 전송” 화면에서 파일 형식을 PDF로 고르고 OCR(속도 우선 또는 정밀도 우선)을 켜면 텍스트 레이어가 있는 검색 가능한 PDF가 만들어집니다.',
  'pages.angelInsider.issues.feature-using-files.sections.0.blocks.6.p':
    'PDF를 한꺼번에 대량으로 OCR 처리해야 하나요? A&GEL 개발팀에 문의하세요 — 대량 변환 처리를 도와드릴 수 있습니다.',
  'pages.angelInsider.issues.feature-using-files.sections.1.kicker': '02 — 민감도 레이블',
  'pages.angelInsider.issues.feature-using-files.sections.1.heading':
    '민감도 레이블에서 생기는 문제',
  'pages.angelInsider.issues.feature-using-files.sections.1.blocks.0.p':
    '모든 문서에는 Word나 Outlook에서 저장할 때 지정되는 민감도 레이블이 붙으며, A&GEL은 업로드를 받아들이기 전에 이 레이블을 확인합니다.',
  'pages.angelInsider.issues.feature-using-files.sections.1.blocks.1.p':
    'A&GEL은 Internal 민감도 레이블로 저장된 파일을 거부합니다 — 문서를 External로 다시 표시하고 저장한 뒤 업로드하세요.',
  'pages.angelInsider.issues.feature-using-files.sections.2.kicker': '03 — 구버전 Word 파일',
  'pages.angelInsider.issues.feature-using-files.sections.2.heading': '구버전 Word 문서 지원',
  'pages.angelInsider.issues.feature-using-files.sections.2.blocks.0.p':
    '구버전 Word 문서도 지원됩니다. 다음 형식은 업로드 전에 변환하거나 다시 저장할 필요가 없습니다:',
  'pages.angelInsider.issues.feature-using-files.sections.2.blocks.1.formatsGrid.left.label': 'PDF',
  'pages.angelInsider.issues.feature-using-files.sections.2.blocks.1.formatsGrid.topMiddle.label':
    'MS Word 최신 형식(.docx)',
  'pages.angelInsider.issues.feature-using-files.sections.2.blocks.1.formatsGrid.bottomMiddle.label':
    'MS Word 1997~2004(.doc)',
  'pages.angelInsider.issues.feature-using-files.sections.2.blocks.1.formatsGrid.right.label':
    '이메일(.msg)',
  'pages.angelInsider.issues.feature-using-files.signoff.line':
    'Kofax나 프린터의 OCR 설정으로 스캔 문서를 검색 가능하게 만들고, 내부 문서는 업로드 전에 External로 저장하세요. 구버전과 최신 Word 형식은 모두 변환 없이 그대로 쓸 수 있다는 점도 기억해 두세요.',
  'pages.angelInsider.issues.feature-using-files.signoff.name': 'A&GEL 개발팀',
  'pages.angelInsider.issues.feature-work-studio.title': 'Workstudio',
  'pages.angelInsider.issues.feature-work-studio.subtitle':
    '팀의 표준 입장을 표준화된 검토 절차로 성문화하세요 — 변경 내용 추적이 적용된 Word 문서로 돌려받습니다.',
  'pages.angelInsider.issues.feature-work-studio.glance.0':
    '팀의 협상 입장을 Workstudio에 한 번만 담아 두면 — 모든 계약서에 재사용할 수 있습니다.',
  'pages.angelInsider.issues.feature-work-studio.glance.1':
    'A&GEL이 해당 Workstudio를 적용해 <strong>변경 내용 추적이 적용된 Word 문서</strong>를 돌려줍니다.',
  'pages.angelInsider.issues.feature-work-studio.glance.2':
    '수락/거절/보류 상태로 수정 사항을 검토하세요.',
  'pages.angelInsider.issues.feature-work-studio.glance.3':
    'Workstudio를 만들고 활용하는 방법은 다음 호 A&GEL Insider에서 더 자세히 다룹니다.',
  'pages.angelInsider.issues.feature-work-studio.sections.0.kicker': '01 — Workstudio',
  'pages.angelInsider.issues.feature-work-studio.sections.0.heading':
    '우리 팀의 표준 입장을 자동으로',
  'pages.angelInsider.issues.feature-work-studio.sections.0.blocks.0.p':
    'Workstudio는 팀의 협상 입장과 표준 입장을 재사용 가능한 검토 템플릿으로 담아 둘 수 있게 해 줍니다. 한 번 만들어 두면 어떤 계약서를 올리든 A&GEL이 그 Workstudio를 적용해 — 제안된 수정 사항이 변경 내용 추적 형식으로 담긴 Word 문서를 돌려주며, 곧바로 검토하고 손볼 수 있습니다.',
  'pages.angelInsider.issues.feature-work-studio.sections.0.blocks.1.figure.caption':
    'Workstudio 실제 화면 — 수락/거절/보류 상태로 수정 사항과 메모를 검토하는 모습.',
  'pages.angelInsider.issues.feature-work-studio.sections.0.blocks.2.callout.title':
    'Workstudio 전체 가이드가 곧 나옵니다',
  'pages.angelInsider.issues.feature-work-studio.sections.0.blocks.2.callout.body':
    '다음 호 A&GEL Insider에서 Workstudio를 처음부터 만드는 방법과, 이를 팀의 실제 사건에 적용하는 방법을 다룹니다.',
  'pages.angelInsider.issues.feature-work-studio.signoff.line': '여러분의 입장을, 자동으로 적용.',
  'pages.angelInsider.issues.feature-work-studio.signoff.name': 'A&GEL 개발팀',
  'pages.angelInsider.issues.feature-deepresearch.title': '딥 리서치',
  'pages.angelInsider.issues.feature-deepresearch.subtitle':
    '구조화된 리서치 프롬프트를 바탕으로 한 문서 전반 분석 — 모든 결과가 출처 단락으로 연결됩니다.',
  'pages.angelInsider.issues.feature-deepresearch.glance.0':
    '선택한 문서 세트 전체에 구조화된 리서치 프롬프트를 실행합니다.',
  'pages.angelInsider.issues.feature-deepresearch.glance.1':
    '모든 결과에 <strong>클릭 가능한 인라인 인용</strong>이 붙습니다 — 해당 대목이 강조된 원문을 열어 보세요.',
  'pages.angelInsider.issues.feature-deepresearch.glance.2':
    '<strong>전문 앱</strong>에서 찾을 수 있습니다.',
  'pages.angelInsider.issues.feature-deepresearch.glance.3':
    '1차 자료를 잘 선별해 보관함에 올려 두고 함께 쓰면 정밀도가 가장 높아집니다.',
  'pages.angelInsider.issues.feature-deepresearch.sections.0.kicker': '01 — 어떤 기능인가',
  'pages.angelInsider.issues.feature-deepresearch.sections.0.heading':
    '구조화된 프롬프트로 문서 전반을 분석',
  'pages.angelInsider.issues.feature-deepresearch.sections.0.blocks.0.p':
    '딥 리서치는 선택한 문서들에 구조화된 리서치 프롬프트를 실행해, 출처가 붙은 상세한 분석을 돌려줍니다. 단일 파일을 캐묻기보다는 여러 문서에 걸쳐 정보를 종합해야 하는 작업 — 판례 분석, 시장 조사, 규제 지도 그리기 — 을 위해 설계되었습니다.',
  'pages.angelInsider.issues.feature-deepresearch.sections.0.blocks.1.figure.caption':
    '딥 리서치 결과 — 각 결과가 클릭 가능한 인라인 인용을 통해 출처 문서로 연결됩니다.',
  'pages.angelInsider.issues.feature-deepresearch.sections.1.kicker': '02 — 인라인 인용',
  'pages.angelInsider.issues.feature-deepresearch.sections.1.heading':
    '모든 결과를 원문과 대조해 확인하기',
  'pages.angelInsider.issues.feature-deepresearch.sections.1.blocks.0.p':
    '딥 리서치 결과의 모든 항목에는 <strong>번호가 매겨진 인라인 인용</strong>이 붙습니다. 인용을 클릭하면 원문이 열리고 해당 대목이 강조 표시됩니다 — 페이지를 벗어날 필요가 없습니다.',
  'pages.angelInsider.issues.feature-deepresearch.sections.1.blocks.1.callout.title':
    '컨텍스트를 선별해 쓰세요',
  'pages.angelInsider.issues.feature-deepresearch.sections.1.blocks.1.callout.body':
    '리서치 질문과 가장 관련이 깊은 문서로 컨텍스트를 좁히세요. 범위가 넓으면 신호가 희석됩니다 — 딥 리서치는 잘 선별되고 목표가 분명한 자료에서 가장 좋은 성능을 냅니다.',
  'pages.angelInsider.issues.feature-deepresearch.sections.2.kicker': '03 — 언제 쓰나',
  'pages.angelInsider.issues.feature-deepresearch.sections.2.heading':
    '종합이 필요한 작업에 가장 알맞습니다',
  'pages.angelInsider.issues.feature-deepresearch.sections.2.blocks.0.p':
    '여러 자료를 가로질러 종합해야 할 때 딥 리서치를 쓰세요 — 여러 진술서의 입장을 비교하거나, 특정 쟁점에 관한 판례를 정리하거나, 여러 관할권의 규제 요건을 지도처럼 펼쳐 볼 때 말입니다. 문서가 한 건뿐이라면 가이드 요약이나 범위 요약을 고려해 보세요.',
  'pages.angelInsider.issues.feature-deepresearch.signoff.line': '모든 결과, 원문으로 확인.',
  'pages.angelInsider.issues.feature-deepresearch.signoff.name': 'A&GEL 개발팀',
  'pages.angelInsider.issues.feature-scopesummary.title': '범위 요약',
  'pages.angelInsider.issues.feature-scopesummary.subtitle':
    '직접 정의한 중점 영역에 맞춘 구조화된 요약 — 추출된 모든 항목에 클릭 가능한 인라인 인용이 붙습니다.',
  'pages.angelInsider.issues.feature-scopesummary.glance.0':
    '문서 전체가 아니라, 직접 정한 범위에 초점을 맞춘 요약을 만들어 냅니다.',
  'pages.angelInsider.issues.feature-scopesummary.glance.1':
    '추출된 모든 항목에 원문과 대조할 수 있는 <strong>클릭 가능한 인라인 인용</strong>이 붙습니다.',
  'pages.angelInsider.issues.feature-scopesummary.glance.2':
    '<strong>전문 앱</strong>에서 찾을 수 있습니다.',
  'pages.angelInsider.issues.feature-scopesummary.glance.3':
    '범위를 좁게 정의할수록 더 겨냥되고 곧바로 쓸 수 있는 결과가 나옵니다.',
  'pages.angelInsider.issues.feature-scopesummary.sections.0.kicker': '01 — 어떤 기능인가',
  'pages.angelInsider.issues.feature-scopesummary.sections.0.heading':
    '정해진 범위 안에서의 집중 추출',
  'pages.angelInsider.issues.feature-scopesummary.sections.0.blocks.0.p':
    '범위 요약은 A&GEL이 집중했으면 하는 영역 — 의무, 위험 배분, 해지권, 지식재산권 조항 — 을 직접 정하게 해 주고, 그 범위로 한정된 구조화된 요약을 생성합니다. 문서 전체 요약보다 더 겨냥된 결과가 나오며, 검토 우선순위와 곧바로 맞물립니다.',
  'pages.angelInsider.issues.feature-scopesummary.sections.0.blocks.1.callout.title':
    '범위를 분명하게 정하세요',
  'pages.angelInsider.issues.feature-scopesummary.sections.0.blocks.1.callout.body':
    '범위가 좁을수록 결과가 정밀해집니다. 범위가 넓으면 문서 전체 요약과 크게 다르지 않은 결과가 나옵니다. “개인정보 보호 및 보안 의무”처럼 겨냥된 범위는 간결하고 곧바로 쓸 수 있는 추출 결과를 만들어 냅니다.',
  'pages.angelInsider.issues.feature-scopesummary.sections.1.kicker': '02 — 인라인 인용',
  'pages.angelInsider.issues.feature-scopesummary.sections.1.heading': '모든 항목, 원문으로 확인',
  'pages.angelInsider.issues.feature-scopesummary.sections.1.blocks.0.p':
    '범위 요약에서 추출된 각 항목에는 <strong>클릭 가능한 인라인 인용</strong>이 붙습니다 — 클릭하면 원문 문서가 열리고 해당 조항이나 문단이 강조 표시됩니다. 탭을 오갈 필요 없이, 확인이 한 페이지 안에서 끝납니다.',
  'pages.angelInsider.issues.feature-scopesummary.signoff.line':
    '범위를 정하고, 출처를 달고, 확인까지.',
  'pages.angelInsider.issues.feature-scopesummary.signoff.name': 'A&GEL 개발팀',
  'pages.angelInsider.issues.feature-review.title': '검토',
  'pages.angelInsider.issues.feature-review.subtitle':
    '여러 문서에 여러 질문을 한 번에 던지세요 — 결과는 인라인 인용과 함께 표로 표시됩니다.',
  'pages.angelInsider.issues.feature-review.glance.0':
    '<strong>여러 문서에 질문 목록을 동시에 실행</strong>하고 — 결과를 하나의 표로 받습니다.',
  'pages.angelInsider.issues.feature-review.glance.1':
    '셀을 클릭하면 원문 조항으로 이어지는 인라인 인용이 담긴 <strong>설명 패널</strong>이 펼쳐집니다.',
  'pages.angelInsider.issues.feature-review.glance.2':
    '<strong>미니 채팅</strong>으로 검토 페이지를 벗어나지 않고 후속 질문을 이어가세요.',
  'pages.angelInsider.issues.feature-review.glance.3':
    '<strong>전문 앱</strong>에서 찾을 수 있습니다.',
  'pages.angelInsider.issues.feature-review.sections.0.kicker': '01 — 어떤 기능인가',
  'pages.angelInsider.issues.feature-review.sections.0.heading':
    '여러 문서, 여러 질문을 표 하나로 검토',
  'pages.angelInsider.issues.feature-review.sections.0.blocks.0.p':
    '검토는 질문 목록을 여러 문서에 동시에 실행해 결과를 표로 돌려줍니다 — 질문마다 한 행, 문서마다 한 열입니다. 이 형식은 계약서 비교, 문서 세트 전반에 걸친 실사, 서면별 입장 정리에 잘 맞습니다.',
  'pages.angelInsider.issues.feature-review.sections.0.blocks.1.figure.caption':
    'AI SaaS 벤치마킹 검토 — 정해진 질문 세트로 파일 20건을 표 하나에서 검토한 모습.',
  'pages.angelInsider.issues.feature-review.sections.1.kicker': '02 — 설명 패널',
  'pages.angelInsider.issues.feature-review.sections.1.heading':
    '모든 결과에 원문으로 확인되는 설명을',
  'pages.angelInsider.issues.feature-review.sections.1.blocks.0.p':
    '아무 셀이나 클릭하면 <strong>설명 패널</strong>이 펼쳐집니다. 각 결과가 항목별로 나뉘어 구조화된 인라인 참조와 함께 제시되며 — 참조를 클릭하면 원문 조항이 바로 열립니다.',
  'pages.angelInsider.issues.feature-review.sections.1.blocks.1.figure.caption':
    '검토의 설명 패널 — 각 결과가 원문 조항으로 연결되어 있습니다.',
  'pages.angelInsider.issues.feature-review.sections.1.blocks.2.callout.title':
    '질문 목록은 한 번 만들어 두고 재사용하세요',
  'pages.angelInsider.issues.feature-review.sections.1.blocks.2.callout.body':
    '잘 짜인 질문 목록은 그 문서 유형에 두고두고 쓰는 템플릿이 됩니다. 저장해 두었다가 같은 범주의 다음 계약서 묶음에 그대로 적용하세요.',
  'pages.angelInsider.issues.feature-review.sections.2.kicker': '03 — 미니 채팅',
  'pages.angelInsider.issues.feature-review.sections.2.heading':
    '페이지를 벗어나지 않고 이어서 묻기',
  'pages.angelInsider.issues.feature-review.sections.2.blocks.0.p':
    '<strong>미니 채팅 창</strong>에서는 문서와 검토 결과에 대해 동시에 후속 질문을 던질 수 있습니다 — 다른 화면으로 이동할 필요가 없죠. 창은 옮기고 크기도 조절할 수 있어 작업 공간을 가리지 않습니다.',
  'pages.angelInsider.issues.feature-review.signoff.line': '모든 문서. 모든 질문. 하나의 표.',
  'pages.angelInsider.issues.feature-review.signoff.name': 'A&GEL 개발팀',
  'pages.angelInsider.issues.feature-msg.title': '.msg 이메일 업로드',
  'pages.angelInsider.issues.feature-msg.subtitle':
    '이메일 파일 전체를 첨부 파일까지 통째로 A&GEL에 올려, 다른 문서처럼 활용하세요.',
  'pages.angelInsider.issues.feature-msg.glance.0':
    '<strong>.msg</strong> 이메일 파일을 파일에 바로 업로드하세요.',
  'pages.angelInsider.issues.feature-msg.glance.1':
    'A&GEL이 첨부 파일을 포함한 모든 내용을 읽습니다.',
  'pages.angelInsider.issues.feature-msg.glance.2':
    '채팅이나 전문 모드(가이드 요약, 타임라인 등)와 함께 쓸 수 있습니다.',
  'pages.angelInsider.issues.feature-msg.glance.3':
    '예외: <em>내부 전용</em> 레이블이 붙었거나 암호로 보호된 첨부 파일은 건너뜁니다.',
  'pages.angelInsider.issues.feature-msg.sections.0.kicker': '.msg 업로드',
  'pages.angelInsider.issues.feature-msg.sections.0.heading': '이메일 파일(.msg) 업로드하기',
  'pages.angelInsider.issues.feature-msg.sections.0.blocks.0.p':
    '이제 A&GEL 사용자는 <strong>.msg</strong> 이메일 파일 전체를 파일에 업로드해 채팅이나 전문 모드에서 활용할 수 있습니다. A&GEL은 첨부 파일을 포함한 모든 내용을 읽습니다 — 다만 <em>내부 전용</em> 민감도 레이블이 붙었거나 암호로 보호된 첨부 파일은 제외됩니다.',
  'pages.angelInsider.issues.feature-msg.sections.0.blocks.1.p':
    '업로드한 뒤에는 A&GEL에게 이메일을 요약하게 하거나, 첨부 문서를 요약하게 하거나, 라이브러리의 어떤 프롬프트든 그 파일에 적용해 실행할 수 있습니다.',
  'pages.angelInsider.issues.feature-msg.signoff.line': '이메일도, 첨부 파일도, 전부.',
  'pages.angelInsider.issues.feature-msg.signoff.name': 'A&GEL 개발팀',
  'pages.angelInsider.issues.feature-inline-ref.title': '인라인 참조',
  'pages.angelInsider.issues.feature-inline-ref.subtitle':
    '딥 리서치, 타임라인, 범위 요약, 검토에서 클릭 가능한 핀사이트 인용 — 페이지를 벗어나지 않고 모든 결과를 원문과 대조해 확인하세요.',
  'pages.angelInsider.issues.feature-inline-ref.glance.0':
    '딥 리서치, 타임라인, 범위 요약 결과에 이제 <strong>클릭 가능한 인라인 인용</strong>이 붙습니다.',
  'pages.angelInsider.issues.feature-inline-ref.glance.1':
    '인용을 클릭하면 해당 대목이 정확히 강조된 원문 문서가 열립니다.',
  'pages.angelInsider.issues.feature-inline-ref.glance.2':
    '검토의 <strong>설명 패널</strong>에도 AI가 생성한 각 결과마다 구조화된 인라인 참조가 붙습니다.',
  'pages.angelInsider.issues.feature-inline-ref.glance.3':
    '탭을 오갈 필요 없이 — 모든 확인이 한 페이지에서 끝납니다.',
  'pages.angelInsider.issues.feature-inline-ref.sections.0.kicker': '인라인 참조',
  'pages.angelInsider.issues.feature-inline-ref.sections.0.heading':
    '모든 결과를 원문과 대조해 확인하기',
  'pages.angelInsider.issues.feature-inline-ref.sections.0.blocks.0.p':
    'A&GEL의 주요 결과물 앱 — <strong>딥 리서치, 타임라인, 범위 요약</strong> — 에 이제 클릭 가능한 인라인 인용이 들어갑니다. 각 참조에는 번호가 매겨지고 링크가 걸려 있어, 클릭하면 해당 대목이 정확히 강조된 원문 문서가 열립니다.',
  'pages.angelInsider.issues.feature-inline-ref.sections.0.blocks.1.p':
    '덕분에 특정 항목을 확인하려고 탭을 옮기거나 원문 문서를 일일이 뒤질 필요가 없어집니다. 상호 대조가 한 페이지 안에서 가능합니다.',
  'pages.angelInsider.issues.feature-inline-ref.sections.1.kicker': '검토에서의 인라인 참조',
  'pages.angelInsider.issues.feature-inline-ref.sections.1.heading': '설명 패널의 구조화된 인용',
  'pages.angelInsider.issues.feature-inline-ref.sections.1.blocks.0.p':
    '검토 페이지의 <strong>설명</strong> 영역 — 아무 셀이나 클릭하면 펼쳐집니다 — 에도 이제 구조화된 인라인 참조가 들어갑니다. 설명의 각 항목이 원문 조항이나 문단으로 연결되어, AI가 생성한 결과를 사실관계와 대조해 확인하기가 한결 수월해집니다.',
  'pages.angelInsider.issues.feature-inline-ref.sections.1.blocks.1.figure.caption':
    '검토의 설명 패널 — 원문 문서로 연결된 구조화된 인라인 참조가 함께 표시됩니다.',
  'pages.angelInsider.issues.feature-inline-ref.signoff.line': '모든 결과. 원문으로 확인.',
  'pages.angelInsider.issues.feature-inline-ref.signoff.name': 'A&GEL 개발팀',
  'pages.angelInsider.issues.issue-5.title': '인라인 참조, 미니 채팅 등',
  'pages.angelInsider.issues.issue-5.subtitle':
    '모든 앱에 걸친 핀사이트 인용, 옮길 수 있는 미니 채팅, 스크라이브 타임스탬프, 그리고 이어지는 편의 개선.',
  'pages.angelInsider.issues.issue-5.date': '2026년 4월 10일',
  'pages.angelInsider.issues.issue-5.glance.0':
    '딥 리서치, 타임라인, 범위 요약, 검토에 이제 <strong>클릭 가능한 인라인 인용</strong>이 들어갑니다.',
  'pages.angelInsider.issues.issue-5.glance.1':
    '검토, 비교, 나란히 보기의 미니 채팅 창을 이제 <strong>옮기고 크기도 조절할 수 있습니다</strong>.',
  'pages.angelInsider.issues.issue-5.glance.2':
    '스크라이브 전사본에 이제 다운로드한 Word 문서 안에 <strong>타임스탬프</strong>가 포함됩니다.',
  'pages.angelInsider.issues.issue-5.glance.3':
    '중지 버튼 외에 <strong>기록 탭에서도 세션을 종료</strong>할 수 있게 되었습니다.',
  'pages.angelInsider.issues.issue-5.glance.4':
    '검색 개선: 키워드 매칭이 좋아지고 문서 내 검색이 추가되었습니다.',
  'pages.angelInsider.issues.issue-5.sections.0.kicker': '01 — 인라인 참조',
  'pages.angelInsider.issues.issue-5.sections.0.heading': '모든 앱에 걸친 핀사이트 인용',
  'pages.angelInsider.issues.issue-5.sections.0.blocks.0.p':
    '딥 리서치, 타임라인, 범위 요약에 이제 <strong>클릭 가능한 인라인 인용</strong>이 들어갑니다. 이 참조 덕분에 결과물을 원본 문서와 즉시 대조할 수 있습니다 — 인용을 클릭하면 관련 대목이 강조된 원문이 열리며, 페이지를 벗어날 필요가 없습니다.',
  'pages.angelInsider.issues.issue-5.sections.0.blocks.1.p':
    '검토 페이지에서 펼쳐지는 <strong>설명</strong> 영역에도 원본 문서로 연결되는 구조화된 인라인 참조가 추가되어, AI가 만든 분석을 사실관계와 대조해 확인하기가 한결 쉬워졌습니다.',
  'pages.angelInsider.issues.issue-5.sections.0.blocks.2.figure.caption':
    '검토의 설명 패널 — 원본 문서로 연결된 구조화된 인라인 참조.',
  'pages.angelInsider.issues.issue-5.sections.1.kicker': '02 — 미니 채팅',
  'pages.angelInsider.issues.issue-5.sections.1.heading': '옮길 수 있는 미니 채팅 인터페이스',
  'pages.angelInsider.issues.issue-5.sections.1.blocks.0.p':
    '<strong>검토, 비교, 나란히 보기</strong>에서 쓰는 미니 채팅 창을 이제 옮기고 크기도 조절할 수 있습니다. 결과물을 살펴보는 동안 옆으로 밀어 두세요 — 더 이상 주 작업 공간을 가리지 않습니다.',
  'pages.angelInsider.issues.issue-5.sections.2.kicker': '03 — 스크라이브',
  'pages.angelInsider.issues.issue-5.sections.2.heading': '다운로드한 전사본의 타임스탬프',
  'pages.angelInsider.issues.issue-5.sections.2.blocks.0.p':
    '다운로드한 스크라이브 전사본(Word 문서)에 이제 <strong>타임스탬프</strong>가 포함됩니다 — 문서에서 곧바로 녹음의 특정 순간으로 이동할 수 있게 해 주는 표식입니다.',
  'pages.angelInsider.issues.issue-5.sections.2.blocks.1.figure.caption':
    '번역과 나란히 타임스탬프가 표시된 스크라이브 전사본 다운로드본.',
  'pages.angelInsider.issues.issue-5.sections.3.kicker': '04 — 그 밖의 업데이트',
  'pages.angelInsider.issues.issue-5.sections.3.heading': '편의 개선',
  'pages.angelInsider.issues.issue-5.sections.3.blocks.0.h': '더 쉬워진 세션 종료',
  'pages.angelInsider.issues.issue-5.sections.3.blocks.1.p':
    '진행 중인 세션은 기존의 중지 버튼 외에 <strong>기록 탭에서 삭제하는 방식</strong>으로도 종료할 수 있습니다 — 프롬프트를 고쳐 다시 실행해야 할 때나 세션이 응답하지 않을 때 유용합니다.',
  'pages.angelInsider.issues.issue-5.sections.3.blocks.2.h': '향상된 검색',
  'pages.angelInsider.issues.issue-5.sections.3.blocks.3.p':
    '검색에 이제 <strong>인라인 참조</strong>가 더해지고, 키워드 매칭이 개선되었으며, 문서 내 검색이 가능해졌습니다 — 보관함 곳곳에서 원하는 내용을 찾기가 한결 수월해집니다.',
  'pages.angelInsider.issues.issue-5.sections.3.blocks.4.h': '더 빨라진 가이드 요약',
  'pages.angelInsider.issues.issue-5.sections.3.blocks.5.p':
    '가이드 요약은 이제 생성 도중 <strong>인라인 참조가 포함된 중간 업데이트</strong>를 제공하며, 전반적인 출력 속도도 빨라졌습니다. 비교적 단순한 문서라면 요약이 충분히 빨리 로드되어 중간 업데이트가 생략될 수 있습니다.',
  'pages.angelInsider.issues.issue-5.sections.3.blocks.6.h': '다듬어진 파일 화면',
  'pages.angelInsider.issues.issue-5.sections.3.blocks.7.p':
    '파일 페이지의 페이지 나누기가 개선되었습니다 — 파일과 폴더를 한눈에 더 많이 볼 수 있고, 화면 크기에 맞춰 목록이 유동적으로 채워집니다.',
  'pages.angelInsider.issues.issue-5.signoff.line': '확인은 더 빠르게. 작업 공간은 더 깔끔하게.',
  'pages.angelInsider.issues.issue-5.signoff.name': 'A&GEL 개발팀',
  'pages.angelInsider.issues.feature-faq.title': '자주 묻는 질문',
  'pages.angelInsider.issues.feature-faq.subtitle':
    'A&GEL 시작하기 — 파일 관리와 프롬프트 작성부터 결과물 점검까지.',
  'pages.angelInsider.issues.feature-faq.date': '2026년 2월 10일',
  'pages.angelInsider.issues.feature-faq.glance.0':
    'A&GEL이 여러분의 전문성을 대체하지 않고 어떻게 뒷받침하는지.',
  'pages.angelInsider.issues.feature-faq.glance.1':
    '파일 관리 모범 사례: 무엇을 올리고 어떻게 정리할 것인가.',
  'pages.angelInsider.issues.feature-faq.glance.2':
    '페르소나–과제–컨텍스트–형식 프레임워크로 효과적인 프롬프트 쓰는 법.',
  'pages.angelInsider.issues.feature-faq.glance.3':
    'A&GEL 결과물의 정확성과 신뢰성을 점검하는 방법.',
  'pages.angelInsider.issues.feature-faq.glance.4': 'A&GEL에서 쓰이는 기술 용어 모음.',
  'pages.angelInsider.issues.feature-faq.sections.0.kicker': '1 — 일반 원칙',
  'pages.angelInsider.issues.feature-faq.sections.0.heading': '전문가가 언제나 전문가로 남게 하라',
  'pages.angelInsider.issues.feature-faq.sections.0.blocks.0.h':
    'Q: A&GEL의 설계 철학 가운데 하나가 “전문가가 언제나 전문가로 남게 하라”입니다. 무슨 뜻인가요?',
  'pages.angelInsider.issues.feature-faq.sections.0.blocks.1.p':
    '“전문가가 언제나 전문가로 남게 하라”는, 해당 분야의 전문가로서 여러분의 판단과 통찰, 그리고 진정성이 언제나 업무의 중심에 있어야 한다는 뜻입니다.',
  'pages.angelInsider.issues.feature-faq.sections.0.blocks.2.p':
    'A&GEL은 그 전문성을 대체하지도, 해당 분야 전문가 노릇을 하지도 않습니다. 오히려 지식 노동자이자 법률가인 여러분이 더 많은 것을 가지고 더 많은 일을 해내도록 돕기 위해 설계되었습니다.',
  'pages.angelInsider.issues.feature-faq.sections.0.blocks.3.h':
    'Q: A&GEL에 물어보려는 주제를 제가 전혀 모른다면, 그럴 때는 A&GEL을 쓰지 말아야 하나요?',
  'pages.angelInsider.issues.feature-faq.sections.0.blocks.4.p':
    '아직 전문성을 쌓아 가는 중이라 해서 A&GEL 사용을 피해야 한다는 뜻은 아닙니다. 다만 A&GEL을 어떻게 쓰는지에 더 신경 써야 한다는 뜻이죠. 더 조심스럽게 접근하고, A&GEL의 결과물을 더 꼼꼼히 확인하세요.',
  'pages.angelInsider.issues.feature-faq.sections.0.blocks.5.p':
    '나아가 A&GEL을 팀이나 회사가 이미 올려 둔 노하우로 가는 관문이자 길잡이로 삼아 보세요. 그런 노하우에 접근하는 새로운 방법으로 쓰면서 필요할 때마다 통찰과 가르침을 얻는다면, A&GEL은 여러분의 학습과 성장을 뒷받침하는 강력한 도구가 될 것입니다.',
  'pages.angelInsider.issues.feature-faq.sections.1.kicker': '2 — 파일 관리',
  'pages.angelInsider.issues.feature-faq.sections.1.heading': '무엇을 올리고, 어떻게 정리할 것인가',
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.0.h':
    'Q: A&GEL에 어떤 참고 자료를 업로드해야 하나요?',
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.1.p':
    '원칙적으로는 신뢰할 수 있고 정확한 자료만 올리세요. 예를 들어 1차 법률 자료(법령, 판례 등)와 검증된 내부 자료(사내 노하우나 직접 여러 번 검증한 문서)가 이에 해당합니다.',
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.2.p':
    'A&GEL의 결과물은 여러분이 지정한 문서·폴더에 크게 좌우되므로, 올바른 파일을 골라 올리고 그 신뢰할 만한 문서들에 명확한 명명 규칙을 두세요.',
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.3.callout.title': 'Word 문서 설정',
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.3.callout.body':
    'A&GEL에 업로드하기 전, Word 문서의 보안 설정을 ‘External’(또는 이에 준하는 값)로 지정해야 합니다.',
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.4.h':
    'Q: 제3자 문서는 어떤가요? A&GEL에 올려도 되나요?',
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.5.p':
    '물론입니다! 제3자 문서를 분석하고 따져 보고 검토하는 데 A&GEL을 적극 활용해 보세요 — 실은 그것이 A&GEL의 여러 전문 모드(검토 등)가 가진 핵심 강점 가운데 하나입니다. 상대방 대리인이나 거래 상대방의 문서도 포함됩니다.',
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.6.p':
    '다만 제3자 문서임이 분명히 드러나는 폴더에 올려 두세요. 그래야 파일 경로만 보고도 이것이 신뢰할 만한 선례인지, 아니면 지금 다루고 있는 “외부” 문서인지 구분할 수 있습니다.',
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.7.p':
    'A&GEL 사용과 관련된 사내 정책(예: 생성형 AI 사용을 다루는 정책)과 이용 정책도 함께 유념하세요. 필요한 경우 적절한 권한을 갖춘 제3자 콘텐츠 사용도 여기에 포함됩니다.',
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.8.h':
    'Q: 파일 탭이나 채팅에 올린 파일을 A&GEL이 “처리”하는 데 왜 시간이 오래 걸리나요?',
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.9.p':
    '문서는 A&GEL이 다룰 수 있는 형태(이를 “임베딩”이라 부릅니다)로 변환되어야 하므로 업로드 시 시간이 걸릴 수 있습니다 — 다만 이 작업은 보관함의 파일에 올릴 때 한 번만 일어납니다. 파일 탭에 올린 문서는 채팅이나 전문 모드에서 해당 파일을 컨텍스트로 선택하면 새 세션에서도 다시 쓸 수 있습니다.',
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.10.p':
    '채팅에서는 문서를 한 번 올려 두면, “컨텍스트” 버튼을 누른 뒤 “문서로 새 채팅 시작” 버튼을 눌러 새로운 채팅 세션에서 같은 문서와 다시 대화할 수 있습니다.',
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.11.h':
    'Q: 파일 탭에 문서를 한꺼번에 올리려면 어떻게 해야 하나요?',
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.12.p':
    '파일 모드에서 화면 오른쪽 위의 업로드 버튼을 클릭하세요. 올리고 싶은 파일을 원하는 만큼 선택한 뒤 “열기”를 누릅니다. 참고 자료가 업로드되는 동안에도 A&GEL의 다른 기능을 계속 쓸 수 있습니다.',
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.13.h':
    'Q: A&GEL에 올린 참고 자료는 어떻게 분류하고 관리해야 하나요? 그냥 전부 한 폴더에 올리면 왜 안 되나요?',
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.14.p':
    '<strong>파일 관리가 왜 중요한가요?</strong> 적절한 파일 관리는 다음 두 가지를 효과적으로 해내기 위한 핵심입니다: (a) A&GEL이 답변의 근거로 삼을 관련 참고 자료를 골라 주는 것, (b) A&GEL이 어떤 참고 자료를 썼는지 확인해 생성된 결과의 정확성과 신뢰성을 담보하는 것.',
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.15.p':
    '<strong>올린 참고 자료는 어떻게 관리해야 하나요?</strong> A&GEL에 참고 자료를 올릴 때는 모든 것을 한 폴더에 넣지 않기를 강력히 권합니다. 대신 (i) 주제와 (ii) 업무 흐름을 기준으로 문서를 선별해 묶으세요.',
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.16.p':
    '파일 탭에서 그렇게 하려면, 문서를 올리기 전에 오른쪽 상단의 “폴더 만들기” 버튼을 눌러 새 폴더를 만들고 주제 이름을 붙이세요. 그리고 새로 만든 폴더 안에 하위 폴더를 만들어 업로드할 문서의 업무 흐름 이름을 붙이면 됩니다.',
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.17.p':
    '이렇게 하면 문서를 올렸을 때 주제와 업무 흐름이 함께 드러나는 알맞은 파일 경로가 생깁니다. 예: <code>Home / IP Licensing Agreements / Licensor</code>',
  'pages.angelInsider.issues.feature-faq.sections.2.kicker': '3 — A&GEL에 프롬프트 쓰기',
  'pages.angelInsider.issues.feature-faq.sections.2.heading': '효과적인 프롬프트 작성하기',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.0.h':
    'Q: 어떤 유형의 프롬프트를 쓸 수 있나요?',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.1.p':
    'A&GEL에는 여러 방식으로 프롬프트를 쓸 수 있습니다. 아래에 다양한 유형을 제안해 두었습니다(미처 생각지 못했던 것도 있을 겁니다):',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.2.h': '정보 탐색과 검색',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.3.list.0':
    '<strong>질문형 프롬프트:</strong> 사실 정보나 설명, 해명을 구하는 직접적인 질문.',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.3.list.1':
    '<strong>설명형 프롬프트:</strong> 개념·과정·현상에 대한 상세한 설명 요청. “설명하라”, “서술하라”, “쪼개어 보라” 같은 표현을 자주 씁니다.',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.3.list.2':
    '<strong>리서치형 프롬프트:</strong> 여러 출처의 정보를 종합해야 할 수도 있는, 한층 복잡한 정보 수집 요청.',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.4.h': '과제 지향과 지시형',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.5.list.0':
    '<strong>지시형 프롬프트:</strong> “써라”, “만들라”, “분석하라”, “요약하라” 같은 행위 동사를 쓰는 명확하고 직접적인 명령.',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.5.list.1':
    '<strong>다단계 과제형 프롬프트:</strong> 큰 과제를 순차적 단계로 쪼개는 복합 지시.',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.5.list.2':
    '<strong>템플릿형 프롬프트:</strong> AI가 따라야 할 특정 형식이나 틀을 제시하는 구조화된 프롬프트.',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.6.h': '분석과 문제 해결',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.7.list.0':
    '<strong>데이터 분석형 프롬프트:</strong> 데이터셋을 분석하거나 패턴을 찾아내거나 통찰을 뽑아내라는 지시.',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.7.list.1':
    '<strong>문제 해결형 프롬프트:</strong> 과제를 제시하고 AI에게 해법·전략·권고안을 요구하는 요청.',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.7.list.2':
    '<strong>비교 분석형 프롬프트:</strong> 여러 선택지를 견주고, 대안을 평가하거나 장단점을 따져 보라는 지시.',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.8.h': '분류와 정리',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.9.list.0':
    '<strong>분류형 프롬프트:</strong> 텍스트·데이터·정보를 미리 정한 범주나 레이블로 분류하라는 지시.',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.9.list.1':
    '<strong>정렬·순위형 프롬프트:</strong> 중요도, 우선순위, 선호 같은 기준에 따라 정보를 정리하라는 요청.',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.9.list.2':
    '<strong>태그·레이블형 프롬프트:</strong> 정리나 검색을 위해 콘텐츠에 태그·레이블·메타데이터를 붙이라는 지시.',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.10.h': '변환과 서식',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.11.list.0':
    '<strong>번역형 프롬프트:</strong> 텍스트를 다른 언어로 옮기거나 다른 문화적 맥락에 맞게 다듬으라는 지시.',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.11.list.1':
    '<strong>형식 변환형 프롬프트:</strong> 산문을 개조식으로 바꾸는 등 정보의 구조나 표현 방식을 바꾸라는 요청.',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.11.list.2':
    '<strong>문체 변환형 프롬프트:</strong> 다른 어조·문체로, 또는 다른 독자를 겨냥해 내용을 다시 쓰라는 지시.',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.12.h': '그 밖의 프롬프트 유형',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.13.list.0':
    '역할극 및 페르소나 프롬프트',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.13.list.1':
    '대화형 및 상호작용 프롬프트',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.13.list.2':
    '시스템 및 행동 지침 프롬프트',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.13.list.3': '추론 및 논리 프롬프트',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.13.list.4': '코드 및 기술 프롬프트',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.13.list.5': '교육 및 훈련 프롬프트',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.14.h':
    'Q: 효과적인 프롬프트는 어떻게 쓰나요?',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.15.p':
    '대체로 가장 효과적인 프롬프트는 네 부분으로 이루어집니다: <strong>(a) 페르소나, (b) 과제, (c) 컨텍스트, (d) 형식.</strong>',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.16.h': '(a) 페르소나',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.17.p':
    '페르소나란 AI 프롬프트를 쓸 때 여러분 자신에 대해 알려 주는 정보이거나, A&GEL이 흉내 내야 할 역할을 뜻합니다. 이것이 A&GEL을 특정한 문체와 어조로 이끌어 줍니다. 페르소나를 더하면 여러분에게 더 잘 맞는 답을 얻게 됩니다.',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.18.prompt.label': '예시',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.18.prompt.text':
    '당신은 30년 경력의 노련한 변호사입니다.',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.19.h': '(b) 과제',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.20.p':
    '모델에게 내리는 지시입니다. 가장 좋은 결과를 얻으려면 과제 지시를 구체적으로 써야 합니다. 다만 AI에게 과제를 맡길 때는 명확하고 간결하게 쓰는 것도 그만큼 중요합니다.',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.21.prompt.label': '예시',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.21.prompt.text':
    '이 문서를 100단어 이내로 요약하라.',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.22.h': '(c) 컨텍스트',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.23.p':
    'A&GEL에 넣어 주는 컨텍스트(즉 정보)가 모든 차이를 만듭니다. 컨텍스트야말로 A&GEL 프롬프트에서 겨냥된 결과를 얻는 가장 좋은 방법입니다. 이러한 컨텍스트는 A&GEL이 결과를 만들 때 특별히 고려하기를 바라는 전문 “지식”의 형태로 제시할 수도 있습니다.',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.24.prompt.label': '예시',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.24.prompt.text':
    '이 요약은 이번 거래의 매수인인 고객을 위한 것이다. 요약에는 매수인의 관점에서 본 거래의 세부 사항을 포함하라.\n\n지식: 양도, 경개 또는 이전 조항은 지배권·소유권·지분 변동에 관한 조항의 예에 해당하지 않는다.',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.25.h': '(d) 형식',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.26.p':
    '결과물의 형태를 말합니다. 목록, 표, 마크다운 형식 등을 고를 수 있습니다.',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.27.prompt.label': '예시',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.27.prompt.text':
    '요약을 표 형태로 제시하라.',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.28.callout.title':
    '프롬프트 라이브러리에서 출발하세요',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.28.callout.body':
    '효과적인 프롬프트를 쓰는 한 가지 방법은, 이미 효과가 입증된 기존 프롬프트를 가져와 목적에 맞게 고치는 것입니다. 프롬프트 라이브러리 탭으로 가서 해당 프롬프트를 “복제”한 뒤 사건에 맞게 다듬으세요.',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.29.h':
    '전체 예시 — 페르소나 + 과제 + 컨텍스트 + 형식',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.30.prompt.label': '전체 프롬프트 예시',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.30.prompt.text':
    '당신은 경험 많은 변호사다. 이 문서에 대해 각 항목 100단어를 넘지 않는 간결한 요약을 작성하라. 지시: (1) 문서가 다루는 주요 이점과 긍정적 요소를 짚어 내는 데 집중하고, 별도의 항목에서 이를 뒷받침하는 사실 예시를 최소 하나 제시하라. 그리고 (b) 문서가 다루는 주요 위험과 부정적 요소를 짚어 내고, 별도의 항목에서 이를 뒷받침하는 사실 예시를 최소 하나 제시하라. 요약은 일관되고 명료해야 한다. 예시나 논거가 둘 이상 발견되면, 문서에 서술된 바에 따라 어느 것이 가장 낫고 어느 것이 가장 못한지 밝혀라. 격식 있는 표현을 쓰고 중립적인 어조를 유지하라. 개인적 의견이나 해석은 넣지 마라. 모든 결과물은 마크다운 형식으로, 각 핵심 항목은 글머리 기호로, 특히 중요한 내용은 굵은 글씨로 제시하라. 이 작업물은 선임 법률 전문가의 검토를 거쳐 고위험 금융 거래에 쓰일 것이므로, 정밀하고 정확하며 전문적이어야 한다.',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.31.h':
    'Q: RAG란 무엇이며 A&GEL은 언제 사용하나요?',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.32.p':
    'A&GEL의 채팅 기능은 기본적으로 검색 증강 생성(RAG)을 사용합니다. 파일 탭에 올려 둔 참고 자료에서 정보를 가져와, 여러분이 A&GEL에 던진 프롬프트와 함께 생성 요소(즉 LLM)에 전달하는 방식이죠. 그런 다음 A&GEL은 자신이 가진 데이터에 RAG가 더해 준 컨텍스트를 얹어 결과를 만들어 냅니다.',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.33.p':
    'RAG와 LLM 기술의 결합은 A&GEL이 “증강된 답변”을 만들어 낼 컨텍스트와 관련 정보를 제공합니다. 이로써 A&GEL 결과물의 정밀도가 높아지고, 답변이 신뢰할 만할 확률도 그만큼 커집니다.',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.34.h':
    'Q: 왜 모든 프롬프트마다 업로드한 자료 전부를 A&GEL이 고려하게 하면 안 되나요?',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.35.p':
    '프롬프트와 무관한 업로드 자료는 A&GEL이 고려하지 않게 하기를 강력히 권합니다.',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.36.p':
    'A&GEL 같은 생성형 AI 도구는 단어, 조항, 계약 등의 의미를 이해하지 않습니다. 진짜 이해가 아니라 확률적 방식으로 작동하죠. 채팅 모드에서 모든 파일을 컨텍스트로 선택하면, A&GEL은 보관함에 올린 모든 문서에서 참고 자료를 끌어옵니다. 하지만 프롬프트에 실제로 필요한 컨텍스트 자료는 특정 주제, 나아가 특정 업무 흐름에 속한 것들뿐일 수 있습니다. 목적과 무관한 컨텍스트를 A&GEL에 더 넣어 주면 결과물의 속도, 정확성, 정밀도, 신뢰성이 모두 떨어질 가능성이 큽니다.',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.37.h':
    'Q: 프롬프트마다 관련 참고 자료는 어떻게 고르나요?',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.38.p':
    '채팅 모드에서 A&GEL이 프롬프트의 컨텍스트로 꼭 관련 있는 참고 자료만 쓰게 하려면, “컨텍스트”로 이동해 선택 아이콘을 클릭한 뒤 관련 있는 문서·폴더만 고르세요.',
  'pages.angelInsider.issues.feature-faq.sections.3.kicker': '4 — 결과물 활용',
  'pages.angelInsider.issues.feature-faq.sections.3.heading': '정확성과 신뢰성 점검하기',
  'pages.angelInsider.issues.feature-faq.sections.3.blocks.0.h':
    'Q: A&GEL에 프롬프트를 넣어 결과를 받았습니다. 그대로 써도 되나요?',
  'pages.angelInsider.issues.feature-faq.sections.3.blocks.1.p':
    '원칙적으로 A&GEL의 결과물은 업무 산출물에 쓰기 전에 항상 확인해야 합니다. A&GEL의 결과물은 출발점이나 참고 자료로만 삼고, 신뢰할 수 있는 지식 원천(직접 올린 참고 자료나 검증된 법률 자료 등)과 반드시 교차 확인하시길 권합니다.',
  'pages.angelInsider.issues.feature-faq.sections.3.blocks.2.h':
    'Q: 결과물의 정확성과 신뢰성은 어떻게 점검해야 하나요?',
  'pages.angelInsider.issues.feature-faq.sections.3.blocks.3.p':
    '채팅 모드에서 A&GEL의 결과물은 가능한 경우 언제나 참조를 포함하도록 최적화되어 있습니다. 이 참조는 신뢰할 수 있는 정보(예: 파일 탭에 올린 자료)로 이어지는 링크입니다.',
  'pages.angelInsider.issues.feature-faq.sections.3.blocks.4.p':
    '<strong>A&GEL은 여러분의 노하우로 가는 관문이어야 하며, 노하우의 원천이 되어서는 안 됩니다.</strong> 각 참조 링크를 클릭하면 A&GEL이 컨텍스트를 가져온 참고 자료를 볼 수 있습니다. 정확성과 신뢰성을 담보하려면 언제나 그 참고 자료와 A&GEL의 결과물을 대조해 확인하세요.',
  'pages.angelInsider.issues.feature-faq.sections.3.blocks.5.p':
    '적절한 A&GEL 파일 관리가 자리 잡혀 있다면, 참조 링크는 — 참조된 문서의 파일 경로를 보여 주므로 — A&GEL이 올바른 주제(및 업무 흐름) 자료로 결과를 보강했는지도 한눈에 알려 줍니다. 예를 들어 “임차권 양도인”의 입장에서 프롬프트를 넣었는데 A&GEL이 “임차권 양수인” 폴더의 문서를 참조했다면, 그 결과가 목적에 온전히 맞춰지지 않았음을 즉시 알아챌 수 있습니다.',
  'pages.angelInsider.issues.feature-faq.sections.3.blocks.6.callout.title':
    '결과물에 참조가 하나도 없다면?',
  'pages.angelInsider.issues.feature-faq.sections.3.blocks.6.callout.body':
    '참조가 없는 결과물은 신뢰할 만한 참고 자료에 뿌리내리지 않았으므로 환각이 생기기 쉽습니다. 참조가 전혀 보이지 않는다면, 결과에 제시된 정보는 거의 틀림없이 모델의 사전 학습에서만 나온 것입니다. 충분한 컨텍스트가 주어진 일반적인 글쓰기·문장 편집 프롬프트(예: 문서 간결화나 교정)나 요약에 대한 답이라고 확신할 수 있는 경우가 아니라면 그 결과물을 쓰지 마세요.',
  'pages.angelInsider.issues.feature-faq.sections.4.kicker': '5 — 용어집',
  'pages.angelInsider.issues.feature-faq.sections.4.heading': 'A&GEL에서 쓰이는 기술 용어',
  'pages.angelInsider.issues.feature-faq.sections.4.blocks.0.p':
    '<strong>즐겨찾기 파일 가중치:</strong> 응답을 생성할 때 (보관함 안에서) 여러분이 “즐겨찾기”로 표시한 문서를 A&GEL이 얼마나 우선할지 조정합니다. 가중치가 높을수록 이 선호 자료가 보관함의 일반 파일보다 결과물에 더 크게 반영됩니다.',
  'pages.angelInsider.issues.feature-faq.sections.4.blocks.1.p':
    '<strong>재순위화:</strong> A&GEL이 1차 검색 결과를 다시 살펴 가장 관련성 높은 조항이나 문단을 앞세우는 2차 정렬 과정입니다. 이를 통해 응답을 만들기 전에 가장 적절한 정보가 맨 위에 오게 됩니다.',
  'pages.angelInsider.issues.feature-faq.sections.4.blocks.2.p':
    '<strong>검색 비율:</strong> 질의에 답하기 위해 AI가 가져오는 내부 데이터의 양을 조절합니다. 비율이 높으면 더 많은 컨텍스트를 담도록 검색 범위가 넓어지고(폭넓은 탐색에 유용), 낮으면 정확히 일치하는 것에만 엄격히 집중합니다(대체로 CTRL+F와 비슷합니다).',
  'pages.angelInsider.issues.feature-faq.sections.4.blocks.3.p':
    '<strong>시스템 프롬프트:</strong> A&GEL의 구체적인 역할, 어조, 작동 한계를 정하는 기본 지시문 묶음입니다(예: “당신은 20년 경력의 시니어 파트너입니다”). 이 설정은 이후의 모든 요청을 A&GEL이 어떻게 처리할지 이끄는 기본 틀이 됩니다.',
  'pages.angelInsider.issues.feature-faq.sections.4.blocks.4.p':
    '<strong>‘사고’ 또는 ‘추론’:</strong> A&GEL이 최종 응답을 만들기 전에 복잡한 질의를 단계별로 논리적으로 쪼개어 살피는 과정입니다. 이 내부 숙고는 인간의 추론을 흉내 낸 것으로, 복잡한 분석에서 오류를 줄이는 데 목적이 있습니다.',
  'pages.angelInsider.issues.feature-faq.signoff.line':
    '새로운 도구는 무엇이든 익숙해지는 데 시간이 조금 걸립니다 — A&GEL도 마찬가지입니다. 쓰면 쓸수록 더 쓸모 있어집니다.',
  'pages.angelInsider.issues.feature-faq.signoff.name': 'A&GEL 개발팀',
  'pages.app.addCustomFieldsTitle': '각 이벤트에서 추출할 사용자 지정 필드 추가',
  'pages.app.addCustomStepButton': '사용자 지정 단계',
  'pages.app.addFieldButton': '필드 추가',
  'pages.app.addFromLibraryButton': '라이브러리에서',
  'pages.app.addFromSavedButton': '저장된 구성',
  'pages.app.addToMattersButton': '매터에 추가',
  'pages.app.analysisType.agenticResearch.description':
    '선택한 문서와 업로드된 파일을 탐색한 후, 출처를 포함한 종합적인 답변을 생성합니다.',
  'pages.app.analysisType.agenticResearch.title': '에이전틱 리서치',
  'pages.app.analysisType.comparison.description':
    '두 문서를 비교하여 차이점을 설명하는 보고서를 제공합니다. 비교의 초점을 지정하기 위해 프롬프트를 입력할 수 있습니다.',
  'pages.app.analysisType.comparison.title': '비교',
  'pages.app.analysisType.contractDeadlines.description':
    "계약서/문서에서 발견된 모든 기한, 중요 날짜 및 기간을 나열합니다. 고객에 대한 세부 정보를 제공하면 도움이 됩니다(예: '고객은 전자은행 서비스를 전문으로 하는 싱가포르 은행입니다').",
  'pages.app.analysisType.contractDeadlines.title': '기한 추출',
  'pages.app.analysisType.executiveSummary.description':
    '핵심 조언, 이슈, 리스크 및 조치 사항에 대한 간결한 요약을 제공합니다.',
  'pages.app.analysisType.executiveSummary.title': '핵심 요약',
  'pages.app.analysisType.gartnerReport.description':
    '예측과 권장 사항을 포함한 심층 업계 보고서를 제공합니다.',
  'pages.app.analysisType.gartnerReport.title': 'Gartner 스타일 보고서',
  'pages.app.analysisType.guidedSummary.description':
    '프롬프트에 따라 단일 문서에 대한 상세 요약을 제공합니다.',
  'pages.app.analysisType.multiStepPrompt.description':
    '여러 프롬프트를 순차적으로 실행하며, 각 단계의 결과물을 바탕으로 다음 단계를 진행합니다.',
  'pages.app.analysisType.multiStepPrompt.title': '다단계 프롬프트',
  'pages.app.analysisType.scopeOfWork.description':
    '지원 또는 서비스 요청이 담긴 고객 이메일, 서한 또는 RFP를 업로드하거나 선택하세요. "프롬프트"에 고객에 대한 세부 정보를 제공하면 도움이 됩니다(예: \'고객은 전자은행 서비스를 전문으로 하는 싱가포르 은행입니다\').',
  'pages.app.analysisType.scopeOfWork.title': '업무 범위 요약',
  'pages.app.analysisType.standardInfo.description':
    '간결한 요약, 주요 인물 및 기관 목록, 사건의 간단한 타임라인을 제공합니다. 최대 100개의 문서를 제공할 수 있습니다.',
  'pages.app.analysisType.timeline.description':
    '최대 100개의 문서에 걸친 사건의 상세한 타임라인을 제공합니다.',
  'pages.app.analyzingFiles': '파일 분석 중...',
  'pages.app.applicablePartiesColumnTitle': '적용 당사자',
  'pages.app.appsInstructions':
    '작업할 여러 파일을 선택한 후 아래 목록에서 분석 유형을 선택하세요. 요청 처리에는 약 1~5분이 소요됩니다.',
  'pages.app.appsList.agenticResearch.description':
    '선택한 문서와 업로드된 파일을 탐색한 후 출처가 포함된 종합적인 답변을 작성합니다.',
  'pages.app.appsList.contractDeadlines.description':
    '계약서/문서에서 발견된 모든 기한, 주요 날짜 및 기간을 나열합니다.',
  'pages.app.appsList.executiveSummary.description':
    '경영진을 위한 핵심 사항, 조사 결과 및 권고 사항에 대한 개괄적 개요',
  'pages.app.appsList.gartnerReport.description':
    '확신에 찬 객관적인 조사 방법론을 활용한 심층 업계 분석',
  'pages.app.appsList.guidedSummary.description':
    '프롬프트에 따라 단일 문서에 대한 상세 요약을 제공합니다',
  'pages.app.appsList.multiStepPrompt.description':
    '여러 프롬프트를 순차적으로 실행하며, 각 단계의 결과물을 바탕으로 다음 단계를 진행합니다',
  'pages.app.appsList.scopeOfWork.description':
    '지원 또는 서비스 요청이 담긴 고객 이메일, 서한 또는 RFP를 업로드하거나 선택하세요.',
  'pages.app.appsList.standardInfo.description':
    '간결한 요약, 인물 및 기관 목록, 간단한 타임라인을 제공합니다',
  'pages.app.appsList.timeline.description':
    '최대 100개의 문서에 걸친 사건의 상세한 타임라인을 제공합니다',
  'pages.app.appsTitle': '앱',
  'pages.app.backToSavedPromptsLabel': '저장된 프롬프트로 돌아가기',
  'pages.app.backgroundColumnTitle': '배경',
  'pages.app.buildMultiStepPromptTitle': '다단계 프롬프트 작성',
  'pages.app.buildNewButton': '새 구성',
  'pages.app.clauseColumnTitle': '조항',
  'pages.app.clearStepsButton': '비우기',
  'pages.app.clearStepsConfirm': '목록의 모든 단계를 제거할까요?',
  'pages.app.clientDetailsPlaceholder': '고객의 이름 및 간단한 세부 정보',
  'pages.app.clientInformationTitle': '고객 정보',
  'pages.app.clientLabel': '고객',
  'pages.app.collapseAllPrompts': '모든 프롬프트 접기',
  'pages.app.collapsePrompt': '프롬프트 접기',
  'pages.app.compilingFinalSummary': '최종 요약 작성 중...',
  'pages.app.complexityLabel': '복잡도',
  'pages.app.configNameLabel': '구성 이름',
  'pages.app.configTagsLabel': '태그',
  'pages.app.configurationDeletedSuccess': '구성이 삭제되었습니다',
  'pages.app.configurationSavedSuccess': '구성이 성공적으로 저장되었습니다',
  'pages.app.configurationUpdatedSuccess': '구성이 성공적으로 업데이트되었습니다',
  'pages.app.contactLabel': '연락처',
  'pages.app.counterpartyLabel': '상대방',
  'pages.app.dateReferenceColumnTitle': '날짜/참조',
  'pages.app.deadlinesSectionTitle': '기한',
  'pages.app.deleteConfigConfirmTitle': '이 구성을 삭제하시겠습니까?',
  'pages.app.deleteStepTooltip': '단계 삭제',
  'pages.app.detailsColumnTitle': '세부 정보',
  'pages.app.doneCount': '완료 ({completed}/{total})',
  'pages.app.dragHereToUpload': '업로드하려면 여기로 드래그하세요',
  'pages.app.dragStepTooltip': '단계 드래그',
  'pages.app.dropZoneForNamedStep': '{stepName}의 드롭 영역',
  'pages.app.dropZoneForStepNumber': '{stepNumber} 단계의 드롭 영역',
  'pages.app.durationColumnTitle': '기간',
  'pages.app.enterConfigNamePlaceholder': '구성 이름 입력',
  'pages.app.enterDescriptionPlaceholder': '설명 입력',
  'pages.app.enterTagsPlaceholder': '태그 입력 후 Enter',
  'pages.app.entitiesColumnTitle': '기관',
  'pages.app.expandAllPrompts': '모든 프롬프트 펼치기',
  'pages.app.expandPrompt': '프롬프트 펼치기',
  'pages.app.extendPromptTabLabel': '프롬프트 확장',
  'pages.app.extraFieldDescriptionPlaceholder': '설명 (예: 언급된 금액 추출)',
  'pages.app.extraFieldKeyPlaceholder': '키 (예: 예산)',
  'pages.app.extractColumnTitle': '발췌',
  'pages.app.extractDeadlinesModalDescription':
    "계약서/문서에서 발견된 모든 기한, 주요 날짜 및 기간을 나열합니다. 고객에 대한 세부 정보를 제공하면 도움이 됩니다(예: '고객은 전자은행 서비스를 전문으로 하는 싱가포르 은행입니다')",
  'pages.app.fileCountLabel': '파일 {count}개',
  'pages.app.filesCompleteCount': '{completed}/{total} 파일 완료',
  'pages.app.hardDeadlineColumnTitle': '확정 기한',
  'pages.app.inProgressSuffix': ' (진행 중)',
  'pages.app.keyDatesDeadlinesTitle': '주요 날짜 및 기한',
  'pages.app.libraryPanelTitle': '프롬프트 라이브러리',
  'pages.app.loadSavedConfigPlaceholder': '저장된 구성 불러오기',
  'pages.app.loadingDocumentTip': '문서 로딩 중...',
  'pages.app.mattersUpdatedSuccess': '매터가 성공적으로 업데이트되었습니다',
  'pages.app.moveStepDownTooltip': '아래로 이동',
  'pages.app.moveStepUpTooltip': '위로 이동',
  'pages.app.newAnalysisModesDescription':
    '계약서에서 더 많은 가치를 얻을 수 있도록 강력한 신규 분석 모드 두 가지를 도입했습니다.',
  'pages.app.newAnalysisModesTitle': '새로운 분석 모드',
  'pages.app.newFieldDefaultKey': '필드 {number}',
  'pages.app.newSessionLabel': '새 세션',
  'pages.app.newStepDefaultName': '새 단계',
  'pages.app.noSourceDocumentsDescription': '원본 문서 없음',
  'pages.app.noTimelineItemsExtracted': '추출된 타임라인 항목이 없습니다.',
  'pages.app.overallTabLabel': '전체',
  'pages.app.overviewSectionTitle': '개요',
  'pages.app.partiesSectionTitle': '당사자',
  'pages.app.peopleEntitiesInvolvedLabel': '관련 인물/기관',
  'pages.app.periodsDurationsTitle': '기간 및 존속기간',
  'pages.app.pleaseEnterPlaceholder': '입력해 주세요',
  'pages.app.processingNextStep': '다음 단계 처리 중...',
  'pages.app.promptForStepPlaceholder': '이 단계의 프롬프트',
  'pages.app.promptLabelWithValue': '프롬프트: {prompt}',
  'pages.app.provideDetailsTabLabel': '세부 정보 입력',
  'pages.app.provideDocumentsTabLabel': '문서 제공',
  'pages.app.providePromptsTabLabel': '프롬프트 제공',
  'pages.app.provisionColumnTitle': '규정',
  'pages.app.publishAudienceGroupsLabel': '그룹',
  'pages.app.publishAudienceLabel': '공개 대상',
  'pages.app.publishAudienceOptionFirmWide': '회사 전체',
  'pages.app.publishAudienceOptionGroup': '그룹',
  'pages.app.publishAudienceOptionPublic': '전체 공개',
  'pages.app.publishButton': '게시',
  'pages.app.publishConfigTitle': '구성 게시',
  'pages.app.publishFirmWideNotice':
    '이 구성은 조직 내 모든 사용자와 공유됩니다. 승인을 위해 조직 관리자에게 요청이 전송됩니다.',
  'pages.app.publishPublicNotice':
    '이 구성은 모든 사용자에게 공개됩니다. 승인을 위해 최고 관리자에게 요청이 전송됩니다.',
  'pages.app.publishRequestSubmitted': '게시 요청이 제출되었습니다 — 관리자 승인 대기 중',
  'pages.app.publishedToGroup': '그룹에 게시됨',
  'pages.app.readingDocumentName': '{name} 읽는 중',
  'pages.app.restrictionColumnTitle': '제한 사항',
  'pages.app.restrictiveCovenantsTitle': '제한적 특약',
  'pages.app.reuseButton': '재사용',
  'pages.app.runAppButton': '앱 실행',
  'pages.app.sanitizedCheckingDocuments': '문서 확인 중…',
  'pages.app.sanitizedSearchingDocuments': '문서 검색 중…',
  'pages.app.sanitizedWorkingThroughDocuments': '문서 검토 중…',
  'pages.app.saveAsConfigButton': '다른 이름으로 저장',
  'pages.app.saveConfigButton': '구성 저장',
  'pages.app.saveConfigurationTitle': '구성 저장',
  'pages.app.savedPromptStepCount': '{count, plural, other {단계 #개}}',
  'pages.app.savedPromptsEmpty': '저장된 다단계 프롬프트가 없습니다',
  'pages.app.savedPromptsPanelTitle': '저장된 구성 선택',
  'pages.app.savedPromptsSearchPlaceholder': '저장된 프롬프트 검색...',
  'pages.app.savedPromptsTagFilterPlaceholder': '태그로 필터',
  'pages.app.scopeOfWorkModalDescription':
    '지원 또는 서비스 요청이 담긴 고객 이메일, 서한 또는 RFP를 업로드하거나 선택하세요. "프롬프트"에 고객에 대한 세부 정보를 제공하면 도움이 됩니다(예: \'고객은 전자은행 서비스를 전문으로 하는 싱가포르 은행입니다\')',
  'pages.app.searchMattersPlaceholder': '매터 검색...',
  'pages.app.searchPromptsPlaceholder': '프롬프트 검색...',
  'pages.app.selectAtLeastOneGroupError': '하나 이상의 그룹을 선택하세요',
  'pages.app.selectDocumentsStepTitle': '1. 분석할 문서를 선택하세요',
  'pages.app.selectMattersLabel': '매터 선택:',
  'pages.app.sharedConfigLabel': '{name} (공유됨)',
  'pages.app.sourcesColumnTitle': '출처',
  'pages.app.specialRequestsSectionTitle': '특별 요청 사항',
  'pages.app.specificInformationStepTitle': '2. 특정 정보 (선택 사항)',
  'pages.app.stepNamePlaceholder': '단계 이름 (예: 기관 추출)',
  'pages.app.stepNumberLabel': '단계 {number}',
  'pages.app.stepsAddedFromConfig': '{count, plural, other {단계 #개 추가됨}}',
  'pages.app.subagentLabel': '하위 에이전트 {number}',
  'pages.app.subjectLabel': '제목',
  'pages.app.summaryLabel': '요약',
  'pages.app.timelineFieldsDescription':
    '타임라인에 표시할 추가 열을 정의하세요. 각 필드에 대해 키(열 제목)와 추출할 정보에 대한 설명을 입력하세요.',
  'pages.app.tool.checkingDocuments': '문서 확인 중',
  'pages.app.tool.readingDocument': '문서 읽는 중',
  'pages.app.tool.searchingDocuments': '문서 검색 중',
  'pages.app.tool.workingWithName': '작업 중 ({name})',
  'pages.app.tool.writingReport': '보고서 작성 중',
  'pages.app.untitledSession': '(제목 없음)',
  'pages.app.updateConfigButton': '업데이트',
  'pages.app.updateConfigurationTitle': '구성 업데이트',
  'pages.app.updateMattersFailed': '매터 업데이트에 실패했습니다',
  'pages.app.uploadOrSelectFilesError': '파일을 업로드하거나 기존 파일을 선택해 주세요',
  'pages.app.urgencyColumnTitle': '긴급도',
  'pages.app.useAnotherAppButton': '다른 앱 사용',
  'pages.app.whatsNew': '새로운 기능',
  'pages.app.workingEllipsis': '작업 중…',
  'pages.app.workingThroughDocumentsCount': '문서 처리 중 ({completed}/{total})',
  'pages.chat.addToMatters': '매터에 추가',
  'pages.chat.agentQuestion.answersSent': '답변이 에이전트에 전송되었습니다',
  'pages.chat.agentQuestion.customAnswerPlaceholder': '또는 직접 답변을 입력하세요...',
  'pages.chat.agentQuestion.dismissQuestion': '질문 닫기',
  'pages.chat.agentQuestion.noAnswer': '(답변 없음)',
  'pages.chat.agentQuestion.question': '질문',
  'pages.chat.agentQuestion.questionOfTotal': '질문 {current}/{total}',
  'pages.chat.agentQuestion.questionProgress': '{current} / {total}',
  'pages.chat.agentQuestion.reviewAnswers': '답변 검토',
  'pages.chat.agentQuestion.reviewYourAnswers': '제출하기 전에 답변을 검토하세요.',
  'pages.chat.agentQuestion.seeLess': '간략히 보기',
  'pages.chat.agentQuestion.seeMore': '더 보기',
  'pages.chat.agentQuestion.sendAnswers': '답변 보내기',
  'pages.chat.agentQuestion.submitted': '제출됨',
  'pages.chat.agentQuestion.summary': '요약',
  'pages.chat.agenticRag': '에이전틱 RAG',
  'pages.chat.agenticRag.description': '에이전트가 컨텍스트 파일을 검색할 시점을 판단합니다',
  'pages.chat.agenticRag.tooltip':
    '출처가 표시된 에이전틱 검색을 활성화합니다. 채팅 컨텍스트에 문서가 필요합니다.',
  'pages.chat.allowSelfPrompting': '자동 프롬프트 허용',
  'pages.chat.allowSelfPrompting.description':
    '에이전트가 라이브러리에서 맞는 프롬프트를 적용합니다',
  'pages.chat.allowSelfPrompting.tooltip':
    '활성화하면 어시스턴트가 응답 개선을 위해 라이브러리 프롬프트를 제안하고 적용할 수 있습니다.',
  'pages.chat.attachedDocument': '첨부된 문서',
  'pages.chat.auth.contentOpenedInNewTab': '콘텐츠가 새 탭에서 열렸습니다',
  'pages.chat.auth.dataOpenedInNewTab': '데이터가 새 탭에서 열렸습니다',
  'pages.chat.auth.failedToFetchUrl': 'URL을 가져오지 못했습니다: {error}',
  'pages.chat.auth.failedToOpenNewTab': '새 탭을 여는 데 실패했습니다',
  'pages.chat.auth.fileOpenedInNewTab': '파일이 새 탭에서 열렸습니다',
  'pages.chat.auth.jsonResponseTitle': 'JSON 응답',
  'pages.chat.auth.textResponseTitle': '텍스트 응답',
  'pages.chat.cannotCopyNonTextContent': '텍스트가 아닌 콘텐츠는 복사할 수 없습니다',
  'pages.chat.chatTitle': '채팅',
  'pages.chat.clickOrDragToUpload': '클릭하거나 드래그하여 업로드',
  'pages.chat.connectionInterrupted': '연결이 중단되었습니다. {retry}를 눌러 주세요.',
  'pages.chat.context.custom': '사용자 지정 {suffix}',
  'pages.chat.context.defaultWithName': '기본값 ({name})',
  'pages.chat.context.fullContext': '전체 컨텍스트',
  'pages.chat.context.label': '컨텍스트',
  'pages.chat.context.selectedLabel': '선택됨',
  'pages.chat.customisation': '맞춤 설정',
  'pages.chat.dragHereToUpload': '여기로 드래그하여 업로드',
  'pages.chat.emptyState.desktopTitle': '오늘 A&GEL이 무엇을 도와드릴까요?',
  'pages.chat.emptyState.mobileTitle': 'A&GEL이 어떻게 도와드릴까요?',
  'pages.chat.emptyState.subtitle':
    '아래 프롬프트를 선택해 바로 시작하거나, 직접 입력하여 A&GEL과 대화해 보세요.',
  'pages.chat.failedToCopyMessage': '메시지 복사에 실패했습니다',
  'pages.chat.failedToDownloadFile': '파일 다운로드에 실패했습니다: {error}',
  'pages.chat.fileDownloadedSuccessfully': '파일이 성공적으로 다운로드되었습니다',
  'pages.chat.filesInVault': '보관함의 파일',
  'pages.chat.home': '홈',
  'pages.chat.htmlContentIframeTitle': 'HTML 콘텐츠',
  'pages.chat.messageCopied': '메시지가 복사되었습니다!',
  'pages.chat.newChatConfirm.content': '현재 채팅 기록을 지우고 새 세션을 시작하시겠습니까?',
  'pages.chat.newChatConfirm.okText': '예, 새 채팅 시작',
  'pages.chat.newChatConfirm.title': '새 채팅을 시작하시겠습니까?',
  'pages.chat.nextStep.button': '다음 단계',
  'pages.chat.nextStep.review': '검토',
  'pages.chat.nextStep.workstudio': 'Workstudio',
  'pages.chat.referenceDocument': '참조 문서',
  'pages.chat.referenceTitle': '참조: {title}',
  'pages.chat.referencesCount': '참조 {count}건',
  'pages.chat.selectedContext': '선택된 컨텍스트',
  'pages.chat.selfPromptedUsing': '{name}을(를) 사용하여 자동 프롬프트가 적용되었습니다.',
  'pages.chat.showMoreLines': '더 보기 ({count}줄)',
  'pages.chat.sourcesCount': '출처 ({count})',
  'pages.chat.startNewChat': '새 채팅 시작',
  'pages.chat.starterPrompt.caseSummariser.description':
    '싱가포르 판례 요약을 위한 법률 컨텍스트가 포함된 상세 프롬프트입니다.',
  'pages.chat.starterPrompt.caseSummariser.name': '판례 요약',
  'pages.chat.starterPrompt.draftChecklist.description':
    'Angel이 문서에서 체크리스트를 작성하도록 하는 프롬프트입니다.',
  'pages.chat.starterPrompt.draftChecklist.name': '체크리스트 작성',
  'pages.chat.starterPrompt.summariseArticle.description': '기사를 요약하는 범용 프롬프트입니다.',
  'pages.chat.starterPrompt.summariseArticle.name': '이 기사 요약하기',
  'pages.chat.status.completed': '완료됨',
  'pages.chat.status.working': '작업 중',
  'pages.chat.toolCategory.compare': '텍스트 비교 중',
  'pages.chat.toolCategory.generate': '문서 생성 중',
  'pages.chat.toolCategory.read': '문서 읽는 중',
  'pages.chat.toolCategory.searchDoc': '문서 검색 중',
  'pages.chat.toolCategory.searchFiles': '파일 검색 중',
  'pages.chat.toolCategory.selfInstruction': '지침 적용 중',
  'pages.chat.transientFiles': '임시 파일',
  'pages.chat.unknownFileName': '알 수 없음',
  'pages.chat.unknownFileNameLong': '알 수 없는 파일',
  'pages.chat.untitledSession': '(제목 없음)',
  'pages.chat.upload.failedToUploadFile': '{fileName} 업로드에 실패했습니다',
  'pages.chat.upload.fileTypeNotAllowed':
    '허용되지 않는 파일 형식입니다. PDF, DOC, DOCX, MSG, EML, TXT, MD, XLS, XLSX, PPT, PPTX 파일만 허용됩니다.',
  'pages.chat.upload.onlyAllowedTypes':
    'PDF, DOC, DOCX, MSG, EML, TXT, MD, XLS, XLSX, PPT 또는 PPTX 파일만 업로드해 주세요',
  'pages.chat.upload.someFilesSkipped':
    '일부 파일이 제외되었습니다. PDF, DOC, DOCX, MSG, EML, TXT, MD, XLS, XLSX, PPT 또는 PPTX 파일만 허용됩니다',
  'pages.chat.uploadedImageAlt': '업로드됨',
  'pages.chat.waiting.almostThere': '거의 다 됐습니다...',
  'pages.chat.waiting.fetchingThatForYou': '가져오는 중입니다...',
  'pages.chat.waiting.hangTight': '잠시만 기다려 주세요, 처리 중입니다...',
  'pages.chat.waiting.holdOnRetrieving': '잠시만요, 정보를 가져오는 중입니다...',
  'pages.chat.waiting.justAMoment': '잠시만 기다려 주세요...',
  'pages.chat.waiting.letMeCheck': '확인해 보겠습니다...',
  'pages.chat.waiting.lookingThatUp': '찾아보는 중입니다...',
  'pages.chat.waiting.oneSecPlease': '잠시만요...',
  'pages.chat.waiting.workingOnIt': '처리 중입니다...',
  'pages.chat.webSearch.confidentialityNotice':
    '웹 검색이 켜져 있습니다. 프롬프트에 고객 기밀 정보나 변호사·의뢰인 특권이 적용되는 정보를 포함하지 마십시오.',
  'pages.chat.webSearch.permission.title': '검색 권한',
  'pages.chat.webSearch.permission.manual': '수동',
  'pages.chat.webSearch.permission.manualDescription': '각 검색어를 전송 전에 검토합니다',
  'pages.chat.webSearch.permission.auto': '자동',
  'pages.chat.webSearch.permission.autoDescription':
    '검토 없이 실행됩니다. 검색어가 로펌 외부로 전송됩니다',
  'pages.comparison.analysisFallbackTitle': '분석',
  'pages.comparison.outcomeUnverified': '미확인',
  'pages.comparison.commentTags': '댓글 태그',
  'pages.comparison.allCommentTags': '모든 댓글 태그',
  'pages.comparison.noMatchingComments': '선택한 태그와 일치하는 댓글이 없습니다',
  'pages.comparison.downloadExcel': 'Excel 다운로드',
  'pages.comparison.stopSuccess':
    '비교가 성공적으로 중지되었습니다. 부분 결과를 확인할 수 있습니다.',
  'pages.comparison.stopFailed': '비교 중지에 실패했습니다',
  'pages.comparison.uploadSuccess': '{fileName}이(가) 성공적으로 업로드되었습니다',
  'pages.comparison.uploadFailed': '{fileName} 업로드에 실패했습니다',
  'pages.comparison.uploadLimitExceeded':
    '이 작업 유형에는 최대 {max}개의 파일만 업로드할 수 있습니다.',
  'pages.comparison.pollingTimeout':
    '폴링 시간이 초과되었습니다. 작업이 계속 처리 중일 수 있습니다.',
  'pages.comparison.taskStarted': '비교 작업이 시작되었습니다',
  'pages.comparison.startFailed': '비교 시작에 실패했습니다',
  'pages.comparison.previousAnalysisTitle': '이전 분석',
  'pages.comparison.analysisPositionCounter': '{current} / {total}',
  'pages.comparison.analysisFoundCounter': '{total}건 발견',
  'pages.comparison.nextAnalysisTitle': '다음 분석',
  'pages.comparison.messageHeading': '메시지',
  'pages.comparison.noResultsYet': '아직 결과가 없습니다',
  'pages.comparison.startComparisonButton': '비교 시작',
  'pages.comparison.newComparisonButton': '새 비교 시작',
  'pages.comparison.searchComparisonsPlaceholder': '비교 검색',
  'pages.comparison.reuseButton': '재사용',
  'pages.comparison.selectMattersLabel': '매터 선택:',
  'pages.comparison.searchMattersPlaceholder': '매터 검색...',
  'pages.comparison.mattersUpdated': '매터가 성공적으로 업데이트되었습니다',
  'pages.comparison.mattersUpdateFailed': '매터 업데이트에 실패했습니다',
  'pages.comparison.addToMattersButton': '매터에 추가',
  'pages.comparison.untitled': '(제목 없음)',
  'pages.comparison.processingMoreResults': '결과를 추가로 처리하는 중...',
  'pages.comparison.processingComparison': '비교를 처리하는 중...',
  'pages.comparison.taskType.strikethroughUnderline.label': '취소선 및 밑줄',
  'pages.comparison.taskType.strikethroughUnderline.description':
    '표준 취소선 및 밑줄 서식으로 표시된 변경 사항을 분석합니다.',
  'pages.comparison.taskType.trackedChanges.label': '변경 내용 추적',
  'pages.comparison.taskType.trackedChanges.description':
    '변경 내용 추적 기능을 사용하여 작성된 수정 사항과 코멘트를 검토합니다.',
  'pages.comparison.taskType.twoVersions.label': '두 가지 버전',
  'pages.comparison.taskType.twoVersions.description':
    '문서의 두 가지 별도 버전을 비교하여 차이점을 확인합니다.',
  'pages.comparison.taskType.referenceDocument.label': '대상 문서 대 참조 문서',
  'pages.comparison.taskType.referenceDocument.description':
    '대상 문서를 참조 문서(예: 텀시트)와 비교합니다.',
  'pages.comparison.requirement.singleDocument': '단일 문서',
  'pages.comparison.requirement.twoDocuments': '문서 2개',
  'pages.comparison.startHereTab': '여기서 시작',
  'pages.comparison.selectDocumentsPrompt': '비교를 수행할 문서를 선택하세요',
  'pages.comparison.dragUploadText': '클릭하거나 파일을 이 영역으로 드래그하여 업로드하세요',
  'pages.comparison.swapOrderButton': '순서 바꾸기',
  'pages.comparison.fileLabel.old': '(이전) ',
  'pages.comparison.fileLabel.new': '(신규) ',
  'pages.comparison.fileLabel.reference': '(참조) ',
  'pages.comparison.fileLabel.target': '(대상) ',
  'pages.comparison.customInstructionTab': '사용자 지정 지침 (선택 사항)',
  'pages.comparison.modifyPromptTitle': '프롬프트 수정',
  'pages.comparison.customInstructionPlaceholder':
    'A&GEL에 대한 구체적인 지침을 입력하세요 (예: "제 고객은 XYZ입니다. 고객에게 영향을 미치는 수정 사항에 집중해 주세요" 또는 "바하사 말레이시아어로 코멘트 작성")',
  'pages.comparison.pageTitle': '비교',
  'pages.comparison.legalReviewDescription':
    '비교 기능은 수정 사항에 대한 "법률 검토"를 수행하도록 최적화되어 있습니다 (즉, 기본적으로 수정 사항에 따른 법적 결과에 대해 코멘트합니다).',
  'pages.comparison.similarDocumentComparisonTitle': '유사 문서 비교',
  'pages.comparison.referenceDocumentComparisonTitle': '참조 문서 비교',
  'pages.comparison.dragHereToUpload': '업로드하려면 여기로 드래그하세요',
  'pages.comparison.documentCount.unknownFile': '알 수 없는 파일',
  'pages.comparison.documentCount.fileCount': '파일 {count}개',
  'pages.comparison.reviewDirection.reviewedOnBehalfOf': '다음을 대신하여 검토: ',
  'pages.comparison.reviewDirection.swapButton': '검토 방향 바꾸기',
  'pages.comparison.invalidFileDocxOrPdf':
    '{fileName}은(는) 유효한 .docx 또는 .pdf 파일이 아닙니다',
  'pages.comparison.invalidFileDocx': '{fileName}은(는) 유효한 .docx 파일이 아닙니다',
  'pages.comparison.twoVersionsFileCountError':
    '두 가지 버전 비교를 위해 문서 2개를 정확히 업로드해 주세요.',
  'pages.comparison.singleFileCountError': '이 작업을 위해 문서 1개를 정확히 업로드해 주세요.',
  'pages.composer.changeAction.accept': '승인',
  'pages.composer.changeAction.reject': '거부',
  'pages.composer.changeAction.reset': '초기화',
  'pages.composer.documentView.foundCount': '{count}개 찾음',
  'pages.composer.documentView.nextChangeArrow': '다음 ↓',
  'pages.composer.documentView.nextChangeTitle': '다음 변경 사항',
  'pages.composer.documentView.positionCount': '{current} / {total}',
  'pages.composer.documentView.previousChangeTitle': '이전 변경 사항',
  'pages.composer.documentView.stepNumber': '{number}단계',
  'pages.composer.documentView.turnNumber': '턴 {number}',
  'pages.composer.playbook.askAgel': 'A&GEL에 질문하기',
  'pages.composer.playbook.chooseDocumentDescription':
    '.docx 파일을 선택하여 캔버스를 열고 채팅을 시작하세요.',
  'pages.composer.playbook.chooseDocumentTitle': '시작할 문서를 선택하세요',
  'pages.composer.playbook.createSessionFailed': 'Workstudio 세션 생성에 실패했습니다',
  'pages.composer.playbook.documentCanvas': '문서 캔버스',
  'pages.composer.playbook.docxOnlyAllowedError': 'Workstudio 모드에서는 .docx 파일만 허용됩니다',
  'pages.composer.playbook.docxOnlySkippedWarning':
    '일부 파일이 건너뛰어졌습니다. .docx 파일만 허용됩니다',
  'pages.composer.playbook.docxOnlySupportedError': 'Workstudio 모드에서는 .docx 파일만 지원됩니다',
  'pages.composer.playbook.downloadGenerating': '생성하는 중…',
  'pages.composer.playbook.dragToUpload': '업로드하려면 여기로 드래그하세요',
  'pages.composer.playbook.fileUploadFailed': '{fileName} 업로드에 실패했습니다',
  'pages.composer.playbook.fileUploadedSuccess': '{fileName}이(가) 성공적으로 업로드되었습니다',
  'pages.composer.playbook.newButtonText': '새 Workstudio',
  'pages.composer.playbook.openFailed': 'Workstudio 열기에 실패했습니다',
  'pages.composer.playbook.reuseButton': '재사용',
  'pages.composer.playbook.resizeChatPane': '채팅 영역 크기 조절',
  'pages.composer.playbook.searchPlaceholder': 'Workstudio 검색',
  'pages.composer.playbook.title': 'Workstudio',
  'pages.composer.playbookReview.acceptAllButton': '모두 승인',
  'pages.composer.playbookReview.acceptChangeError':
    '변경 사항 승인에 실패했습니다. 다시 시도해 주세요.',
  'pages.composer.playbookReview.addCommentButton': '코멘트',
  'pages.composer.playbookReview.addCommentPlaceholder': '코멘트를 추가하세요...',
  'pages.composer.playbookReview.addCommentTooltip': '코멘트 추가',
  'pages.composer.playbookReview.allAcceptError':
    '모든 변경 사항 승인에 실패했습니다. 다시 시도해 주세요.',
  'pages.composer.playbookReview.allAcceptedSuccess': '모든 변경 사항이 승인되었습니다',
  'pages.composer.playbookReview.allRejectError':
    '모든 변경 사항 거부에 실패했습니다. 다시 시도해 주세요.',
  'pages.composer.playbookReview.allRejectedSuccess': '모든 변경 사항이 거부되었습니다',
  'pages.composer.playbookReview.allResetError':
    '모든 변경 사항 초기화에 실패했습니다. 다시 시도해 주세요.',
  'pages.composer.playbookReview.allResetSuccess': '모든 변경 사항이 대기 상태로 초기화되었습니다',
  'pages.composer.playbookReview.backToWorkstudio': 'Workstudio로 돌아가기',
  'pages.composer.playbookReview.changeOfTotal': '변경 사항 {index}/{total}',
  'pages.composer.playbookReview.commentSaveError':
    '코멘트 저장에 실패했습니다. 다시 시도해 주세요.',
  'pages.composer.playbookReview.commentSavedSuccess': '코멘트가 저장되었습니다',
  'pages.composer.playbookReview.discardDraftButton': '초안 삭제',
  'pages.composer.playbookReview.documentLoadFailedError':
    '이 문서를 불러올 수 없습니다. 새로고침 후 다시 시도해 주세요.',
  'pages.composer.playbookReview.documentViewAriaLabel': '문서 보기',
  'pages.composer.playbookReview.doneEditingButton': '완료',
  'pages.composer.playbookReview.downloadGenericError': '다운로드 생성에 실패했습니다',
  'pages.composer.playbookReview.downloadInfoTooltip':
    '각 턴은 계속 검토할 수 있습니다. 다운로드하면 승인된 레이어와 대기 중인 레이어가 적용된 현재 병합 문서가 생성됩니다.',
  'pages.composer.playbookReview.downloadSuccess': '문서가 성공적으로 다운로드되었습니다!',
  'pages.composer.playbookReview.downloadTimeoutError': '다운로드 생성 시간이 초과되었습니다',
  'pages.composer.playbookReview.editCommentButton': '코멘트 수정',
  'pages.composer.playbookReview.editCommentTooltip': '코멘트 수정',
  'pages.composer.playbookReview.editDocumentButton': '편집',
  'pages.composer.playbookReview.groupAcceptAllCount': '모두 승인 ({count})',
  'pages.composer.playbookReview.groupAcceptedError':
    '변경 사항 승인에 실패했습니다. 다시 시도해 주세요.',
  'pages.composer.playbookReview.groupAcceptedSuccess':
    '동일한 변경 사항 {count}건이 승인되었습니다',
  'pages.composer.playbookReview.groupRejectAllCount': '모두 거부 ({count})',
  'pages.composer.playbookReview.groupRejectedError':
    '변경 사항 거부에 실패했습니다. 다시 시도해 주세요.',
  'pages.composer.playbookReview.groupRejectedSuccess':
    '동일한 변경 사항 {count}건이 거부되었습니다',
  'pages.composer.playbookReview.groupResetAllCount': '모두 초기화 ({count})',
  'pages.composer.playbookReview.groupResetError':
    '변경 사항 초기화에 실패했습니다. 다시 시도해 주세요.',
  'pages.composer.playbookReview.groupResetSuccess':
    '동일한 변경 사항 {count}건이 초기화되었습니다',
  'pages.composer.playbookReview.hidePromptButton': '프롬프트 숨기기',
  'pages.composer.playbookReview.layerChangeCount':
    '{count, plural, one {변경 사항 #건} other {변경 사항 #건}}',
  'pages.composer.playbookReview.loadingDocument': '문서를 불러오는 중...',
  'pages.composer.playbookReview.localDraftTag': '로컬 초안',
  'pages.composer.playbookReview.localDraftTooltip':
    '저장되지 않은 초안입니다. 편집 저장을 사용해 텍스트 변경을 추적 변경으로 기록하세요.',
  'pages.composer.playbookReview.noChangesDescription':
    'AI가 지정된 지침에 대해 제안한 변경 사항이 없습니다.',
  'pages.composer.playbookReview.noChangesFromStep': '이 단계에서 변경 사항 없음',
  'pages.composer.playbookReview.noChangesTitle': '확인된 변경 사항 없음',
  'pages.composer.playbookReview.previousChangesFallback': '이전 변경 사항',
  'pages.composer.playbookReview.processingTimeoutError':
    '처리 시간이 예상보다 오래 걸리고 있습니다. 새로고침하여 상태를 확인해 주세요.',
  'pages.composer.playbookReview.regenerateLabel': '재생성',
  'pages.composer.playbookReview.rejectAllButton': '모두 거부',
  'pages.composer.playbookReview.rejectChangeError':
    '변경 사항 거부에 실패했습니다. 다시 시도해 주세요.',
  'pages.composer.playbookReview.resetAllButton': '모두 초기화',
  'pages.composer.playbookReview.reviewViewAriaLabel': '검토 보기',
  'pages.composer.playbookReview.saveEditsButton': '편집 저장',
  'pages.composer.playbookReview.saveEditsError':
    '편집 내용을 저장하지 못했습니다. 초안은 유지됩니다 — 다시 시도해 주세요.',
  'pages.composer.playbookReview.saveEditsNoChanges': '저장할 텍스트 변경 사항이 없습니다.',
  'pages.composer.playbookReview.saveEditsSuccess': '편집 내용이 추적 변경으로 저장되었습니다.',
  'pages.composer.playbookReview.saveEditsTooltip':
    '텍스트 변경을 추적 변경으로 저장합니다. 서식만 변경한 내용은 저장되지 않습니다.',
  'pages.composer.playbookReview.saveEditsUnavailableTooltip':
    '이 문서의 레이아웃을 문서 텍스트로 되돌릴 수 없어 저장할 수 없습니다. 편집 내용은 로컬 초안으로 유지됩니다.',
  'pages.composer.playbookReview.selfPromptedUsing':
    '{promptName}을(를) 사용하여 자동으로 생성된 프롬프트입니다.',
  'pages.composer.playbookReview.showFullPromptButton': '전체 프롬프트 보기',
  'pages.composer.playbookReview.showMoreIdentical':
    '{action, select, hide {동일한 변경 사항 {count}건 숨기기} other {동일한 변경 사항 {count}건 더 보기}}',
  'pages.composer.playbookReview.showingDocumentView': '문서 보기 표시 중',
  'pages.composer.playbookReview.showingStepView': '단계별 보기 표시 중',
  'pages.composer.playbookReview.status.accepted': '승인됨',
  'pages.composer.playbookReview.status.pending': '대기 중',
  'pages.composer.playbookReview.status.rejected': '거부됨',
  'pages.composer.playbookReview.statusDistributionAriaLabel': '검토 상태 분포',
  'pages.composer.playbookReview.stepChangeCount':
    '{count, plural, one {변경 사항 #건} other {변경 사항 #건}}',
  'pages.composer.playbookReview.stepTag': '{number}단계',
  'pages.composer.playbookReview.stepViewAriaLabel': '단계별 보기',
  'pages.composer.playbookReview.turnNeedsRegeneration': '이 턴은 재생성이 필요합니다.',
  'pages.composer.playbookReview.turnRegenerationReason':
    '이전 턴에서 내린 결정으로 인해 해당 턴의 기반이 된 문서가 변경되었습니다.',
  'pages.composer.playbookReview.turnHasConflicts': '이 턴에는 충돌하는 변경 사항이 있습니다.',
  'pages.composer.playbookReview.turnConflictReason':
    '일부 제안된 변경 사항이 서로 겹칩니다. 다시 적용하려면 턴을 재생성하세요.',
  'pages.composer.playbookReview.turnHasUnlocatableChanges':
    '이 턴에는 위치를 찾을 수 없는 변경 사항이 있습니다.',
  'pages.composer.playbookReview.turnUnlocatableReason':
    '일부 제안된 변경 사항을 문서에서 찾을 수 없습니다. 다시 적용하려면 턴을 재생성하세요.',
  'pages.composer.playbookReview.turnTitle': '턴 {order}: {prompt}',
  'pages.composer.playbookReview.undoChangeError': '실행 취소에 실패했습니다. 다시 시도해 주세요.',
  'pages.composer.playbookReview.updatingCanvas': '검토 캔버스를 업데이트하는 중...',
  'pages.composer.playbookReview.viewChangeTooltip': '원본 문서에서 변경 사항 보기',
  'pages.composer.playbookReview.viewContextButton': '컨텍스트 보기',
  'pages.composer.playbookReview.waitForUpdateWarning':
    '다운로드하기 전에 현재 업데이트가 완료될 때까지 기다려 주세요.',
  'pages.dashboard.allChannelsOption': '전체 채널',
  'pages.dashboard.presetPast30Days': '최근 30일',
  'pages.dashboard.presetToday': '오늘',
  'pages.dashboard.presetWtd': 'WTD',
  'pages.dashboard.presetMtd': 'MTD',
  'pages.dashboard.presetYtd': 'YTD',
  'pages.dashboard.exportLoading': '대시보드 내보내기',
  'pages.dashboard.downloaded': '다운로드됨',
  'pages.dashboard.downloadingName': '{name} 다운로드 중',
  'pages.dashboard.chatGptMessageSeries': 'ChatGPT 메시지',
  'pages.dashboard.storyboardMessageSeries': '스토리보드 메시지',
  'pages.dashboard.broadcastMessageSeries': '브로드캐스트 메시지',
  'pages.dashboard.messageTrendDataTitle': '메시지 추세 데이터',
  'pages.dashboard.messageTrendDataTooltip': '선택한 기간 동안의 메시지 통계 추세입니다.',
  'pages.dashboard.newUsersSeries': '신규 사용자',
  'pages.dashboard.activeUsersSeries': '활성 사용자',
  'pages.dashboard.userTrendDataTitle': '사용자 추세 데이터',
  'pages.dashboard.userTrendDataTooltip': '선택한 기간 동안의 사용자 통계 추세입니다.',
  'pages.dashboard.userActivityHeatmapTitle': '사용자 활동 히트맵',
  'pages.dashboard.userActivityHeatmapTooltip':
    '선택한 기간 동안 요일별·시간대별 평균 사용자 메시지 수입니다.',
  'pages.dashboard.wordCloudTitle': '워드 클라우드',
  'pages.dashboard.wordCloudTooltip':
    '선택한 기간 동안 사용자 메시지에서 자주 사용된 단어를 그래픽으로 표현한 것입니다.',
  'pages.dashboard.realTimeUsersTitle': '실시간 사용자',
  'pages.dashboard.activeUsersTitle': '활성 사용자',
  'pages.dashboard.newUsersTitle': '신규 사용자',
  'pages.dashboard.promptTokensTitle': '프롬프트 토큰',
  'pages.dashboard.completionTokensTitle': '완료 토큰',
  'pages.dashboard.userMessagesTitle': '사용자 메시지',
  'pages.dashboard.chatGptTitle': 'ChatGPT',
  'pages.dashboard.storyboardsTitle': '스토리보드',
  'pages.dashboard.botMessagesTitle': '봇 메시지',
  'pages.dashboard.broadcastsTitle': '브로드캐스트',
  'pages.dashboard.repliesTitle': '회신',
  'pages.dashboard.messageExchangesTitle': '메시지 교환',
  'pages.dashboard.broadcastTitle': '#브로드캐스트',
  'pages.dashboard.outreachTitle': '아웃리치',
  'pages.dashboard.totalUsersTitle': '전체 사용자',
  'pages.dashboard.totalUserMessagesTitle': '전체 사용자 메시지',
  'pages.dashboard.totalBotMessagesTitle': '전체 봇 메시지',
  'pages.dashboard.totalMessageExchangesTitle': '전체 메시지 교환',
  'pages.diagnostics.usersFilter.label': '사용자:',
  'pages.diagnostics.usersFilter.placeholder': '사용자',
  'pages.diagnostics.typesFilter.label': '유형:',
  'pages.diagnostics.typesFilter.placeholder': '유형',
  'pages.diagnostics.dateFilter.label': '날짜:',
  'pages.diagnostics.datePreset.past30Days': '최근 30일',
  'pages.diagnostics.datePreset.today': '오늘',
  'pages.diagnostics.datePreset.wtd': 'WTD',
  'pages.diagnostics.datePreset.mtd': 'MTD',
  'pages.diagnostics.datePreset.ytd': 'YTD',
  'pages.diagnostics.errorItem.description': ' {username} · 생성 시간: {createdTime}',
  'pages.files.you': '나',
  'pages.files.assignAnotherOwnerFirst': '먼저 다른 소유자를 지정해 주세요.',
  'pages.files.keepAtLeastOneMember': '최소 한 명의 구성원을 유지해 주세요.',
  'pages.files.keepAtLeastOneOwner': '최소 한 명의 소유자를 유지해 주세요.',
  'pages.files.deletingEllipsis': '삭제 중...',
  'pages.files.failedToDelete': '삭제하지 못했습니다',
  'pages.files.dropToUploadCurrentFolder': '현재 폴더에 업로드하려면 여기에 놓으세요',
  'pages.files.deleteConfirm.title': '파일 {count}개를 삭제하시겠습니까?',
  'pages.files.fromPath': '출처: {path}',
  'pages.files.createdAtColumn': '생성일',
  'pages.files.favoritesTitle': '즐겨찾기',
  'pages.files.searchFavoritesPlaceholder': '즐겨찾기 검색...',
  'pages.files.chatTooltip': '채팅',
  'pages.files.uploadingEllipsis': '업로드 중...',
  'pages.files.paginationRangeOfTotal': '{total}개 중 {start}-{end}',
  'pages.files.enterNamePlaceholder': '이름 입력',
  'pages.files.deleteConfirm.itemContent': '정말 “{name}”을(를) 삭제하시겠습니까?',
  'pages.files.chatWithFolderTooltip': '이 폴더와 채팅',
  'pages.files.chatWithFileTooltip': '이 파일과 채팅',
  'pages.files.filePreviewAlt': '파일 미리보기',
  'pages.files.fileTypeCannotBePreviewed': '이 파일 형식은 미리 볼 수 없습니다',
  'pages.files.uploadFilesMenuItem': '파일 업로드',
  'pages.files.uploadFolderMenuItem': '폴더 업로드',
  'pages.files.newFolderButton': '새 폴더',
  'pages.files.sortOption.newestFirst': '최신순',
  'pages.files.sortOption.oldestFirst': '오래된순',
  'pages.files.sortOption.nameAZ': '이름 A-Z',
  'pages.files.sortOption.nameZA': '이름 Z-A',
  'pages.files.deleteAllFailedFilesConfirm':
    '{count, plural, one {업로드에 실패한 파일 {count}개를 모두 삭제하시겠습니까?} other {업로드에 실패한 파일 {count}개를 모두 삭제하시겠습니까?}}',
  'pages.files.cleanupButton': '정리',
  'pages.files.selectButton': '선택',
  'pages.files.addGroupTitle': '그룹 추가',
  'pages.files.editGroupTitle': '그룹 편집',
  'pages.files.groupType.privateGroup': '비공개 그룹',
  'pages.files.groupType.firmWide': '전사 공개',
  'pages.files.groupType.public': '공개',
  'pages.files.selectGroupTypeRequired': '그룹 유형을 선택해 주세요.',
  'pages.files.groupNameRequired': '그룹 이름을 입력해 주세요.',
  'pages.files.groupNameTaken': '같은 이름의 그룹이 이미 있습니다.',
  'pages.files.addPersonPlaceholder': '구성원 추가',
  'pages.files.noMembersYet': '아직 구성원이 없습니다.',
  'pages.files.memberColumn': '구성원',
  'pages.files.roleColumn': '역할',
  'pages.files.roleOwner': '소유자',
  'pages.files.roleMember': '구성원',
  'pages.files.revisionHistoryTitle': '수정 이력',
  'pages.files.renamedTo': ' → ',
  'pages.files.noFieldValue': '{field} 없음',
  'pages.files.chatWithGroupTooltip': '이 그룹과 채팅',
  'pages.files.searchFilesPlaceholder': '파일 검색...',
  'pages.files.historyTitle': '기록',
  'pages.files.addNewButton': '새로 추가',
  'pages.files.homeButton': '홈',
  'pages.files.selectFolderPlaceholder': '폴더 선택',
  'pages.files.moveMultipleFilesTitle': '파일 {count}개 이동',
  'pages.files.moveSingleFileTitle': '“{name}” 이동',
  'pages.files.addAtLeastOneMember': '최소 한 명의 구성원을 추가해 주세요.',
  'pages.files.selectAtLeastOneOwner': '최소 한 명의 소유자를 선택해 주세요.',
  'pages.files.folderWarning.privateGroup': '보안 수준 낮음: 그룹 구성원에게 공개됩니다.',
  'pages.files.folderWarning.firmWide': '보안 수준 매우 낮음: 회사 전체에 공개됩니다.',
  'pages.files.folderWarning.public': '보안 수준 매우 낮음: 모든 사용자에게 공개됩니다.',
  'pages.files.duplicateFileNameError': '파일 이름이 중복됩니다. 파일 이름을 변경해 주세요',
  'pages.files.failedToUpdate': '업데이트하지 못했습니다',
  'pages.files.filesDeletedCount': '파일 {count}개 삭제됨',
  'pages.files.filesMovedCount': '파일 {count}개 이동됨',
  'pages.files.failedToDeleteCount': '파일 {count}개를 삭제하지 못했습니다',
  'pages.files.failedToMoveCount': '파일 {count}개를 이동하지 못했습니다',
  'pages.files.filesDeletedCountWithFailures': '파일 {count}개 삭제됨, {failedCount}개 실패',
  'pages.files.filesMovedCountWithFailures': '파일 {count}개 이동됨, {failedCount}개 실패',
  'pages.files.failedToDeleteFiles': '파일을 삭제하지 못했습니다',
  'pages.files.failedToMoveFiles': '파일을 이동하지 못했습니다',
  'pages.files.unnamedFile': '이름 없음',
  'pages.files.failedToUploadFile': '{fileName}을(를) 업로드하지 못했습니다',
  'pages.files.failedToCreateFolder': '폴더를 생성하지 못했습니다: {folderName}',
  'pages.files.someFilesSkippedUnsupportedTypes':
    '지원되지 않는 형식이라 일부 파일을 건너뛰었습니다',
  'pages.files.uploadingFolderEllipsis': '폴더 업로드 중...',
  'pages.files.folderUploadFailed': '폴더 업로드에 실패했습니다',
  'pages.files.allowedFileTypesMessage':
    'PDF, DOC, DOCX, MSG, EML, TXT, MD, PPT, PPTX, XLS, XLSX 파일만 지원됩니다',
  'pages.library.attachedDocsAccessNote':
    '프롬프트에 첨부된 문서에 대한 접근 권한은 프롬프트 자체의 접근 권한과 동일하게 적용됩니다.',
  'pages.library.functionOption.summarise': '요약',
  'pages.library.functionOption.review': '검토',
  'pages.library.functionOption.amend': '수정',
  'pages.library.functionOption.redFlagging': '레드플래깅',
  'pages.library.functionOption.promptlet': '프롬프릿',
  'pages.library.visibilityOption.personal': '개인',
  'pages.library.visibilityOption.group': '그룹',
  'pages.library.visibilityOption.firmWide': '회사 전체',
  'pages.library.visibilityOption.public': '공개',
  'pages.library.updateSuccess': '성공적으로 업데이트되었습니다',
  'pages.library.updateFailed': '업데이트에 실패했습니다',
  'pages.library.copySuccess': '프롬프트가 클립보드에 복사되었습니다!',
  'pages.library.copyFailed': '프롬프트 복사에 실패했습니다',
  'pages.library.selfInstruction': '자가 지시',
  'pages.library.pendingApproval': '승인 대기 중',
  'pages.library.publishPromptModalTitle': '프롬프트 게시',
  'pages.library.publishButton': '게시',
  'pages.library.publishRequestSentToAdmin':
    '이 프롬프트 게시 요청이 승인을 위해 관리자에게 전송되었습니다.',
  'pages.library.publishSuccess': '프롬프트가 성공적으로 게시되었습니다.',
  'pages.library.publishFailedDefault': '게시 요청을 제출하지 못했습니다. 다시 시도해 주세요.',
  'pages.library.field.visibility': '공개 범위',
  'pages.library.firmWideVisibilityNote':
    '이 프롬프트는 조직 내 모든 사용자에게 표시됩니다. 승인을 위해 조직 관리자에게 요청이 전송됩니다.',
  'pages.library.publicVisibilityNote':
    '이 프롬프트는 모든 사용자에게 표시됩니다. 승인을 위해 최고 관리자에게 요청이 전송됩니다.',
  'pages.library.pendingApprovalNote':
    '게시 요청이 승인 대기 중입니다. 요청이 승인 또는 거부될 때까지 회사 전체 및 공개 옵션을 사용할 수 없습니다.',
  'pages.library.cloneButton': '복제',
  'pages.library.chatWithPromptButton': '이 프롬프트로 채팅하기',
  'pages.library.enterPromptNamePlaceholder': '프롬프트 이름 입력',
  'pages.library.field.purpose': '목적',
  'pages.library.enterPurposePlaceholder': '목적 입력',
  'pages.library.field.notes': '메모',
  'pages.library.enterNotesPlaceholder': '메모 입력',
  'pages.library.field.author': '작성자',
  'pages.library.allowSelfInstruction': '자가 지시 허용',
  'pages.library.attachedDocuments': '첨부 문서',
  'pages.library.documentsCount': '문서 {count}개',
  'pages.library.field.prompt': '프롬프트',
  'pages.library.enterPromptContentPlaceholder': '프롬프트 내용 입력',
  'pages.library.noPromptsSelected': '선택된 프롬프트가 없습니다',
  'pages.library.promptClonedSuccess': '프롬프트가 성공적으로 복제되었습니다',
  'pages.library.cloneAuthorLabel': '작성자: {author}',
  'pages.library.cloneAudienceLabel': '공개 대상: {visibility}',
  'pages.library.undoChangesButton': '변경 취소',
  'pages.library.saveChangesButton': '변경 사항 저장',
  'pages.library.unsavedChangesTitle': '저장되지 않은 변경 사항',
  'pages.library.unsavedChangesContent': '저장되지 않은 변경 사항이 있습니다. 종료하시겠습니까?',
  'pages.library.exitModifyButton': '수정 종료',
  'pages.library.field.tags': '태그',
  'pages.library.title': '프롬프트 라이브러리',
  'pages.library.description':
    'AI 언어 모델과의 상호작용을 안내하거나 최적화하는 데 사용되는 사전 설계된 프롬프트 모음입니다. 글쓰기, 코딩, 데이터 분석, 창작 등 목적, 작업 또는 분야별로 프롬프트를 정리하는 중앙 저장소 역할을 합니다.',
  'pages.library.exitCompareButton': '비교 종료',
  'pages.library.compareButton': '비교',
  'pages.library.addPromptModalTitle': '프롬프트 추가',
  'pages.library.addButton': '추가 +',
  'pages.library.tagsPlaceholder': '태그 목록',
  'pages.library.filterByFunctionPlaceholder': '기능별 필터',
  'pages.library.filterByAudiencePlaceholder': '공개 대상별 필터',
  'pages.library.searchPlaceholder': '프롬프트 및 태그 검색',
  'pages.library.favoriteOnly': '즐겨찾기만',
  'pages.library.filterByLabel': '필터:',
  'pages.library.compareSelectHint': '비교할 프롬프트를 2~3개 선택하세요',
  'pages.library.untitledPrompt': '제목 없는 프롬프트',
  'pages.library.compareLimitWarning': '최대 3개까지 프롬프트를 비교할 수 있습니다',
  'pages.library.copyPromptButton': '프롬프트 복사',
  'pages.organisation.idColumnTitle': 'ID',
  'pages.organisation.untitledOrganisationFallback': '제목 없는 조직',
  'pages.organisation.userLimitLabel': '사용자 제한',
  'pages.organisation.userLimitUnlimitedCount': '{count} / 무제한',
  'pages.organisation.userLimitUnlimited': '무제한',
  'pages.organisation.userLimitOnly': '제한: {limit}',
  'pages.organisation.msTenantIdsLabel': 'MS 테넌트 ID',
  'pages.organisation.organisationsTableHeaderTitle': '조직',
  'pages.organisation.createOrganisationLabel': '조직 생성',
  'pages.organisation.usersTableHeaderTitle': '{orgName} 사용자',
  'pages.organisation.defaultOrganisationName': '조직',
  'pages.organisation.userLimitReachedTooltip': '사용자 제한에 도달했습니다',
  'pages.organisation.addUserButtonLabel': '사용자 추가',
  'pages.organisation.usernameColumnTitle': '사용자 이름',
  'pages.organisation.emailColumnTitle': '이메일',
  'pages.organisation.roleLabel': '역할',
  'pages.organisation.defaultUserRoleLabel': '사용자',
  'pages.organisation.changeRoleButtonLabel': '역할 변경',
  'pages.organisation.removeUserConfirmTitle': '조직에서 사용자를 제거하시겠습니까?',
  'pages.organisation.userRemovedSuccessMessage': '사용자가 제거되었습니다',
  'pages.organisation.unableToRemoveUserErrorMessage': '사용자를 제거할 수 없습니다',
  'pages.organisation.editOrganisationModalTitle': '조직 편집',
  'pages.organisation.organisationUpdatedSuccessMessage': '조직이 성공적으로 업데이트되었습니다',
  'pages.organisation.organisationCreatedSuccessMessage': '조직이 성공적으로 생성되었습니다',
  'pages.organisation.organisationNameRequiredMessage': '조직 이름은 필수입니다',
  'pages.organisation.organisationNameLabel': '조직 이름',
  'pages.organisation.userLimitTooltip':
    '허용되는 최대 사용자 수입니다. 무제한으로 설정하려면 비워 두세요.',
  'pages.organisation.msTenantIdsTooltip':
    '이 Microsoft 테넌트 ID에 속한 사용자는 SSO로 로그인할 수 있습니다.',
  'pages.organisation.userEmailLabel': '사용자 이메일',
  'pages.organisation.userEmailPlaceholder': 'user@company.com',
  'pages.organisation.emailRequiredMessage': '이메일은 필수입니다',
  'pages.organisation.roleRequiredMessage': '역할은 필수입니다',
  'pages.organisation.userAddedSuccessMessage': '사용자가 추가되었습니다',
  'pages.organisation.unableToAddUserErrorMessage': '사용자를 추가할 수 없습니다',
  'pages.organisation.roleUpdatedSuccessMessage': '역할이 업데이트되었습니다',
  'pages.organisation.unableToUpdateRoleErrorMessage': '역할을 업데이트할 수 없습니다',
  'pages.organisation.unableToLoadRolesErrorMessage': '역할을 불러올 수 없습니다',
  'pages.playbook.header.title': 'Workstudio',
  'pages.playbook.emptyState.title': '준비되었습니다.',
  'pages.playbook.emptyState.description':
    '재작성, 조항 검토, 요약 또는 특정 수정 사항을 요청해 보세요.',
  'pages.playbook.checkingDocument': '문서를 확인하는 중...',
  'pages.playbook.updatingReviewCanvas': '검토 캔버스를 업데이트하는 중...',
  'pages.playbook.inputPlaceholder': 'A&GEL에게 변경할 내용을 알려주세요...',
  'pages.playbook.inputAriaLabel': 'Workstudio 지시사항',
  'pages.playbook.contextButton': '컨텍스트',
  'pages.playbook.sendButtonAriaLabel': 'Workstudio 지시사항 보내기',
  'pages.playbook.sendInstructionError': 'Workstudio 지시사항을 보내지 못했습니다',
  'pages.projectsHub.func.chat': '채팅',
  'pages.projectsHub.func.scribe': '스크라이브',
  'pages.projectsHub.func.apps': '앱',
  'pages.projectsHub.func.review': '검토',
  'pages.projectsHub.func.sideBySide': '나란히 보기',
  'pages.projectsHub.func.comparison': '비교',
  'pages.projectsHub.func.translation': '번역',
  'pages.projectsHub.func.template': '맞춤 출력',
  'pages.projectsHub.func.quote': '견적',
  'pages.projectsHub.untitledSession': '제목 없음',
  'pages.projectsHub.untitledFileLabel': '(제목 없음)',
  'pages.projectsHub.errors.loadDataFailed': '데이터를 불러오지 못했습니다',
  'pages.projectsHub.subfolderCreated': '하위 폴더가 생성되었습니다',
  'pages.projectsHub.collectionCreated': '컬렉션이 생성되었습니다',
  'pages.projectsHub.errors.createFailed': '생성하지 못했습니다',
  'pages.projectsHub.errors.updateFailed': '업데이트하지 못했습니다',
  'pages.projectsHub.deleteCollectionConfirm.title': '컬렉션 삭제',
  'pages.projectsHub.deleteCollectionConfirm.content': '"{name}"을(를) 삭제하시겠습니까?',
  'pages.projectsHub.collectionDeleted': '삭제되었습니다',
  'pages.projectsHub.errors.deleteFailed': '삭제 실패',
  'pages.projectsHub.sessionsAdded': '{count}개의 세션이 추가되었습니다',
  'pages.projectsHub.errors.addSessionsFailed': '추가 실패',
  'pages.projectsHub.sessionRemoved': '세션이 제거되었습니다',
  'pages.projectsHub.errors.removeSessionFailed': '세션 제거 실패',
  'pages.projectsHub.sessionsRemoved': '{count}개의 세션이 제거되었습니다',
  'pages.projectsHub.errors.removeSessionsFailed': '세션 제거 실패',
  'pages.projectsHub.fieldSaved': '저장되었습니다',
  'pages.projectsHub.errors.saveFieldFailed': '저장 실패',
  'pages.projectsHub.folderDeleted': '폴더가 삭제되었습니다',
  'pages.projectsHub.errors.deleteFolderFailed': '폴더 삭제 실패',
  'pages.projectsHub.folderCreated': '폴더가 생성되었습니다',
  'pages.projectsHub.errors.createFolderFailed': '폴더 생성 실패',
  'pages.projectsHub.deleteFolderConfirm.description':
    '"{name}" 및 모든 콘텐츠를 삭제하시겠습니까?',
  'pages.projectsHub.deleteSessionsConfirm.title': '세션 삭제',
  'pages.projectsHub.deleteSessionsConfirm.description':
    '이 컬렉션에서 {count}개의 세션을 제거하시겠습니까?',
  'pages.projectsHub.removeSessionConfirm.title': '세션 제거',
  'pages.projectsHub.removeSessionConfirm.description':
    '이 컬렉션에서 "{name}"을(를) 제거하시겠습니까?',
  'pages.projectsHub.sort.newestFirst': '최신순',
  'pages.projectsHub.sort.oldestFirst': '오래된순',
  'pages.projectsHub.sort.nameAsc': '이름 (A-Z)',
  'pages.projectsHub.sort.nameDesc': '이름 (Z-A)',
  'pages.projectsHub.doubleClickToOpen': '더블클릭하여 열기',
  'pages.projectsHub.tidyUp': '정리',
  'pages.projectsHub.exit': '나가기',
  'pages.projectsHub.manage': '관리',
  'pages.projectsHub.deleteSessionsButton': '삭제 ({count})',
  'pages.projectsHub.searchSessionsPlaceholder': '세션 검색',
  'pages.projectsHub.emptyState.noFiles': '파일 없음',
  'pages.projectsHub.newFolderButton': '새 폴더',
  'pages.projectsHub.addSessionsButton': '세션 추가',
  'pages.projectsHub.folderInfoLabel': '폴더 정보',
  'pages.projectsHub.mattersHeading': '매터',
  'pages.projectsHub.mattersSubtitle':
    '하나의 워크스페이스에서 컬렉션을 생성하고 다양한 기능의 세션을 정리하세요.',
  'pages.projectsHub.hubBreadcrumbLabel': '허브',
  'pages.projectsHub.deleteFolderButton': '폴더 삭제',
  'pages.projectsHub.itemsLabel': '항목',
  'pages.projectsHub.selectSubfolderEmptyState': '세부 정보를 보려면 하위 폴더를 선택하세요',
  'pages.projectsHub.selectFolderEmptyState': '세부 정보를 보려면 폴더를 선택하세요',
  'pages.projectsHub.noCollectionsMatch': '현재 필터와 일치하는 컬렉션이 없습니다.',
  'pages.projectsHub.noSessionsFoundForFunction': '{func} 세션을 찾을 수 없습니다.',
  'pages.projectsHub.addSelectedSessionsButton':
    '{count, plural, =0 {선택 항목 추가} other {#개 세션 추가}}',
  'pages.projectsHub.step1ChooseFunctionType': '1단계 — 기능 유형 선택',
  'pages.projectsHub.selectFunctionPlaceholder': '기능 선택',
  'pages.projectsHub.step2SelectSessions': '2단계 — 추가할 세션 선택',
  'pages.projectsHub.createFolderButton': '폴더 생성',
  'pages.projectsHub.folderNameLabel': '폴더 이름',
  'pages.projectsHub.subfolderNamePlaceholder': '예: 실사(Due Diligence)',
  'pages.projectsHub.collectionNamePlaceholder': '예: M&A 실사',
  'pages.projectsHub.optionalDescriptionPlaceholder': '설명 (선택 사항)',
  'pages.projectsHub.optionalNotesPlaceholder': '메모 (선택 사항)',
  'pages.projectsHub.createCollectionModalTitle': '컬렉션 생성',
  'pages.projectsHub.collectionNameLabel': '컬렉션 이름',
  'pages.projectsHub.editCollectionModalTitle': '편집 • {name}',
  'pages.projectsHub.itemCountLabel': '{count, plural, one {#개 항목} other {#개 항목}}',
  'pages.projectsHub.fileCountLabel': '{count, plural, one {#개 파일} other {#개 파일}}',
  'pages.quote.historyTooltip': '기록 (Tab+H)',
  'pages.quote.hideTooltip': '숨기기 (Tab+H)',
  'pages.quote.newQuoteTooltip': '새 견적서 (Tab+N)',
  'pages.quote.untitled': '(제목 없음)',
  'pages.quote.newQuote': '새 견적서',
  'pages.quote.deletedExample': '삭제된 예시',
  'pages.quote.generateDescription': '템플릿과 사실관계를 바탕으로 견적서를 생성합니다',
  'pages.quote.sizeLabel': '분량',
  'pages.quote.sizeShort': '짧게',
  'pages.quote.sizeMedium': '보통',
  'pages.quote.sizeLong': '길게',
  'pages.quote.examplesLabel': '예시',
  'pages.quote.promptLabel': '프롬프트',
  'pages.quote.examplesTitle': '예시',
  'pages.quote.quoteTitle': '견적서',
  'pages.quote.uploadManageExamples': '예시 업로드 / 관리',
  'pages.quote.generateQuoteSubtitle': '견적서 생성',
  'pages.quote.fileLabel': '파일',
  'pages.quote.deleteConfirmTitle': '다음 예시를 삭제하시겠습니까?',
  'pages.review.addAtLeastOneQuestion': '제출하기 전에 질문을 하나 이상 추가해 주세요.',
  'pages.review.addAtLeastOneQuestionFirst': '먼저 질문을 하나 이상 추가해 주세요.',
  'pages.review.addAtLeastOneQuestionRule': '질문을 하나 이상 추가해 주세요',
  'pages.review.addQuestionButton': '질문',
  'pages.review.addSectionButton': '섹션',
  'pages.review.addToMatters': '매터에 추가',
  'pages.review.adhocModifyMode': '임시 수정',
  'pages.review.audiencePlaceholder': '고객사 또는 대상 독자 이름',
  'pages.review.authorLabel': '작성자',
  'pages.review.categoryLabel': '카테고리',
  'pages.review.cellDetailsDrawer.addCommentPlaceholder': '댓글 추가...',
  'pages.review.cellDetailsDrawer.answer': '답변',
  'pages.review.cellDetailsDrawer.comments': '댓글',
  'pages.review.cellDetailsDrawer.commentsWithCount': '댓글 ({count})',
  'pages.review.cellDetailsDrawer.exactMatch': '원본 문서에서 정확히 일치하는 항목을 찾았습니다',
  'pages.review.cellDetailsDrawer.explanation': '설명',
  'pages.review.cellDetailsDrawer.fullReference': '전체 참조',
  'pages.review.cellDetailsDrawer.fuzzyMatch': '원본 문서에서 유사한 항목을 찾았습니다',
  'pages.review.cellDetailsDrawer.openDocument': '문서 열기',
  'pages.review.cellDetailsDrawer.openInSearch': '검색에서 열기',
  'pages.review.cellDetailsDrawer.verified': '확인됨',
  'pages.review.cellDetailsDrawer.verify': '확인',
  'pages.review.cellMarkedUnverified': '셀이 미확인으로 표시되었습니다',
  'pages.review.cellMarkedVerified': '셀이 확인됨으로 표시되었습니다',
  'pages.review.cellUpdateFailed': '셀 업데이트 실패',
  'pages.review.cellUpdatedSuccessfully': '셀이 성공적으로 업데이트되었습니다',
  'pages.review.cellVerificationUpdateFailed': '셀 확인 상태 업데이트 실패',
  'pages.review.changesUndone': '변경 사항이 취소되었습니다',
  'pages.review.chatWithEntireOutput': '전체 결과와 채팅하기',
  'pages.review.cloneButton': '복제',
  'pages.review.clonedNamePrefix': '복제됨 - {name}',
  'pages.review.columnEditModal.addTitle': '새 문서 추가 (열)',
  'pages.review.columnEditModal.columnUpdated':
    '열 업데이트가 시작되었습니다. 잠시 후 열이 새로고침됩니다.',
  'pages.review.columnEditModal.columnsAdded':
    '새 열이 추가되었습니다. 잠시 후 매트릭스가 새로고침됩니다.',
  'pages.review.columnEditModal.dropToUpload': '업로드하려면 파일을 여기에 놓으세요',
  'pages.review.columnEditModal.fileRequired': '이 열에 사용할 파일을 업로드하거나 선택해 주세요.',
  'pages.review.columnEditModal.filesRequiredValidation':
    '파일을 업로드하거나 기존 파일을 선택해 주세요',
  'pages.review.columnEditModal.updateFailed': '열 업데이트 실패',
  'pages.review.columnEditModal.updateTitle': '이 열의 새 문서',
  'pages.review.createQuestionListButton': '질문 목록 생성',
  'pages.review.createdByYou': '나',
  'pages.review.customInstruction': '사용자 지정 지침',
  'pages.review.customInstructionOptional': '사용자 지정 지침 (선택 사항)',
  'pages.review.deleteQuestionListConfirm': '이 질문 목록을 삭제하시겠습니까?',
  'pages.review.downloadExcel': 'Excel (.xlsx)',
  'pages.review.downloadWord': 'Word (.docx)',
  'pages.review.dragHereToUpload': '업로드하려면 여기로 드래그하세요',
  'pages.review.exitButton': '나가기',
  'pages.review.exitClone': '복제 종료',
  'pages.review.exitCreate': '생성 종료',
  'pages.review.exitModify': '수정 종료',
  'pages.review.fileCount': '파일 {count}개',
  'pages.review.mattersUpdateFailed': '매터 업데이트 실패',
  'pages.review.mattersUpdated': '매터가 성공적으로 업데이트되었습니다',
  'pages.review.modifyButton': '수정',
  'pages.review.newCategoryPlaceholder': '새 카테고리',
  'pages.review.newQuestionListDefaultName': '새 검토 질문 목록',
  'pages.review.noEmailOnFile': '등록된 이메일이 없습니다',
  'pages.review.noNotesAvailable': '사용 가능한 메모가 없습니다.',
  'pages.review.noPrivateGroupsFound': '비공개 그룹을 찾을 수 없습니다',
  'pages.review.noPurposeAvailable': '사용 가능한 목적이 없습니다.',
  'pages.review.noQuestionsYet': '아직 질문이 없습니다.',
  'pages.review.notesLabel': '메모',
  'pages.review.pendingApproval': '승인 대기 중',
  'pages.review.pollingTimeout': '폴링 시간이 초과되었습니다. 검토가 계속 처리 중일 수 있습니다.',
  'pages.review.publishButton': '게시',
  'pages.review.publishFailed': '질문 목록 게시에 실패했습니다',
  'pages.review.publishTargetFirm': '법인 전체',
  'pages.review.publishToLabel': '게시 대상:',
  'pages.review.publishedAccess.firm': '법인',
  'pages.review.publishedAccess.privateGroup': '비공개 그룹',
  'pages.review.publishedAccess.public': '공개',
  'pages.review.publishedToLabel': '{access}에 게시됨',
  'pages.review.publishedToPrivateGroup': '질문 목록이 비공개 그룹에 게시되었습니다',
  'pages.review.publishedToPrivateGroups': '질문 목록이 비공개 그룹들에 게시되었습니다',
  'pages.review.purposeLabel': '목적',
  'pages.review.questionListCloned': '질문 목록이 복제되었습니다',
  'pages.review.questionListCreated': '질문 목록이 생성되었습니다',
  'pages.review.questionListDeleted': '질문 목록이 삭제되었습니다',
  'pages.review.questionListImporter.allColumns': '모든 열 (모든 셀 결합)',
  'pages.review.questionListImporter.checklistText': '체크리스트 텍스트',
  'pages.review.questionListImporter.checklistTextPlaceholder':
    '체크리스트를 여기에 붙여넣으세요. 한 줄에 하나의 요구 사항을 입력합니다.',
  'pages.review.questionListImporter.columnOption': '열 {index} - {label}',
  'pages.review.questionListImporter.couldNotParse': '체크리스트를 분석할 수 없습니다.',
  'pages.review.questionListImporter.couldNotReadFile': '{fileName} 파일을 읽을 수 없습니다.',
  'pages.review.questionListImporter.docxColumn': 'DOCX 열',
  'pages.review.questionListImporter.dropZoneHint':
    'DOCX, PDF, EML, MSG, TXT 또는 MD 파일. 파일은 로컬에 저장됩니다.',
  'pages.review.questionListImporter.dropZoneText':
    '체크리스트를 클릭하거나 이 영역으로 드래그하세요',
  'pages.review.questionListImporter.granularityEveryLine': '모든 줄을 질문으로',
  'pages.review.questionListImporter.granularityLevel2': '레벨 2까지',
  'pages.review.questionListImporter.granularityLevel3': '레벨 3까지',
  'pages.review.questionListImporter.granularityLevel4': '레벨 4까지',
  'pages.review.questionListImporter.granularityLevel5': '레벨 5까지',
  'pages.review.questionListImporter.granularityTopLevel': '최상위 레벨만',
  'pages.review.questionListImporter.groupByLevel': '레벨별로 질문 그룹화',
  'pages.review.questionListImporter.importQuestions': '질문 가져오기',
  'pages.review.questionListImporter.importQuestionsAction': '질문 가져오기',
  'pages.review.questionListImporter.loadedFile': '{fileName} 로드됨',
  'pages.review.questionListImporter.noQuestionsDetected':
    '체크리스트에서 질문이 감지되지 않았습니다.',
  'pages.review.questionListImporter.noQuestionsSelected': '가져올 질문이 선택되지 않았습니다.',
  'pages.review.questionListImporter.pasteOrSelectRequired':
    '미리 보기 전에 체크리스트를 붙여넣거나 선택하세요.',
  'pages.review.questionListImporter.previewQuestions': '질문 미리 보기',
  'pages.review.questionListImporter.questionGranularity': '질문 세분화 수준',
  'pages.review.questionListImporter.questionsReadyCount':
    '{count, plural, one {질문 #개 준비됨} other {질문 #개 준비됨}}',
  'pages.review.questionListImporter.readingChecklist': '체크리스트 읽는 중...',
  'pages.review.questionListImporter.removeFile': '파일 제거',
  'pages.review.questionListImporter.removeQuestion': '질문 {number} 제거',
  'pages.review.questionListImporter.removeQuestionsHint': '가져오지 않을 질문은 제거하세요.',
  'pages.review.questionListImporter.reviewQuestions': '질문 검토',
  'pages.review.questionListNamePlaceholder': '검토 질문 목록 이름',
  'pages.review.questionListUpdated': '질문 목록이 업데이트되었습니다',
  'pages.review.questionNamePlaceholder': '질문',
  'pages.review.questionRow.dragToReorder': '드래그하여 순서 변경',
  'pages.review.questionRow.moveDown': '아래로 이동',
  'pages.review.questionRow.moveUp': '위로 이동',
  'pages.review.questionRow.rowType': '행 유형',
  'pages.review.questionsList': '질문 목록',
  'pages.review.quickQuestionsDescription':
    '임의의 질문 세트를 기반으로 하나 이상의 문서에 대한 구조화된 검토를 생성합니다',
  'pages.review.quickQuestionsHeading': '빠른 질문',
  'pages.review.rejected': '거부됨',
  'pages.review.resizeHint': '테두리를 드래그하여 크기를 조절하세요.',
  'pages.review.restoreConfigFailed': '구성을 복원하지 못했습니다. 다시 시도해 주세요.',
  'pages.review.resultPanel.processing': '처리 중',
  'pages.review.resultPanel.stopped': '처리가 중지되었습니다.',
  'pages.review.reuseButton': '재사용',
  'pages.review.rowEditModal.addTitle': '새 질문 추가 (행)',
  'pages.review.rowEditModal.promptLabel': '프롬프트',
  'pages.review.rowEditModal.promptRequired': '프롬프트를 입력해 주세요.',
  'pages.review.rowEditModal.rowAdded': '새 행이 추가되었습니다. 매트릭스가 곧 새로고침됩니다.',
  'pages.review.rowEditModal.rowUpdated': '행 업데이트가 시작되었습니다. 행이 곧 새로고침됩니다.',
  'pages.review.rowEditModal.updateFailed': '행 업데이트에 실패했습니다',
  'pages.review.rowEditModal.updateTitle': '질문 프롬프트 업데이트',
  'pages.review.saveAsButton': '다른 이름으로 저장',
  'pages.review.saveChangesButton': '변경 사항 저장',
  'pages.review.searchMattersPlaceholder': '매터 검색...',
  'pages.review.sectionNamePlaceholder': '섹션 제목',
  'pages.review.selectCellHint': '셀, 행 또는 열을 클릭하여 선택하세요.',
  'pages.review.selectDocumentsToReview': '검토를 진행할 문서를 선택하세요',
  'pages.review.selectDocumentsToReviewNumbered': '2. 검토를 진행할 문서를 선택하세요',
  'pages.review.selectMatters': '매터 선택:',
  'pages.review.selectPrivateGroupsHint': '공유할 비공개 그룹을 하나 이상 선택하세요:',
  'pages.review.selectPrivateGroupsPlaceholder': '비공개 그룹 선택',
  'pages.review.sentForApproval': '질문 목록이 승인 요청되었습니다',
  'pages.review.sentimentLegendPrefix': '범례: AI의 감정 판단:',
  'pages.review.sentimentNegative': '부정적',
  'pages.review.sentimentPositive': '긍정적',
  'pages.review.showAll': '전체 보기',
  'pages.review.startNewReview': '새 검토 시작',
  'pages.review.stayButton': '머무르기',
  'pages.review.submitReviewFailed': '검토 제출에 실패했습니다',
  'pages.review.systemPromptLabel': '시스템 프롬프트',
  'pages.review.tabs.customiseOptional': '사용자 지정 (선택 사항)',
  'pages.review.tabs.prompts': '프롬프트',
  'pages.review.tabs.selectDocuments': '문서 선택',
  'pages.review.tabs.startHere': '여기서 시작',
  'pages.review.typeHerePlaceholder': '여기에 입력하세요...',
  'pages.review.undoChangesButton': '변경 취소',
  'pages.review.unsavedChangesWillBeLost': '저장하지 않은 변경 사항은 사라집니다.',
  'pages.review.untitledSession': '(제목 없음)',
  'pages.review.updateFailed': '업데이트에 실패했습니다',
  'pages.review.viewMode': '보기',
  'pages.review.whatsNewDescription':
    '문서 검토 프로세스를 향상시키는 여러 새로운 기능이 추가되었습니다.',
  'pages.review.whoIsItFor': '누구를 위한 기능인가요?',
  'pages.review.whoIsItForNumbered': '1. 누구를 위한 기능인가요?',
  'pages.scribe.addToMatters': '매터에 추가',
  'pages.scribe.aiWorking': 'AI가 작업 중입니다...',
  'pages.scribe.appDescription': '오디오 파일 또는 녹음을 구조화된 텍스트로 변환합니다.',
  'pages.scribe.audioUploadFailedSavingOnly': '오디오 파일 업로드에 실패하여 녹취록만 저장합니다',
  'pages.scribe.audioUploadSuccess': '오디오 파일이 업로드되었습니다',
  'pages.scribe.autoDetect': '자동 감지',
  'pages.scribe.autoGenerateFailed': '선택한 결과물 자동 생성에 실패했습니다',
  'pages.scribe.autoRecordingName': '녹음 {timestamp}',
  'pages.scribe.autoSavedNote': '{relative}에 자동 저장됨 ({time})',
  'pages.scribe.convertingEllipsis': '변환 중...',
  'pages.scribe.customLanguageFallback': '사용자 지정',
  'pages.scribe.deleteConfirm.content': '이 녹취록을 삭제하시겠습니까?',
  'pages.scribe.deleteConfirm.title': '녹취록 삭제',
  'pages.scribe.deleteTranscriptFailed': '녹취록 삭제에 실패했습니다',
  'pages.scribe.discardChangesConfirm.cancelText': '계속 편집',
  'pages.scribe.discardChangesConfirm.content':
    '저장하지 않은 편집 내용이 있습니다. 취소하시겠습니까?',
  'pages.scribe.discardChangesConfirm.okText': '취소',
  'pages.scribe.discardChangesConfirm.title': '변경 사항을 취소하시겠습니까?',
  'pages.scribe.downloadAudio': '오디오 다운로드',
  'pages.scribe.downloadFailed': '다운로드에 실패했습니다',
  'pages.scribe.downloadScript': '녹취록 다운로드',
  'pages.scribe.downloadStarted': '다운로드가 시작되었습니다',
  'pages.scribe.downloadingAudio': '오디오 다운로드 중...',
  'pages.scribe.enterTranscriptNamePlaceholder': '녹취록 이름 입력',
  'pages.scribe.errors.authTokenFailed': '인증 토큰을 가져오지 못했습니다',
  'pages.scribe.errors.startRecordingFailed': '녹음을 시작하지 못했습니다',
  'pages.scribe.exitRecordingConfirm.cancelText': '녹음 계속하기',
  'pages.scribe.exitRecordingConfirm.content': '녹취록이 저장되지 않습니다.',
  'pages.scribe.exitRecordingConfirm.okText': '녹음 종료',
  'pages.scribe.exitRecordingConfirm.title': '녹음을 종료하시겠습니까?',
  'pages.scribe.exitRecordingPopconfirm.description':
    '녹음을 종료하시겠습니까? 녹취록이 저장되지 않습니다.',
  'pages.scribe.fastForward10': '10초 앞으로 이동',
  'pages.scribe.fileUploadFailed': '{fileName} 파일 업로드에 실패했습니다.',
  'pages.scribe.fileUploadSuccess': '파일이 성공적으로 업로드되었습니다. 처리를 시작합니다.',
  'pages.scribe.generateButton': '생성',
  'pages.scribe.generationFailedRetryText': '생성에 실패했습니다. 다시 생성해 주세요.',
  'pages.scribe.generationStarted': '생성이 시작되었습니다',
  'pages.scribe.historyButton': '기록',
  'pages.scribe.homeButton': '홈',
  'pages.scribe.initializingTranscription': '받아쓰기를 초기화하는 중...',
  'pages.scribe.interruptedModal.content':
    '연결이 끊겨(예: 기기가 절전 모드로 전환됨) 녹음이 중단되었습니다. "녹취록 보기"를 클릭하여 캡처된 내용을 저장하세요.',
  'pages.scribe.interruptedModal.okText': '녹취록 보기',
  'pages.scribe.interruptedModal.title': '녹음 중단됨',
  'pages.scribe.langGroup.custom': '사용자 지정',
  'pages.scribe.langGroup.everythingElse': '기타 전체',
  'pages.scribe.langGroup.otherOption': '기타…',
  'pages.scribe.langGroup.preferred': '기본 설정',
  'pages.scribe.langGroup.seaEastAsian': '동남아시아 + 동아시아',
  'pages.scribe.languageSelector.addLanguageButton': '언어 추가',
  'pages.scribe.languageSelector.customPlaceholder': '언어를 입력하세요(예: 말레이어)',
  'pages.scribe.liveTranslationLabel': '실시간 번역',
  'pages.scribe.loadingAudio': '오디오를 불러오는 중...',
  'pages.scribe.mattersUpdatedSuccess': '매터가 성공적으로 업데이트되었습니다',
  'pages.scribe.modeNotGenerated': '{modeLabel}이(가) 아직 생성되지 않았습니다',
  'pages.scribe.nameYourTranscriptPlaceholder': '녹취록 이름을 입력하세요',
  'pages.scribe.newRecordingTitle': '새 녹음',
  'pages.scribe.newTranscript': '새 녹취록',
  'pages.scribe.newTranscriptName': '새 녹취록 {timestamp}',
  'pages.scribe.noAudioFileAvailable': '사용 가능한 오디오 파일이 없습니다.',
  'pages.scribe.noAudioForDownload': '다운로드할 수 있는 오디오 파일이 없습니다.',
  'pages.scribe.noContentAvailable': '사용 가능한 콘텐츠가 없습니다. 다시 생성해 주세요.',
  'pages.scribe.noOutputsGenerated': '생성된 결과물이 없습니다',
  'pages.scribe.noRecentRecordings': '최근 녹음이 아직 없습니다.',
  'pages.scribe.noSegmentsToEdit': '편집할 수 있는 구간이 없습니다',
  'pages.scribe.noTimestampedSegments': '타임스탬프가 있는 녹취록 구간이 없습니다.',
  'pages.scribe.notAvailable': '해당 없음',
  'pages.scribe.optionEmailDrafts': '이메일 초안',
  'pages.scribe.outputNotGeneratedYet': '이 결과물은 아직 생성되지 않았습니다.',
  'pages.scribe.outputViewer.actionItemsLabel': '실행 항목',
  'pages.scribe.outputViewer.addActionItemButton': '실행 항목 추가',
  'pages.scribe.outputViewer.columnAction': '조치',
  'pages.scribe.outputViewer.columnAssignee': '담당자',
  'pages.scribe.outputViewer.columnDueDate': '마감일',
  'pages.scribe.outputViewer.columnTask': '작업',
  'pages.scribe.outputViewer.commaSeparatedNamesPlaceholder': '쉼표로 구분된 이름',
  'pages.scribe.outputViewer.fieldBody': '본문',
  'pages.scribe.outputViewer.fieldCategory': '카테고리',
  'pages.scribe.outputViewer.fieldCleanedTranscript': '정제된 녹취록',
  'pages.scribe.outputViewer.fieldExecutiveSummary': '요약',
  'pages.scribe.outputViewer.fieldGeneratedTitle': '생성된 제목',
  'pages.scribe.outputViewer.fieldKeyDecisions': '주요 결정 사항',
  'pages.scribe.outputViewer.fieldNextMeeting': '다음 회의',
  'pages.scribe.outputViewer.fieldParticipants': '참석자',
  'pages.scribe.outputViewer.fieldRecipients': '수신자',
  'pages.scribe.outputViewer.fieldSignatureBlock': '서명란',
  'pages.scribe.outputViewer.fieldSubject': '제목',
  'pages.scribe.outputViewer.fieldTopic': '주제',
  'pages.scribe.outputViewer.generatingContent': '콘텐츠를 생성하는 중...',
  'pages.scribe.outputViewer.generationFailed': '생성 실패',
  'pages.scribe.outputViewer.onePerLinePlaceholder': '한 줄에 하나씩',
  'pages.scribe.outputViewer.pleaseCheckFields': '입력 항목을 확인해 주세요',
  'pages.scribe.outputViewer.titleDefault': '결과물',
  'pages.scribe.outputViewer.titleEmailDraft': '이메일 초안',
  'pages.scribe.outputViewer.titleMeetingNotes': '회의록',
  'pages.scribe.outputViewer.titleVoiceMemo': '음성 메모',
  'pages.scribe.outputViewer.unknownOutputType': '알 수 없는 결과물 유형',
  'pages.scribe.pauseRecordingTitle': '녹음 일시 중지',
  'pages.scribe.recentRecordingsTitle': '최근 녹음',
  'pages.scribe.recentlyTranscribed': '최근 받아쓰기 완료',
  'pages.scribe.recordingInProgressWarning':
    '현재 녹음이 진행 중입니다. 세션을 전환하기 전에 녹음을 중지해 주세요',
  'pages.scribe.recordingMicOnlyNote':
    '녹음은 스피커가 아닌 마이크의 오디오만 캡처합니다. 컴퓨터에서 재생 중인 오디오를 받아쓰려면 별도의 기기를 사용하거나 녹음 파일을 업로드하세요.',
  'pages.scribe.recordingPaused': '녹음 일시 중지됨',
  'pages.scribe.recordingPausedInline': '녹음이 일시 중지되었습니다',
  'pages.scribe.regenerateButton': '다시 생성',
  'pages.scribe.resumeRecordingTitle': '녹음 재개',
  'pages.scribe.retranslatingSegments': '편집된 구간을 다시 번역하는 중...',
  'pages.scribe.fillingMissingTranslations': '누락된 구간을 번역하는 중...',
  'pages.scribe.rewind10': '10초 뒤로 이동',
  'pages.scribe.saveEditsFailed': '녹취록 편집 내용을 저장하지 못했습니다',
  'pages.scribe.saveFailed': '저장하지 못했습니다',
  'pages.scribe.saveTranscriptFailed': '녹취록을 저장하지 못했습니다',
  'pages.scribe.saveTranscriptModalTitle': '녹취록 저장',
  'pages.scribe.saveTranscriptTitle': '녹취록 저장',
  'pages.scribe.savedSuccessfully': '저장되었습니다',
  'pages.scribe.savingTranscript': '녹취록을 저장하는 중...',
  'pages.scribe.scribeTitle': '스크라이브',
  'pages.scribe.scrollToBottom': '맨 아래로 스크롤',
  'pages.scribe.searchMattersPlaceholder': '매터 검색...',
  'pages.scribe.searchTranscriptsPlaceholder': '녹취록 검색',
  'pages.scribe.segmentTranslationFailed': '구간 번역에 실패했습니다',
  'pages.scribe.selectMattersLabel': '매터 선택:',
  'pages.scribe.startGenerationFailed': '생성을 시작하지 못했습니다',
  'pages.scribe.startTranscriptionFailed': '받아쓰기 프로세스를 시작하지 못했습니다',
  'pages.scribe.status.clickMicToStart': '마이크를 클릭하여 녹음을 시작하세요',
  'pages.scribe.status.defaultDescription': '오디오 파일이나 녹음을 구조화된 텍스트로 받아쓰기',
  'pages.scribe.status.processingFile': '파일을 처리하는 중... {stage}',
  'pages.scribe.status.queued': '대기 중',
  'pages.scribe.status.transcriptionCancelled': '받아쓰기가 취소되었습니다',
  'pages.scribe.status.transcriptionCompleted': '받아쓰기가 완료되었습니다',
  'pages.scribe.status.transcriptionFailed': '받아쓰기에 실패했습니다',
  'pages.scribe.stopRecordingConfirm.cancelText': '유지',
  'pages.scribe.stopRecordingConfirm.content':
    '현재 녹음이 진행 중입니다. 이 페이지를 벗어나면 녹음이 중지됩니다. 계속하시겠습니까?',
  'pages.scribe.stopRecordingConfirm.okText': '페이지 나가기',
  'pages.scribe.stopRecordingConfirm.title': '녹음을 중지하시겠습니까?',
  'pages.scribe.stopRecordingSaveTitle': '녹음 중지 및 저장',
  'pages.scribe.tabs.emailDraft': '이메일 초안',
  'pages.scribe.tabs.meetingNotes': '회의록',
  'pages.scribe.tabs.rawTranscript': '원본 녹취록',
  'pages.scribe.tabs.voiceMemo': '음성 메모',
  'pages.scribe.transcriptDeleted': '녹취록이 삭제되었습니다',
  'pages.scribe.transcriptEmpty': '녹취록이 비어 있습니다',
  'pages.scribe.transcriptNameUpdated': '녹취록 이름이 업데이트되었습니다',
  'pages.scribe.transcriptSavedSuccess': '트랜스크립트가 저장되었습니다',
  'pages.scribe.transcriptUpdated': '트랜스크립트가 업데이트되었습니다',
  'pages.scribe.transcriptionFailedDesc':
    'Scribe에서 이 오디오를 전사하지 못했습니다. 오디오 파일을 다운로드한 후 다시 업로드해 보세요.',
  'pages.scribe.transcriptionFailedTitle': '전사 실패',
  'pages.scribe.transcriptionLanguageQuestion': '전사에 사용할 언어를 선택하세요',
  'pages.scribe.transcriptionPurposeQuestion': '이 전사는 어떤 용도로 사용되나요?',
  'pages.scribe.translatingEllipsis': '번역 중...',
  'pages.scribe.increaseTranslationSize': '번역 텍스트 크기 늘리기',
  'pages.scribe.decreaseTranslationSize': '번역 텍스트 크기 줄이기',
  'pages.scribe.translationTextSize': '번역 텍스트 크기',
  'pages.scribe.unassigned': '미지정',
  'pages.scribe.unnamedTranscript': '이름 없는 트랜스크립트',
  'pages.scribe.untitled': '제목 없음',
  'pages.scribe.untitledParens': '(제목 없음)',
  'pages.scribe.untitledTranscript': '제목 없는 트랜스크립트',
  'pages.scribe.updateMattersFailed': '매터 업데이트에 실패했습니다',
  'pages.scribe.updateNameFailed': '트랜스크립트 이름 업데이트에 실패했습니다',
  'pages.scribe.updateTranscriptNameTitle': '트랜스크립트 이름 업데이트',
  'pages.scribe.uploadRecordingButton': '녹음 업로드',
  'pages.scribe.uploadingAudioFile': '오디오 파일 업로드 중...',
  'pages.scribe.waitingEllipsis': '대기 중...',
  'pages.scribe.waitingForTranslations': '번역이 완료되기를 기다리는 중...',
  'pages.scribe.whatsNew': '새로운 기능',
  'pages.scribe.whatsNew.filteringSortingDesc':
    '트랜스크립트를 관리하고 찾기 위한 UI가 개선되었습니다.',
  'pages.scribe.whatsNew.filteringSortingLabel': '필터링 및 정렬:',
  'pages.scribe.whatsNew.guidanceTabsDesc':
    '시작 방법이나 새로운 기능을 손쉽게 확인할 수 있습니다.',
  'pages.scribe.whatsNew.guidanceTabsLabel': '안내 탭:',
  'pages.scribe.whatsNew.intro': '더욱 매끄러운 전사 경험을 제공하기 위해 Scribe를 개선했습니다:',
  'pages.scribe.whatsNew.upcomingFeaturesDesc':
    '더욱 정교한 다국어 제어 기능과 고급 구조화된 출력 형식이 곧 제공될 예정이니 기대해 주세요.',
  'pages.scribe.whatsNew.upcomingFeaturesTitle': '향후 제공 예정 기능',
  'pages.search.chunkCopiedSuccess': '청크가 복사되었습니다!',
  'pages.search.chunkCopyFailed': '청크 복사에 실패했습니다',
  'pages.search.searchRatioLabel': '검색 비율',
  'pages.search.favouriteFileWeightLabel': '즐겨찾기 파일 가중치',
  'pages.search.rerankLabel': '재순위화',
  'pages.search.filePreviewAlt': '파일 미리보기',
  'pages.search.previewNotSupported': '이 파일 형식은 미리보기를 지원하지 않습니다',
  'pages.search.chunkPageLabel': '페이지: {pageNumber}',
  'pages.search.matchPercentage': '일치율 {score}%',
  'pages.search.openChunkAriaLabel': '청크 {index} 열기',
  'pages.search.navigateResultsTitle': '결과 탐색',
  'pages.search.loadingChunkResults': '청크 결과 불러오는 중...',
  'pages.search.chunkResultCount': '{count, plural, other {청크 결과}}',
  'pages.search.previousResultTitle': '이전 결과',
  'pages.search.nextResultTitle': '다음 결과',
  'pages.search.chatWithDocumentButton': '이 문서와 채팅하기',
  'pages.search.searchWithinDocumentPlaceholder': '문서 내 검색...',
  'pages.search.filterDownLabel': '필터 좁히기',
  'pages.search.documentPreviewTitle': '문서 미리보기',
  'pages.search.askAgelPlaceholder': 'A&GEL에게 질문하기',
  'pages.search.searchAllButton': '전체 검색',
  'pages.search.advancedSettingsButton': '고급 설정',
  'pages.search.allTagsOption': ' 전체 태그',
  'pages.sideBySide.addAtLeastOneQuestion': '질문을 하나 이상 추가해 주세요',
  'pages.sideBySide.addAtLeastOneQuestionBeforeSubmitting':
    '제출하기 전에 질문을 하나 이상 추가해 주세요.',
  'pages.sideBySide.addNewQuestionsPlaceholder': '새 질문 추가(한 줄에 하나씩)',
  'pages.sideBySide.addPlusButton': '추가 +',
  'pages.sideBySide.addQuestionsLabel': '질문 추가',
  'pages.sideBySide.addToMattersButton': '매터에 추가',
  'pages.sideBySide.authorFieldLabel': '작성자',
  'pages.sideBySide.authorLabel': '작성자: ',
  'pages.sideBySide.categoryLabel': '카테고리',
  'pages.sideBySide.cellDetails.answer': '답변',
  'pages.sideBySide.cellDetails.verified': '검증됨',
  'pages.sideBySide.cellDetails.verify': '검증',
  'pages.sideBySide.cellMarkedUnverified': '셀이 미검증으로 표시되었습니다',
  'pages.sideBySide.cellMarkedVerified': '셀이 검증됨으로 표시되었습니다',
  'pages.sideBySide.cellUpdatedSuccess': '셀이 업데이트되었습니다',
  'pages.sideBySide.changesUndone': '변경 사항이 실행 취소되었습니다',
  'pages.sideBySide.clickOrDragToUpload': '클릭하거나 드래그하여 업로드',
  'pages.sideBySide.cloneButton': '복제',
  'pages.sideBySide.cloneModeLabel': '복제',
  'pages.sideBySide.clonedNamePrefix': '복제됨 - {name}',
  'pages.sideBySide.columnEditModal.columnAddedSuccess':
    '새 열이 추가되었습니다. 잠시 후 매트릭스가 새로고침됩니다.',
  'pages.sideBySide.columnEditModal.columnUpdateStartedSuccess':
    '열 업데이트가 시작되었습니다. 잠시 후 열이 새로고침됩니다.',
  'pages.sideBySide.columnEditModal.enterPromptWarning': '프롬프트를 입력해 주세요.',
  'pages.sideBySide.columnEditModal.promptLabel': '프롬프트',
  'pages.sideBySide.columnEditModal.promptPlaceholder':
    '이 열에 대한 프롬프트/시스템 지침을 설명하세요',
  'pages.sideBySide.columnEditModal.title': '열 수정',
  'pages.sideBySide.columnEditModal.updateColumnFailed': '열 업데이트에 실패했습니다',
  'pages.sideBySide.createCustomQuestionListDescription':
    '이 세션을 위한 사용자 지정 Side by Side 질문 목록을 생성하세요',
  'pages.sideBySide.createModeLabel': '생성',
  'pages.sideBySide.createQuestionListButton': '질문 목록 생성',
  'pages.sideBySide.createdByLabel': '생성자: ',
  'pages.sideBySide.createdByYou': '나',
  'pages.sideBySide.customInstructionOptional': '2. 사용자 지정 지침(선택 사항)',
  'pages.sideBySide.deleteQuestionListConfirm': '이 질문 목록을 삭제하시겠습니까?',
  'pages.sideBySide.dragHereToUpload': '여기로 드래그하여 업로드',
  'pages.sideBySide.emailButton': '이메일',
  'pages.sideBySide.exitButton': '종료',
  'pages.sideBySide.exitModeButton': '{mode} 종료',
  'pages.sideBySide.fileCount': '파일 {count}개',
  'pages.sideBySide.firmOption': '로펌',
  'pages.sideBySide.firmWideOption': '로펌 전체',
  'pages.sideBySide.fromDocumentOption': '문서에서',
  'pages.sideBySide.groupOption': '그룹',
  'pages.sideBySide.leadRowHeader': '원본 문서 단락',
  'pages.sideBySide.manualCraftOption': '직접 작성',
  'pages.sideBySide.modifyButton': '수정',
  'pages.sideBySide.modifyModeLabel': '수정',
  'pages.sideBySide.newCategoryPlaceholder': '새 카테고리',
  'pages.sideBySide.newQuestionListButtonLabel': '새 Side by Side 질문 목록',
  'pages.sideBySide.newQuestionListDefaultName': '새 Side by Side 질문 목록',
  'pages.sideBySide.noNotesAvailable': '사용 가능한 메모가 없습니다.',
  'pages.sideBySide.noPurposeAvailable': '사용 가능한 목적이 없습니다.',
  'pages.sideBySide.noSystemPromptConfigured': '구성된 시스템 프롬프트가 없습니다.',
  'pages.sideBySide.notesFieldLabel': '메모',
  'pages.sideBySide.notesLabel': '메모: ',
  'pages.sideBySide.pendingApprovalTag': '승인 대기 중',
  'pages.sideBySide.pollingTimeoutWarning':
    '폴링 시간이 초과되었습니다. Side by Side가 아직 처리 중일 수 있습니다.',
  'pages.sideBySide.processing': '처리 중',
  'pages.sideBySide.processingStopped': '처리가 중지되었습니다.',
  'pages.sideBySide.publicOption': '공개',
  'pages.sideBySide.publishButton': '게시',
  'pages.sideBySide.publishQuestionListFailed': '질문 목록 게시에 실패했습니다',
  'pages.sideBySide.publishStatusLabel': '게시 상태',
  'pages.sideBySide.publishToLabel': '게시 대상:',
  'pages.sideBySide.publishedToAccess': '{access}에 게시됨',
  'pages.sideBySide.publishedToGroupSuccess': '질문 목록이 그룹에 게시되었습니다',
  'pages.sideBySide.publishedToPrivateGroups': '질문 목록이 비공개 그룹에 게시되었습니다',
  'pages.sideBySide.publisherLabel': '게시자: ',
  'pages.sideBySide.purposeFieldLabel': '목적',
  'pages.sideBySide.purposeLabel': '목적: ',
  'pages.sideBySide.questionListClonedSuccess': '질문 목록이 복제되었습니다',
  'pages.sideBySide.questionListCreatedSuccess': '질문 목록이 생성되었습니다',
  'pages.sideBySide.questionListDeletedSuccess': '질문 목록이 삭제되었습니다',
  'pages.sideBySide.questionListNamePlaceholder': 'Side-by-Side 질문 목록 이름',
  'pages.sideBySide.questionListUpdatedSuccess': '질문 목록이 업데이트되었습니다',
  'pages.sideBySide.questionsListLabel': '질문 목록',
  'pages.sideBySide.quickQuestionsDescription':
    '임의의 질문 세트를 기반으로 하나 이상의 문서에 대한 구조화된 Side-by-Side를 생성합니다',
  'pages.sideBySide.quickQuestionsTitle': '빠른 질문',
  'pages.sideBySide.rejectedTag': '거부됨',
  'pages.sideBySide.restoreConfigurationFailed': '설정을 복원하지 못했습니다. 다시 시도해 주세요.',
  'pages.sideBySide.reuseButton': '재사용',
  'pages.sideBySide.reviewTemplateQuestionsDescription': '이 템플릿의 질문을 검토하세요',
  'pages.sideBySide.saveChangesButton': '변경 사항 저장',
  'pages.sideBySide.selectDocumentDescription': 'Side-by-Side를 진행할 문서를 선택하세요',
  'pages.sideBySide.selectGroupsPlaceholder': '그룹 선택',
  'pages.sideBySide.selectGroupsToShareDescription': '공유할 그룹을 하나 이상 선택하세요:',
  'pages.sideBySide.selectionDescription':
    '질문 목록을 기반으로 하나 이상의 문서에 대한 구조화된 Side-by-Side를 생성합니다',
  'pages.sideBySide.selectionFeatureName': 'Side-by-Side',
  'pages.sideBySide.selectionTitle': 'Side-by-Side',
  'pages.sideBySide.sentForApprovalSuccess': '질문 목록이 승인 요청되었습니다',
  'pages.sideBySide.showQuestionsButton': '질문 보기',
  'pages.sideBySide.startGenerateReview': '검토 생성 시작',
  'pages.sideBySide.startNewSideBySideButton': '새 Side-by-Side 시작',
  'pages.sideBySide.stayButton': '머무르기',
  'pages.sideBySide.submitFailed': 'Side-by-Side 제출에 실패했습니다',
  'pages.sideBySide.systemPromptLabel': '시스템 프롬프트',
  'pages.sideBySide.tabs.prompts': '프롬프트',
  'pages.sideBySide.tabs.questionList': '질문 목록',
  'pages.sideBySide.tabs.selectDocuments': '문서 선택',
  'pages.sideBySide.targetAudiencePlaceholder': '고객 또는 대상 독자 이름',
  'pages.sideBySide.teamsButton': '팀',
  'pages.sideBySide.templateSystemPromptLabel': '템플릿 시스템 프롬프트',
  'pages.sideBySide.tour.noHistorySessions':
    '기록에 사용 가능한 Side-by-Side 세션이 없습니다. 이 단계를 보려면 먼저 세션을 생성해 주세요.',
  'pages.sideBySide.tour.step1.description':
    '먼저 사용 가능한 카테고리에서 질문 목록을 선택하세요. 진행하려면 원하는 질문 목록 카드를 클릭하세요.',
  'pages.sideBySide.tour.step1.title': '질문 목록 선택',
  'pages.sideBySide.tour.step2.description':
    '대상 독자 또는 고객 이름을 입력한 다음, Side-by-Side로 비교할 문서를 선택하세요.',
  'pages.sideBySide.tour.step2.title': '대상 독자 입력 및 파일 선택',
  'pages.sideBySide.tour.step3.description':
    '여기에서 시스템 프롬프트와 질문 목록을 검토하세요. 이전 세션을 보려면 기록 패널로 전환하세요.',
  'pages.sideBySide.tour.step3.title': '시스템 프롬프트 및 질문 보기',
  'pages.sideBySide.tour.step4.description':
    '제출하면 Side-by-Side 결과가 표 형태로 표시됩니다. 셀을 클릭하면 세부 정보를 볼 수 있습니다.',
  'pages.sideBySide.tour.step4.title': 'Side-by-Side 결과 보기',
  'pages.sideBySide.typeHerePlaceholder': '여기에 입력하세요...',
  'pages.sideBySide.undoChangesButton': '변경 취소',
  'pages.sideBySide.unsavedChangesWillBeLost': '저장하지 않은 변경 사항은 모두 사라집니다.',
  'pages.sideBySide.untitled': '(제목 없음)',
  'pages.sideBySide.updateCellFailed': '셀 업데이트에 실패했습니다',
  'pages.sideBySide.updateCellVerificationFailed': '셀 검증 업데이트에 실패했습니다',
  'pages.sideBySide.updateFailed': '업데이트에 실패했습니다',
  'pages.sideBySide.uploadDocumentFailed': '문서 업로드에 실패했습니다',
  'pages.sideBySide.whatsNewDescription':
    '문서 Side-by-Side 프로세스를 개선하는 다양한 새 기능이 추가되었습니다.',
  'pages.sideBySide.whoIsItForQuestion': '1. 누구를 위한 것인가요?',
  'pages.template.waitingMessage.justAMoment': '잠시만 기다려 주세요...',
  'pages.template.waitingMessage.fetchingThatForYou': '가져오는 중입니다...',
  'pages.template.waitingMessage.hangTight': '잠시만요, 처리 중입니다...',
  'pages.template.waitingMessage.letMeCheck': '확인해 볼게요...',
  'pages.template.waitingMessage.oneSecPlease': '잠시만요...',
  'pages.template.waitingMessage.lookingThatUp': '찾아보는 중입니다...',
  'pages.template.waitingMessage.almostThere': '거의 다 됐습니다...',
  'pages.template.waitingMessage.holdOnRetrieving': '잠시만요, 정보를 가져오는 중입니다...',
  'pages.template.waitingMessage.workingOnIt': '처리 중입니다...',
  'pages.template.dragDropUpload': '업로드하려면 여기로 끌어다 놓으세요',
  'pages.template.uploadInvalidFileTypes':
    'PDF, DOC, DOCX, MSG, EML, TXT, MD 파일만 업로드해 주세요',
  'pages.template.someFilesSkipped':
    '일부 파일이 건너뛰어졌습니다. PDF, DOC, DOCX, MSG, EML, TXT, MD 파일만 허용됩니다',
  'pages.template.fileUploadedSuccess': '{fileName} 파일이 업로드되었습니다',
  'pages.template.fileUploadFailed': '{fileName} 업로드에 실패했습니다',
  'pages.template.loadTemplateDetailsFailed': '템플릿 세부 정보를 불러오지 못했습니다',
  'pages.template.viewLess': '간략히 보기',
  'pages.template.viewAll': '전체 보기',
  'pages.template.tour.step1Title': '사용자 지정 출력 템플릿 선택',
  'pages.template.tour.step1Description':
    '먼저 사용 가능한 카테고리에서 템플릿 프리셋을 선택하세요.',
  'pages.template.tour.step2Title': '분석할 파일 선택',
  'pages.template.tour.step2Description':
    '사용자 지정 출력을 실행할 문서를 업로드하거나 선택하세요.',
  'pages.template.tour.step3Title': '프롬프트 및 지침 검토',
  'pages.template.tour.step3Description':
    '여기에서 대상 독자 정보와 선택적인 사용자 지정 지침을 입력하세요.',
  'pages.template.tour.step4Title': '결과 보기',
  'pages.template.tour.step4Description':
    '제출하면 생성된 사용자 지정 출력이 이 영역에 표시됩니다.',
  'pages.template.noSessionsFound':
    '템플릿 세션을 찾을 수 없습니다. 결과를 보려면 세션을 실행해 주세요.',
  'pages.template.startNewCustomOutput': '새 사용자 지정 출력 시작',
  'pages.template.untitled': '(제목 없음)',
  'pages.template.newSession': '새 세션',
  'pages.template.fileCount': '파일 {count}개',
  'pages.template.reuseButton': '재사용',
  'pages.template.addToMattersButton': '매터에 추가',
  'pages.template.startFillingTemplates': '템플릿 작성 시작',
  'pages.template.unsavedChangesWarning': '저장하지 않은 변경 사항은 모두 사라집니다.',
  'pages.template.stayButton': '머무르기',
  'pages.template.exitButton': '나가기',
  'pages.template.undoChangesButton': '변경 취소',
  'pages.template.changesUndoneMessage': '변경 사항이 취소되었습니다',
  'pages.template.templateCreatedSuccess': '템플릿이 생성되었습니다',
  'pages.template.templateUpdatedSuccess': '템플릿이 업데이트되었습니다',
  'pages.template.fillRequiredFields': '필수 항목을 모두 입력해 주세요',
  'pages.template.saveTemplateFailed': '템플릿 저장에 실패했습니다',
  'pages.template.createTemplateButton': '템플릿 생성',
  'pages.template.saveTemplateButton': '템플릿 저장',
  'pages.template.presetNamePlaceholder': '사용자 지정 템플릿 프리셋 이름',
  'pages.template.categoryLabel': '카테고리',
  'pages.template.newCategoryPlaceholder': '새 카테고리',
  'pages.template.addCategoryButton': '카테고리 추가',
  'pages.template.purposeLabel': '목적',
  'pages.template.notesLabel': '메모',
  'pages.template.systemPromptLabel': '시스템 프롬프트',
  'pages.template.typeProse': '서술형',
  'pages.template.typeTable': '표',
  'pages.template.tableTypeLabel': '표 유형',
  'pages.template.tableTypeTooltip':
    "'조항별' 및 '문서별' 표에서는 사용자 지정 열을 사용할 수 없습니다.",
  'pages.template.tableTypeStandard': '표준',
  'pages.template.tableTypeDocument': '문서별',
  'pages.template.tableTypeClause': '조항별',
  'pages.template.columnsLabel': '열',
  'pages.template.newColumnButton': '새 열',
  'pages.template.exampleLabel': '예시',
  'pages.template.userDefinedLabel': '사용자 지정',
  'pages.template.userDefinedColumnTooltip': '사용자 지정 열',
  'pages.template.columnTypeString': '문자열',
  'pages.template.columnTypeNumber': '숫자',
  'pages.template.columnTypeDatetime': '날짜/시간',
  'pages.template.sectionsLabel': '섹션',
  'pages.template.newSectionButton': '새 섹션',
  'pages.template.headingColumnHeader': '제목',
  'pages.template.promptColumnHeader': '프롬프트',
  'pages.template.modifyButton': '수정',
  'pages.template.publishToLabel': '게시 대상:',
  'pages.template.publishFirmWide': '회사 전체',
  'pages.template.publicAccessLabel': '공개',
  'pages.template.firmAccessLabel': '회사',
  'pages.template.publishButton': '게시',
  'pages.template.publishSentForApproval': '템플릿 프리셋이 승인 요청되었습니다',
  'pages.template.publishTemplateFailed': '템플릿 게시에 실패했습니다',
  'pages.template.deleteConfirmQuestion': '이 템플릿을 삭제하시겠습니까?',
  'pages.template.templateDeletedSuccess': '템플릿이 삭제되었습니다.',
  'pages.template.deleteTemplateFailed': '템플릿을 삭제하지 못했습니다.',
  'pages.template.customTemplateCreatedForSession': '이 세션에 대한 맞춤 템플릿이 생성되었습니다.',
  'pages.template.publishStatusLabel': '게시 상태',
  'pages.template.pendingApprovalStatus': '승인 대기 중',
  'pages.template.rejectedStatus': '반려됨',
  'pages.template.publishedToStatus': '{target}에 게시됨',
  'pages.template.authorLabel': '작성자',
  'pages.template.emailButton': '이메일',
  'pages.template.noPurposeAvailable': '등록된 목적이 없습니다.',
  'pages.template.noNotesAvailable': '등록된 메모가 없습니다.',
  'pages.template.startHereTab': '시작하기',
  'pages.template.whoIsItForQuestion': '1. 누구를 위한 것인가요?',
  'pages.template.clientAudiencePlaceholder': '고객 또는 대상 독자 이름',
  'pages.template.selectDocumentsQuestion': '2. 검토를 진행할 문서를 선택하세요',
  'pages.template.customInstructionTab': '맞춤 지시사항 (선택)',
  'pages.template.modifyPromptLabel': '프롬프트 수정',
  'pages.template.typeHerePlaceholder': '여기에 입력하세요...',
  'pages.template.noSystemPromptConfigured': '설정된 시스템 프롬프트가 없습니다.',
  'pages.template.exampleValuePrefix': '예: {example}',
  'pages.template.customOutputTitle': '맞춤 출력',
  'pages.template.customOutputDescription':
    '특정 유형의 정보를 추출하거나 보다 심층적인 분석이 필요한 문서에 대해, 맞춤형 프롬프트(A&GEL에서는 "맞춤 출력"이라고 함)를 만들어 더욱 정교한 문서 분석에 활용하세요',
  'pages.template.whatsNewButton': '새로운 기능',
  'pages.template.tourButton': '둘러보기',
  'pages.template.addNewCustomTemplateButton': '새 맞춤 템플릿 추가',
  'pages.template.whatsNewModal.intro':
    '문서 검토 프로세스를 개선하기 위해 여러 새로운 기능을 도입했습니다:',
  'pages.template.whatsNewModal.improvedFilteringTitle': '필터링 기능 개선: ',
  'pages.template.whatsNewModal.improvedFilteringBody':
    '질문 목록을 더 빠르게 찾을 수 있도록 새로운 대상 독자 및 작성자 필터가 추가되었습니다.',
  'pages.template.whatsNewModal.adhocQuestionsTitle': '즉석 질문: ',
  'pages.template.whatsNewModal.adhocQuestionsBody':
    '그때그때 질문을 추가할 수 있는 더 유연한 방법입니다.',
  'pages.template.whatsNewModal.uiEnhancementsTitle': 'UI 개선: ',
  'pages.template.whatsNewModal.uiEnhancementsBody':
    '템플릿 관리를 위한 더 깔끔하고 직관적인 인터페이스입니다.',
  'pages.template.upcomingFeaturesTitle': '향후 추가될 기능',
  'pages.template.upcomingFeaturesBody':
    '협업 검토 및 고급 AI 분석 기능 등 더 많은 업데이트를 기대해 주세요.',
  'pages.template.tourIndicator': '{current} / {total}',
  'pages.translation.addToMattersButton': '매터에 추가',
  'pages.translation.batchFileCountLabel': '파일 {count}개',
  'pages.translation.batchTranslationStarted': '일괄 번역이 시작되었습니다.',
  'pages.translation.copiedSuccess': '복사되었습니다!',
  'pages.translation.couldNotResolveFile':
    '선택한 파일을 확인할 수 없습니다. 파일을 다시 업로드하거나 선택해 주세요.',
  'pages.translation.customInstructionTab': '맞춤 지시사항 (선택)',
  'pages.translation.docxOrPdfOnly': 'DOCX 또는 PDF 파일만 선택해 주세요.',
  'pages.translation.downloadFailed': '다운로드에 실패했습니다 ({status})',
  'pages.translation.dragHereToUpload': '여기에 드래그하여 업로드',
  'pages.translation.enterLanguageRequired': '언어를 입력해 주세요',
  'pages.translation.failedRenderOriginalPreview': '원본 미리보기를 렌더링하지 못했습니다',
  'pages.translation.failedRenderTranslatedPreview': '번역본 미리보기를 렌더링하지 못했습니다',
  'pages.translation.failedToFetchDocx': 'DOCX 파일을 불러오지 못했습니다 ({status})',
  'pages.translation.failedToStartTranslation': '번역을 시작하지 못했습니다',
  'pages.translation.failedToStartTranslationMissingId': '번역을 시작하지 못했습니다 (ID 누락)',
  'pages.translation.fileCountLabel': '파일 {count}개',
  'pages.translation.filterFilesPlaceholder': '파일 필터링',
  'pages.translation.liveTranslationHint':
    '왼쪽에 입력하면 오른쪽에서 즉시 번역 결과를 확인할 수 있습니다.',
  'pages.translation.liveTranslationTitle': '실시간 번역',
  'pages.translation.modifyPromptLabel': '프롬프트 수정',
  'pages.translation.failed': '번역 실패',
  'pages.translation.noPreviewAvailable': '미리보기를 사용할 수 없습니다',
  'pages.translation.noFilesMatch': '"{query}"와(과) 일치하는 파일이 없습니다',
  'pages.translation.noTranslatedDocumentYet': '아직 번역된 문서가 없습니다.',
  'pages.translation.originalLabel': '원본',
  'pages.translation.originalPdfTitle': '원본 PDF',
  'pages.translation.otherLanguagePlaceholder': '예: 타밀어',
  'pages.translation.outputLanguageStep': '2. 출력 언어',
  'pages.translation.previewNotSupported': '미리보기는 현재 DOCX 및 PDF 파일만 지원합니다.',
  'pages.translation.processingTitle': '처리 중…',
  'pages.translation.processingTranslation': '번역 처리 중…',
  'pages.translation.promptOptionalLabel': '프롬프트 (선택)',
  'pages.translation.recentlyTranslatedLabel': '최근 번역',
  'pages.translation.renderingOriginal': '원본 렌더링 중…',
  'pages.translation.renderingTranslation': '번역본 렌더링 중…',
  'pages.translation.reuseButton': '재사용',
  'pages.translation.searchTranslationsPlaceholder': '번역 검색',
  'pages.translation.selectAtLeastOneDocument':
    '번역할 문서를 1개 이상 업로드하거나 선택해 주세요.',
  'pages.translation.selectAtMostDocuments': '번역할 문서는 최대 {max}개까지 선택할 수 있습니다.',
  'pages.translation.selectDocumentStep': '1. 번역할 문서를 선택하세요',
  'pages.translation.selectLanguagePlaceholder': '언어 선택',
  'pages.translation.selectLanguageRequired': '언어를 선택해 주세요',
  'pages.translation.selectOutputLanguagePlaceholder': '출력 언어 1개를 선택하세요',
  'pages.translation.selectOutputLanguageRequired': '출력 언어를 선택해 주세요.',
  'pages.translation.startHereTab': '시작하기',
  'pages.translation.startLiveTranslationButton': '실시간 번역 시작',
  'pages.translation.startNewTranslationButton': '새 번역 시작',
  'pages.translation.startTranslationButton': '번역 시작',
  'pages.translation.stopTranslationFailed': '번역을 중지하지 못했습니다',
  'pages.translation.swapLanguagesTooltip': '언어 바꾸기',
  'pages.translation.title': '번역',
  'pages.translation.translateButton': '번역',
  'pages.translation.translatedLabel': '번역본',
  'pages.translation.translatedPdfTitle': '번역된 PDF',
  'pages.translation.translationFailedError': '번역에 실패했습니다',
  'pages.translation.translationHint':
    '문서를 하나 이상의 출력 언어로 번역하세요. 결과는 원본 구간과 나란히 표시됩니다.',
  'pages.translation.translationStoppedSuccess': '번역이 중지되었습니다',
  'pages.translation.translationTaskStarted': '번역 작업이 시작되었습니다',
  'pages.translation.typeTextToTranslatePlaceholder': '번역할 텍스트를 입력하세요',
  'pages.translation.unknownLanguage': '알 수 없음',
  'pages.translation.untitledFallback': '(제목 없음)',
  'pages.translation.untitledTranslationFallback': '제목 없는 번역',
  'pages.user.passwordConfirmationPlaceholder': '비밀번호 확인',
  'pages.user.logoAlt': '로고',
  'pages.user.emailPlaceholder': '이메일',
  'pages.user.passwordPlaceholder': '비밀번호',
  'pages.user.newPasswordPlaceholder': '새 비밀번호',
  'pages.user.forgotPassword.emailSentMessage': '등록된 이메일인 경우 곧 이메일이 발송됩니다',
  'pages.user.forgotPassword.submitButton': '재설정 링크 보내기',
  'pages.user.resetPassword.successMessage': '비밀번호가 변경되었습니다',
  'pages.user.resetPassword.submitButton': '비밀번호 재설정',
  'pages.user.resetPassword.passwordRequired': '비밀번호를 입력해 주세요',
  'pages.user.resetPassword.passwordMinLength': '최소 8자 이상이어야 합니다',
  'pages.user.resetPassword.passwordNeedsAlpha': '영문자를 1자 이상 포함해야 합니다',
  'pages.user.resetPassword.passwordNeedsNumber': '숫자를 1자 이상 포함해야 합니다',
  'pages.user.resetPassword.passwordNeedsSpecial': '특수문자를 1자 이상 포함해야 합니다',
  'pages.user.resetPassword.confirmPasswordRequired': '새 비밀번호를 확인해 주세요!',
  'pages.user.resetPassword.passwordMismatch': '입력하신 두 비밀번호가 일치하지 않습니다!',
  'pages.user.login.tenantNotRegistered':
    '귀하의 Microsoft 테넌트가 이 앱에 등록되어 있지 않습니다. IT 관리자에게 문의해 주세요.',
  'pages.user.login.ssoNotConfigured': 'Microsoft SSO가 올바르게 구성되지 않았습니다',
  'pages.user.login.ssoAccountNotFound': 'Microsoft SSO 계정을 찾을 수 없습니다',
  'pages.user.login.emailPasswordWrong': '이메일 또는 비밀번호가 올바르지 않습니다',
  'pages.user.login.contactAdminContent': '비밀번호를 재설정하려면 관리자에게 문의해 주세요.',
  'pages.user.management.pageTitle': '관리',
  'pages.user.rolesLoadingPlaceholder': '역할을 불러오는 중...',
  'pages.user.selectRolePlaceholder': '역할 선택',
  'pages.user.billing.seatsMinimumError': '좌석 수는 1 이상의 정수여야 합니다.',
  'pages.user.billing.contactRequiredError': '청구 담당자 이름과 이메일을 입력해 주세요.',
  'pages.user.billing.contactNameInvalidError':
    "청구 담당자 이름에는 문자, 공백, 하이픈(-), 아포스트로피(')만 사용할 수 있습니다.",
  'pages.user.billing.renewOrChoosePlan': '갱신 / 요금제 선택',
  'pages.user.billing.switchPlanAction': '요금제 변경',
  'pages.user.billing.subscribeAction': '구독하기',
  'pages.user.billing.renewPlanAction': '플랜 갱신',
  'pages.user.billing.switchPlanModalTitle': '플랜 변경',
  'pages.user.billing.switchPlanConfirmContent':
    '결제 페이지로 이동하며, {planName} ({interval}별 결제) 플랜의 {seats}석에 대해 {total}이(가) 청구됩니다.',
  'pages.user.billing.switchPlanConfirmContentRenewal':
    '결제 페이지로 이동하며, 취소된 구독을 갱신하기 위해 {planName} ({interval}별 결제) 플랜의 {seats}석에 대해 {total}이(가) 청구됩니다.',
  'pages.user.billing.switchPlanConfirmContentReplace':
    '결제 페이지로 이동하며, {planName} ({interval}별 결제) 플랜의 {seats}석에 대해 {total}이(가) 청구됩니다. 현재 플랜은 대체됩니다.',
  'pages.user.billing.renewThisPlanButton': '이 플랜 갱신',
  'pages.user.billing.currentPlanButton': '현재 플랜',
  'pages.user.billing.switchToThisPlanButton': '이 플랜으로 변경',
  'pages.user.billing.subscribeToThisPlanButton': '이 플랜 구독하기',
  'pages.user.billing.planText': '플랜',
  'pages.user.billing.selectedTag': '선택됨',
  'pages.user.billing.totalLabel': '합계:',
  'pages.user.billing.billingContactTitle': '청구 담당자',
  'pages.user.billing.billingContactHint': '결제 및 인보이스 발행에 필요합니다.',
  'pages.user.billing.fullNameLabel': '성명',
  'pages.user.billing.billingEmailLabel': '청구 이메일',
  'pages.user.billing.seatsLabel': '좌석 수',
  'pages.user.billing.registeringTenantTitle': 'Microsoft 테넌트 등록 중',
  'pages.user.billing.tenantStep1': '1/4단계: Microsoft SSO 설정을 불러오는 중...',
  'pages.user.billing.ssoNotEnabledError':
    'Microsoft SSO가 활성화되어 있지 않습니다. 관리자에게 문의하세요.',
  'pages.user.billing.tenantStep2':
    '2/4단계: Microsoft 로그인 팝업을 여는 중입니다. 로그인 후 테넌트에 대한 권한을 부여해 주세요.',
  'pages.user.billing.tenantStep3': '3/4단계: 서버에서 테넌트 토큰을 확인하는 중...',
  'pages.user.billing.tenantStep4': '4/4단계: 테넌트 등록 정보를 현재 조직에 저장하는 중...',
  'pages.user.billing.tenantRegistrationCompleteTitle': 'Microsoft 테넌트 등록 완료',
  'pages.user.billing.tenantAddedMessage':
    '성공적으로 처리되었습니다. 테넌트 ID {tenantId}이(가) 조직에 추가되었습니다.',
  'pages.user.billing.tenantAlreadyRegisteredMessage':
    '테넌트 ID {tenantId}은(는) 이미 조직에 등록되어 있습니다. 추가 조치가 필요하지 않습니다.',
  'pages.user.billing.tenantRegisterGenericError':
    'Microsoft 테넌트를 등록할 수 없습니다. 다시 시도해 주세요.',
  'pages.user.billing.tenantRegistrationFailedTitle': 'Microsoft 테넌트 등록 실패',
  'pages.user.billing.tenantRegistrationIncompleteMessage': '등록이 완료되지 않았습니다. {detail}',
  'pages.user.billing.loadInvoicesError': '인보이스를 불러올 수 없습니다.',
  'pages.user.billing.loadBillingDetailsError': '청구 정보를 불러올 수 없습니다.',
  'pages.user.billing.openCheckoutError': '결제 페이지를 열 수 없습니다.',
  'pages.user.billing.seatChangeScheduledMessage':
    '좌석 변경이 예약되었습니다 — 다음 갱신 시 적용됩니다.',
  'pages.user.billing.seatsUpdatedMessage': '좌석 수가 업데이트되었습니다.',
  'pages.user.billing.tenantPopupNotice':
    '이 창을 닫지 마세요. Microsoft 팝업 창이 필요합니다. 로그인과 동의를 완료해 계속 진행해 주세요.',
  'pages.user.billing.editSeatsModalTitle': '좌석 수 수정',
  'pages.user.billing.saveSeatsButton': '좌석 수 저장',
  'pages.user.billing.currentTotalLabel': '현재 합계',
  'pages.user.billing.previewTotalLabel': '예상 합계',
  'pages.user.billing.differenceLabel': '다음 갱신 시 차액',
  'pages.user.billing.seatChangeRenewalNotice':
    '좌석 변경 사항은 다음 갱신일인 {nextInvoiceDisplay}부터 적용됩니다.',
  'pages.user.billing.invoices': '인보이스',
  'pages.user.billing.nextInvoiceDateLabel': '다음 인보이스 발행일:',
  'pages.user.billing.invoiceColumn': '인보이스',
  'pages.user.billing.dueColumn': '결제 기한',
  'pages.user.billing.amountColumn': '금액',
  'pages.user.billing.downloadInvoiceError': '인보이스 PDF를 다운로드할 수 없습니다.',
  'pages.user.billing.membersSeatsLabel': '멤버 / 좌석',
  'pages.user.billing.scheduledTag': '예약됨',
  'pages.user.billing.pendingSeatsNotice': '→ 다음 갱신부터 {seats}석',
  'pages.user.billing.editSeatsButton': '좌석 수 수정',
  'pages.user.billing.currentPlanCardLabel': '현재 플랜',
  'pages.user.billing.priceLabel': '가격:',
  'pages.user.billing.billingCardTitle': '청구',
  'pages.user.billing.nextInvoiceLabel': '다음 인보이스',
  'pages.user.billing.registerMicrosoftTenantButton': 'Microsoft 테넌트 등록',
  'pages.user.billing.contactOrgAdmin': '조직 관리자에게 문의하세요.',
  'pages.user.billing.graceDeadlineFallback': '유예 기한',
  'pages.user.billing.paymentIssueTitle': '결제 문제',
  'pages.user.billing.pastDueDescription':
    '구독 결제가 연체되었습니다. {graceDate}까지 이용이 유지됩니다. 서비스 중단을 방지하려면 지금 갱신하세요.',
  'pages.user.billing.subscriptionCancelledTitle': '구독이 취소되었습니다.',
  'pages.user.billing.subscriptionInactiveTitle': '구독이 비활성 상태입니다',
  'pages.user.billing.orgAccessRestrictedDescription':
    '청구 문제가 해결될 때까지 조직 접근이 제한됩니다.',
  'pages.welcomeDashboard.jsonResponseTitle': 'JSON 응답',
  'pages.welcomeDashboard.textResponseTitle': '텍스트 응답',
  'pages.welcomeDashboard.visibility.public': '공개',
  'pages.welcomeDashboard.visibility.firm': '소속 기관',
  'pages.welcomeDashboard.visibility.unknown': '알 수 없음',
  'pages.welcomeDashboard.rejectButton': '거부',
  'pages.welcomeDashboard.approveButton': '승인',
  'pages.welcomeDashboard.metrics.wordsGeneratedToday.title': '오늘 생성된 단어 수',
  'pages.welcomeDashboard.metrics.wordsGenerated.chartLabel': '생성된 단어 수',
  'pages.welcomeDashboard.metrics.wordsGeneratedToday.description': 'AI 지원 초안 작성',
  'pages.welcomeDashboard.metrics.pagesProcessed.title': '처리된 A4 페이지 수',
  'pages.welcomeDashboard.metrics.pagesProcessed.chartLabel': '처리된 페이지 수',
  'pages.welcomeDashboard.metrics.pagesProcessed.description': '오늘 진행 중인 매터 전체에서',
  'pages.welcomeDashboard.metrics.documentsDownloaded.title': '다운로드된 문서',
  'pages.welcomeDashboard.metrics.documentsDownloaded.chartLabel': '다운로드된 문서',
  'pages.welcomeDashboard.metrics.documentsDownloaded.description': '오늘 내보낸 파일',
  'pages.welcomeDashboard.metrics.questionsAnswered.title': '답변된 질문',
  'pages.welcomeDashboard.metrics.questionsAnswered.chartLabel': '답변된 질문',
  'pages.welcomeDashboard.metrics.questionsAnswered.description': '오늘 처리된 AI 프롬프트',
  'pages.welcomeDashboard.features.apps.name': '앱',
  'pages.welcomeDashboard.features.apps.description': '콘텐츠 분석 및 요약',
  'pages.welcomeDashboard.features.scribe.name': '스크라이브',
  'pages.welcomeDashboard.features.scribe.description': '문서 전사',
  'pages.welcomeDashboard.features.comparison.name': '비교',
  'pages.welcomeDashboard.features.comparison.description': '문서를 나란히 비교',
  'pages.welcomeDashboard.features.review.name': '검토',
  'pages.welcomeDashboard.features.review.description': '질문으로 문서 검토',
  'pages.welcomeDashboard.features.translation.name': '번역',
  'pages.welcomeDashboard.features.translation.description': '문서 번역',
  'pages.welcomeDashboard.features.chat.name': '채팅',
  'pages.welcomeDashboard.features.chat.description': 'AI 어시스턴트와 채팅',
  'pages.welcomeDashboard.features.templates.name': '템플릿',
  'pages.welcomeDashboard.features.templates.description': '템플릿 관리',
  'pages.welcomeDashboard.features.quote.name': '견적',
  'pages.welcomeDashboard.features.quote.description': '견적 생성',
  'pages.welcomeDashboard.features.files.name': '파일',
  'pages.welcomeDashboard.features.files.description': '파일 관리',
  'pages.welcomeDashboard.features.library.name': '프롬프트 라이브러리',
  'pages.welcomeDashboard.features.library.description': '라이브러리 접근',
  'pages.welcomeDashboard.features.sideBySide.name': '나란히 보기',
  'pages.welcomeDashboard.features.sideBySide.description': '나란히 비교',
  'pages.welcomeDashboard.features.playbook.name': 'Workstudio',
  'pages.welcomeDashboard.features.playbook.description': 'Workstudio 세션 생성 및 관리',
  'pages.welcomeDashboard.features.fallback.description': '기능',
  'pages.welcomeDashboard.features.search.name': '검색',
  'pages.welcomeDashboard.greeting': '안녕하세요, {username}님',
  'pages.welcomeDashboard.useCasesButton': '사용 사례',
  'pages.welcomeDashboard.faqsButton': '자주 묻는 질문',
  'pages.welcomeDashboard.publishingApprovalsButton': '게시 승인 ({count})',
  'pages.welcomeDashboard.jumpBackInTitle': '이어서 진행하기',
  'pages.welcomeDashboard.untitledSession': '제목 없는 세션',
  'pages.welcomeDashboard.viewAllButton': '모두 보기',
  'pages.welcomeDashboard.noRecentSessions': '최근 세션이 없습니다',
  'pages.welcomeDashboard.statsTitle': '통계',
  'pages.welcomeDashboard.usefulFeaturesTitle': '유용한 기능',
  'pages.welcomeDashboard.sessionsCount': '{count, plural, other {세션 #개}}',
  'pages.welcomeDashboard.foundUsefulThisWeek':
    '이번 주 {count}명의 사용자가 유용하다고 평가했습니다',
  'pages.welcomeDashboard.noRecentActivity': '최근 활동이 없습니다',
  'pages.welcomeDashboard.publishingApprovalsModalTitle': '게시 승인',
  'pages.welcomeDashboard.approvalTag.template': '템플릿',
  'pages.welcomeDashboard.approvalTag.review': '검토',
  'pages.welcomeDashboard.approvalTag.sideBySide': '나란히 보기',
  'pages.welcomeDashboard.approvalTag.prompt': '프롬프트',
  'pages.welcomeDashboard.approvalTag.multiStep': '다단계',
  'pages.welcomeDashboard.recentSessionsModalTitle': '{pageName} — 최근 세션',
  'pages.welcomeDashboard.detail.publishTarget': '게시 대상',
  'pages.welcomeDashboard.detail.author': '작성자',
  'pages.welcomeDashboard.detail.unknown': '알 수 없음',
  'pages.welcomeDashboard.detail.category': '카테고리',
  'pages.welcomeDashboard.detail.purpose': '목적',
  'pages.welcomeDashboard.detail.notes': '메모',
  'pages.welcomeDashboard.systemPromptLabel': '시스템 프롬프트',
  'pages.welcomeDashboard.noSystemPromptProvided': '제공된 시스템 프롬프트가 없습니다',
  'pages.welcomeDashboard.promptContentLabel': '프롬프트 내용',
  'pages.welcomeDashboard.noPromptContentAvailable': '사용 가능한 프롬프트 내용이 없습니다',
  'pages.welcomeDashboard.multiStepConfigFallback': '다단계 구성',
  'pages.welcomeDashboard.detail.description': '설명',
  'pages.welcomeDashboard.stepsLabel': '단계',
  'pages.welcomeDashboard.stepFallback': '{number}단계',
  'pages.welcomeDashboard.templateFallback': '템플릿',
  'pages.welcomeDashboard.detail.target': '대상',
  'pages.welcomeDashboard.miscFallback': '기타',
  'pages.welcomeDashboard.detail.type': '유형',
  'pages.welcomeDashboard.templateType.prose': '산문형',
  'pages.welcomeDashboard.templateType.table': '표 형식',
  'pages.welcomeDashboard.tableTypeLabel': '표 유형',
  'pages.welcomeDashboard.tableType.standard': '표준',
  'pages.welcomeDashboard.tableType.documentByDocument': '문서별',
  'pages.welcomeDashboard.tableType.clauseByClause': '조항별',
  'pages.welcomeDashboard.columnsLabel': '열',
  'pages.welcomeDashboard.sectionsLabel': '섹션',
  'pages.welcomeDashboard.userDefinedTag': '사용자 정의',
  'pages.welcomeDashboard.noTemplateStructureAvailable': '사용 가능한 템플릿 구조가 없습니다',
  'pages.welcomeDashboard.questionListFallback': '질문 목록',
  'pages.welcomeDashboard.noQuestionsAvailable': '사용 가능한 질문이 없습니다',
};
